/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
(function(n, r) {
    "use strict";
    typeof module == "object" && typeof module.exports == "object" ? module.exports = n.document ? r(n, !0) : function(s) {
        if (!s.document)
            throw new Error("jQuery requires a window with a document");
        return r(s)
    }
    : r(n)
}
)(typeof window != "undefined" ? window : this, function(n, r) {
    "use strict";
    var s = []
      , f = n.document
      , l = Object.getPrototypeOf
      , h = s.slice
      , d = s.concat
      , m = s.push
      , w = s.indexOf
      , _ = {}
      , k = _.toString
      , A = _.hasOwnProperty
      , x = A.toString
      , E = x.call(Object)
      , j = {}
      , L = function(o) {
        return typeof o == "function" && typeof o.nodeType != "number"
    }
      , C = function(o) {
        return o != null && o === o.window
    }
      , O = {
        type: !0,
        src: !0,
        noModule: !0
    };
    function M(t, o, a) {
        var c, p = (o = o || f).createElement("script");
        if (p.text = t,
        a)
            for (c in O)
                a[c] && (p[c] = a[c]);
        o.head.appendChild(p).parentNode.removeChild(p)
    }
    function U(t) {
        return t == null ? t + "" : typeof t == "object" || typeof t == "function" ? _[k.call(t)] || "object" : typeof t
    }
    var G = "3.3.1"
      , u = function(t, o) {
        return new u.fn.init(t,o)
    }
      , ce = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    u.fn = u.prototype = {
        jquery: "3.3.1",
        constructor: u,
        length: 0,
        toArray: function() {
            return h.call(this)
        },
        get: function(t) {
            return t == null ? h.call(this) : t < 0 ? this[t + this.length] : this[t]
        },
        pushStack: function(t) {
            var o = u.merge(this.constructor(), t);
            return o.prevObject = this,
            o
        },
        each: function(t) {
            return u.each(this, t)
        },
        map: function(t) {
            return this.pushStack(u.map(this, function(o, a) {
                return t.call(o, a, o)
            }))
        },
        slice: function() {
            return this.pushStack(h.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(t) {
            var o = this.length
              , a = +t + (t < 0 ? o : 0);
            return this.pushStack(a >= 0 && a < o ? [this[a]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: m,
        sort: s.sort,
        splice: s.splice
    },
    u.extend = u.fn.extend = function() {
        var t, o, a, c, p, g, v = arguments[0] || {}, S = 1, T = arguments.length, I = !1;
        for (typeof v == "boolean" && (I = v,
        v = arguments[S] || {},
        S++),
        typeof v == "object" || L(v) || (v = {}),
        S === T && (v = this,
        S--); S < T; S++)
            if ((t = arguments[S]) != null)
                for (o in t)
                    a = v[o],
                    v !== (c = t[o]) && (I && c && (u.isPlainObject(c) || (p = Array.isArray(c))) ? (p ? (p = !1,
                    g = a && Array.isArray(a) ? a : []) : g = a && u.isPlainObject(a) ? a : {},
                    v[o] = u.extend(I, g, c)) : c !== void 0 && (v[o] = c));
        return v
    }
    ,
    u.extend({
        expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(t) {
            throw new Error(t)
        },
        noop: function() {},
        isPlainObject: function(t) {
            var o, a;
            return !(!t || k.call(t) !== "[object Object]") && (!(o = l(t)) || typeof (a = A.call(o, "constructor") && o.constructor) == "function" && x.call(a) === E)
        },
        isEmptyObject: function(t) {
            var o;
            for (o in t)
                return !1;
            return !0
        },
        globalEval: function(t) {
            M(t)
        },
        each: function(t, o) {
            var a, c = 0;
            if (ve(t))
                for (a = t.length; c < a && o.call(t[c], c, t[c]) !== !1; c++)
                    ;
            else
                for (c in t)
                    if (o.call(t[c], c, t[c]) === !1)
                        break;
            return t
        },
        trim: function(t) {
            return t == null ? "" : (t + "").replace(ce, "")
        },
        makeArray: function(t, o) {
            var a = o || [];
            return t != null && (ve(Object(t)) ? u.merge(a, typeof t == "string" ? [t] : t) : m.call(a, t)),
            a
        },
        inArray: function(t, o, a) {
            return o == null ? -1 : w.call(o, t, a)
        },
        merge: function(t, o) {
            for (var a = +o.length, c = 0, p = t.length; c < a; c++)
                t[p++] = o[c];
            return t.length = p,
            t
        },
        grep: function(t, o, a) {
            for (var c, p = [], g = 0, v = t.length, S = !a; g < v; g++)
                (c = !o(t[g], g)) !== S && p.push(t[g]);
            return p
        },
        map: function(t, o, a) {
            var c, p, g = 0, v = [];
            if (ve(t))
                for (c = t.length; g < c; g++)
                    (p = o(t[g], g, a)) != null && v.push(p);
            else
                for (g in t)
                    (p = o(t[g], g, a)) != null && v.push(p);
            return d.apply([], v)
        },
        guid: 1,
        support: j
    }),
    typeof Symbol == "function" && (u.fn[Symbol.iterator] = s[Symbol.iterator]),
    u.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, o) {
        _["[object " + o + "]"] = o.toLowerCase()
    });
    function ve(t) {
        var o = !!t && "length"in t && t.length
          , a = U(t);
        return !L(t) && !C(t) && (a === "array" || o === 0 || typeof o == "number" && o > 0 && o - 1 in t)
    }
    var H = function(t) {
        var o, a, c, p, g, v, S, T, I, F, V, N, q, K, ae, te, we, be, Ae, ue = "sizzle" + 1 * new Date, re = t.document, Ee = 0, de = 0, ye = Vt(), dt = Vt(), it = Vt(), Oe = function(y, b) {
            return y === b && (V = !0),
            0
        }, ut = {}.hasOwnProperty, Pe = [], Ue = Pe.pop, nt = Pe.push, xe = Pe.push, Li = Pe.slice, Qe = function(y, b) {
            for (var D = 0, z = y.length; D < z; D++)
                if (y[D] === b)
                    return D;
            return -1
        }, Wt = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", fe = "[\\x20\\t\\r\\n\\f]", Xe = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+", Ni = "\\[" + fe + "*(" + Xe + ")(?:" + fe + "*([*^$|!~]?=)" + fe + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + Xe + "))|)" + fe + "*\\]", Rt = ":(" + Xe + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + Ni + ")*)|.*)\\)|)", On = new RegExp(fe + "+","g"), Ct = new RegExp("^" + fe + "+|((?:^|[^\\\\])(?:\\\\.)*)" + fe + "+$","g"), zn = new RegExp("^" + fe + "*," + fe + "*"), qn = new RegExp("^" + fe + "*([>+~]|" + fe + ")" + fe + "*"), Fn = new RegExp("=" + fe + "*([^\\]'\"]*?)" + fe + "*\\]","g"), Mn = new RegExp(Rt), Hn = new RegExp("^" + Xe + "$"), _t = {
            ID: new RegExp("^#(" + Xe + ")"),
            CLASS: new RegExp("^\\.(" + Xe + ")"),
            TAG: new RegExp("^(" + Xe + "|[*])"),
            ATTR: new RegExp("^" + Ni),
            PSEUDO: new RegExp("^" + Rt),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + fe + "*(even|odd|(([+-]|)(\\d*)n|)" + fe + "*(?:([+-]|)" + fe + "*(\\d+)|))" + fe + "*\\)|)","i"),
            bool: new RegExp("^(?:" + Wt + ")$","i"),
            needsContext: new RegExp("^" + fe + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + fe + "*((?:-\\d)?\\d*)" + fe + "*\\)|)(?=[^-]|$)","i")
        }, Bn = /^(?:input|select|textarea|button)$/i, Wn = /^h\d$/i, ft = /^[^{]+\{\s*\[native \w/, Rn = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Ut = /[+~]/, We = new RegExp("\\\\([\\da-f]{1,6}" + fe + "?|(" + fe + ")|.)","ig"), Re = function(y, b, D) {
            var z = "0x" + b - 65536;
            return z !== z || D ? b : z < 0 ? String.fromCharCode(z + 65536) : String.fromCharCode(z >> 10 | 55296, 1023 & z | 56320)
        }, Oi = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, zi = function(y, b) {
            return b ? y === "\0" ? "\uFFFD" : y.slice(0, -1) + "\\" + y.charCodeAt(y.length - 1).toString(16) + " " : "\\" + y
        }, qi = function() {
            N()
        }, Un = Tt(function(y) {
            return y.disabled === !0 && ("form"in y || "label"in y)
        }, {
            dir: "parentNode",
            next: "legend"
        });
        try {
            xe.apply(Pe = Li.call(re.childNodes), re.childNodes),
            Pe[re.childNodes.length].nodeType
        } catch (y) {
            xe = {
                apply: Pe.length ? function(b, D) {
                    nt.apply(b, Li.call(D))
                }
                : function(b, D) {
                    for (var z = b.length, P = 0; b[z++] = D[P++]; )
                        ;
                    b.length = z - 1
                }
            }
        }
        function he(y, b, D, z) {
            var P, B, R, Q, J, ie, ee, oe = b && b.ownerDocument, le = b ? b.nodeType : 9;
            if (D = D || [],
            typeof y != "string" || !y || le !== 1 && le !== 9 && le !== 11)
                return D;
            if (!z && ((b ? b.ownerDocument || b : re) !== q && N(b),
            b = b || q,
            ae)) {
                if (le !== 11 && (J = Rn.exec(y)))
                    if (P = J[1]) {
                        if (le === 9) {
                            if (!(R = b.getElementById(P)))
                                return D;
                            if (R.id === P)
                                return D.push(R),
                                D
                        } else if (oe && (R = oe.getElementById(P)) && Ae(b, R) && R.id === P)
                            return D.push(R),
                            D
                    } else {
                        if (J[2])
                            return xe.apply(D, b.getElementsByTagName(y)),
                            D;
                        if ((P = J[3]) && a.getElementsByClassName && b.getElementsByClassName)
                            return xe.apply(D, b.getElementsByClassName(P)),
                            D
                    }
                if (a.qsa && !it[y + " "] && (!te || !te.test(y))) {
                    if (le !== 1)
                        oe = b,
                        ee = y;
                    else if (b.nodeName.toLowerCase() !== "object") {
                        for ((Q = b.getAttribute("id")) ? Q = Q.replace(Oi, zi) : b.setAttribute("id", Q = ue),
                        B = (ie = v(y)).length; B--; )
                            ie[B] = "#" + Q + " " + kt(ie[B]);
                        ee = ie.join(","),
                        oe = Ut.test(y) && Qt(b.parentNode) || b
                    }
                    if (ee)
                        try {
                            return xe.apply(D, oe.querySelectorAll(ee)),
                            D
                        } catch (me) {} finally {
                            Q === ue && b.removeAttribute("id")
                        }
                }
            }
            return T(y.replace(Ct, "$1"), b, D, z)
        }
        function Vt() {
            var y = [];
            function b(D, z) {
                return y.push(D + " ") > c.cacheLength && delete b[y.shift()],
                b[D + " "] = z
            }
            return b
        }
        function ze(y) {
            return y[ue] = !0,
            y
        }
        function Me(y) {
            var b = q.createElement("fieldset");
            try {
                return !!y(b)
            } catch (D) {
                return !1
            } finally {
                b.parentNode && b.parentNode.removeChild(b),
                b = null
            }
        }
        function Gt(y, b) {
            for (var D = y.split("|"), z = D.length; z--; )
                c.attrHandle[D[z]] = b
        }
        function Fi(y, b) {
            var D = b && y
              , z = D && y.nodeType === 1 && b.nodeType === 1 && y.sourceIndex - b.sourceIndex;
            if (z)
                return z;
            if (D) {
                for (; D = D.nextSibling; )
                    if (D === b)
                        return -1
            }
            return y ? 1 : -1
        }
        function Vn(y) {
            return function(b) {
                return b.nodeName.toLowerCase() === "input" && b.type === y
            }
        }
        function Gn(y) {
            return function(b) {
                var D = b.nodeName.toLowerCase();
                return (D === "input" || D === "button") && b.type === y
            }
        }
        function Mi(y) {
            return function(b) {
                return "form"in b ? b.parentNode && b.disabled === !1 ? "label"in b ? "label"in b.parentNode ? b.parentNode.disabled === y : b.disabled === y : b.isDisabled === y || b.isDisabled !== !y && Un(b) === y : b.disabled === y : "label"in b && b.disabled === y
            }
        }
        function Je(y) {
            return ze(function(b) {
                return b = +b,
                ze(function(D, z) {
                    for (var P, B = y([], D.length, b), R = B.length; R--; )
                        D[P = B[R]] && (D[P] = !(z[P] = D[P]))
                })
            })
        }
        function Qt(y) {
            return y && typeof y.getElementsByTagName != "undefined" && y
        }
        a = he.support = {},
        g = he.isXML = function(y) {
            var b = y && (y.ownerDocument || y).documentElement;
            return !!b && b.nodeName !== "HTML"
        }
        ,
        N = he.setDocument = function(y) {
            var b, D, z = y ? y.ownerDocument || y : re;
            return z !== q && z.nodeType === 9 && z.documentElement && (q = z,
            K = q.documentElement,
            ae = !g(q),
            re !== q && (D = q.defaultView) && D.top !== D && (D.addEventListener ? D.addEventListener("unload", qi, !1) : D.attachEvent && D.attachEvent("onunload", qi)),
            a.attributes = Me(function(P) {
                return P.className = "i",
                !P.getAttribute("className")
            }),
            a.getElementsByTagName = Me(function(P) {
                return P.appendChild(q.createComment("")),
                !P.getElementsByTagName("*").length
            }),
            a.getElementsByClassName = ft.test(q.getElementsByClassName),
            a.getById = Me(function(P) {
                return K.appendChild(P).id = ue,
                !q.getElementsByName || !q.getElementsByName(ue).length
            }),
            a.getById ? (c.filter.ID = function(P) {
                var B = P.replace(We, Re);
                return function(R) {
                    return R.getAttribute("id") === B
                }
            }
            ,
            c.find.ID = function(P, B) {
                if (typeof B.getElementById != "undefined" && ae) {
                    var R = B.getElementById(P);
                    return R ? [R] : []
                }
            }
            ) : (c.filter.ID = function(P) {
                var B = P.replace(We, Re);
                return function(R) {
                    var Q = typeof R.getAttributeNode != "undefined" && R.getAttributeNode("id");
                    return Q && Q.value === B
                }
            }
            ,
            c.find.ID = function(P, B) {
                if (typeof B.getElementById != "undefined" && ae) {
                    var R, Q, J, ie = B.getElementById(P);
                    if (ie) {
                        if ((R = ie.getAttributeNode("id")) && R.value === P)
                            return [ie];
                        for (J = B.getElementsByName(P),
                        Q = 0; ie = J[Q++]; )
                            if ((R = ie.getAttributeNode("id")) && R.value === P)
                                return [ie]
                    }
                    return []
                }
            }
            ),
            c.find.TAG = a.getElementsByTagName ? function(P, B) {
                return typeof B.getElementsByTagName != "undefined" ? B.getElementsByTagName(P) : a.qsa ? B.querySelectorAll(P) : void 0
            }
            : function(P, B) {
                var R, Q = [], J = 0, ie = B.getElementsByTagName(P);
                if (P === "*") {
                    for (; R = ie[J++]; )
                        R.nodeType === 1 && Q.push(R);
                    return Q
                }
                return ie
            }
            ,
            c.find.CLASS = a.getElementsByClassName && function(P, B) {
                if (typeof B.getElementsByClassName != "undefined" && ae)
                    return B.getElementsByClassName(P)
            }
            ,
            we = [],
            te = [],
            (a.qsa = ft.test(q.querySelectorAll)) && (Me(function(P) {
                K.appendChild(P).innerHTML = "<a id='" + ue + "'></a><select id='" + ue + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                P.querySelectorAll("[msallowcapture^='']").length && te.push("[*^$]=" + fe + "*(?:''|\"\")"),
                P.querySelectorAll("[selected]").length || te.push("\\[" + fe + "*(?:value|" + Wt + ")"),
                P.querySelectorAll("[id~=" + ue + "-]").length || te.push("~="),
                P.querySelectorAll(":checked").length || te.push(":checked"),
                P.querySelectorAll("a#" + ue + "+*").length || te.push(".#.+[+~]")
            }),
            Me(function(P) {
                P.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var B = q.createElement("input");
                B.setAttribute("type", "hidden"),
                P.appendChild(B).setAttribute("name", "D"),
                P.querySelectorAll("[name=d]").length && te.push("name" + fe + "*[*^$|!~]?="),
                P.querySelectorAll(":enabled").length !== 2 && te.push(":enabled", ":disabled"),
                K.appendChild(P).disabled = !0,
                P.querySelectorAll(":disabled").length !== 2 && te.push(":enabled", ":disabled"),
                P.querySelectorAll("*,:x"),
                te.push(",.*:")
            })),
            (a.matchesSelector = ft.test(be = K.matches || K.webkitMatchesSelector || K.mozMatchesSelector || K.oMatchesSelector || K.msMatchesSelector)) && Me(function(P) {
                a.disconnectedMatch = be.call(P, "*"),
                be.call(P, "[s!='']:x"),
                we.push("!=", Rt)
            }),
            te = te.length && new RegExp(te.join("|")),
            we = we.length && new RegExp(we.join("|")),
            b = ft.test(K.compareDocumentPosition),
            Ae = b || ft.test(K.contains) ? function(P, B) {
                var R = P.nodeType === 9 ? P.documentElement : P
                  , Q = B && B.parentNode;
                return P === Q || !(!Q || Q.nodeType !== 1 || !(R.contains ? R.contains(Q) : P.compareDocumentPosition && 16 & P.compareDocumentPosition(Q)))
            }
            : function(P, B) {
                if (B) {
                    for (; B = B.parentNode; )
                        if (B === P)
                            return !0
                }
                return !1
            }
            ,
            Oe = b ? function(P, B) {
                if (P === B)
                    return V = !0,
                    0;
                var R = !P.compareDocumentPosition - !B.compareDocumentPosition;
                return R || (1 & (R = (P.ownerDocument || P) === (B.ownerDocument || B) ? P.compareDocumentPosition(B) : 1) || !a.sortDetached && B.compareDocumentPosition(P) === R ? P === q || P.ownerDocument === re && Ae(re, P) ? -1 : B === q || B.ownerDocument === re && Ae(re, B) ? 1 : F ? Qe(F, P) - Qe(F, B) : 0 : 4 & R ? -1 : 1)
            }
            : function(P, B) {
                if (P === B)
                    return V = !0,
                    0;
                var R, Q = 0, J = P.parentNode, ie = B.parentNode, ee = [P], oe = [B];
                if (!J || !ie)
                    return P === q ? -1 : B === q ? 1 : J ? -1 : ie ? 1 : F ? Qe(F, P) - Qe(F, B) : 0;
                if (J === ie)
                    return Fi(P, B);
                for (R = P; R = R.parentNode; )
                    ee.unshift(R);
                for (R = B; R = R.parentNode; )
                    oe.unshift(R);
                for (; ee[Q] === oe[Q]; )
                    Q++;
                return Q ? Fi(ee[Q], oe[Q]) : ee[Q] === re ? -1 : oe[Q] === re ? 1 : 0
            }
            ),
            q
        }
        ,
        he.matches = function(y, b) {
            return he(y, null, null, b)
        }
        ,
        he.matchesSelector = function(y, b) {
            if ((y.ownerDocument || y) !== q && N(y),
            b = b.replace(Fn, "='$1']"),
            a.matchesSelector && ae && !it[b + " "] && (!we || !we.test(b)) && (!te || !te.test(b)))
                try {
                    var D = be.call(y, b);
                    if (D || a.disconnectedMatch || y.document && y.document.nodeType !== 11)
                        return D
                } catch (z) {}
            return he(b, q, null, [y]).length > 0
        }
        ,
        he.contains = function(y, b) {
            return (y.ownerDocument || y) !== q && N(y),
            Ae(y, b)
        }
        ,
        he.attr = function(y, b) {
            (y.ownerDocument || y) !== q && N(y);
            var D = c.attrHandle[b.toLowerCase()]
              , z = D && ut.call(c.attrHandle, b.toLowerCase()) ? D(y, b, !ae) : void 0;
            return z !== void 0 ? z : a.attributes || !ae ? y.getAttribute(b) : (z = y.getAttributeNode(b)) && z.specified ? z.value : null
        }
        ,
        he.escape = function(y) {
            return (y + "").replace(Oi, zi)
        }
        ,
        he.error = function(y) {
            throw new Error("Syntax error, unrecognized expression: " + y)
        }
        ,
        he.uniqueSort = function(y) {
            var b, D = [], z = 0, P = 0;
            if (V = !a.detectDuplicates,
            F = !a.sortStable && y.slice(0),
            y.sort(Oe),
            V) {
                for (; b = y[P++]; )
                    b === y[P] && (z = D.push(P));
                for (; z--; )
                    y.splice(D[z], 1)
            }
            return F = null,
            y
        }
        ,
        p = he.getText = function(y) {
            var b, D = "", z = 0, P = y.nodeType;
            if (P) {
                if (P === 1 || P === 9 || P === 11) {
                    if (typeof y.textContent == "string")
                        return y.textContent;
                    for (y = y.firstChild; y; y = y.nextSibling)
                        D += p(y)
                } else if (P === 3 || P === 4)
                    return y.nodeValue
            } else
                for (; b = y[z++]; )
                    D += p(b);
            return D
        }
        ,
        (c = he.selectors = {
            cacheLength: 50,
            createPseudo: ze,
            match: _t,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(y) {
                    return y[1] = y[1].replace(We, Re),
                    y[3] = (y[3] || y[4] || y[5] || "").replace(We, Re),
                    y[2] === "~=" && (y[3] = " " + y[3] + " "),
                    y.slice(0, 4)
                },
                CHILD: function(y) {
                    return y[1] = y[1].toLowerCase(),
                    y[1].slice(0, 3) === "nth" ? (y[3] || he.error(y[0]),
                    y[4] = +(y[4] ? y[5] + (y[6] || 1) : 2 * (y[3] === "even" || y[3] === "odd")),
                    y[5] = +(y[7] + y[8] || y[3] === "odd")) : y[3] && he.error(y[0]),
                    y
                },
                PSEUDO: function(y) {
                    var b, D = !y[6] && y[2];
                    return _t.CHILD.test(y[0]) ? null : (y[3] ? y[2] = y[4] || y[5] || "" : D && Mn.test(D) && (b = v(D, !0)) && (b = D.indexOf(")", D.length - b) - D.length) && (y[0] = y[0].slice(0, b),
                    y[2] = D.slice(0, b)),
                    y.slice(0, 3))
                }
            },
            filter: {
                TAG: function(y) {
                    var b = y.replace(We, Re).toLowerCase();
                    return y === "*" ? function() {
                        return !0
                    }
                    : function(D) {
                        return D.nodeName && D.nodeName.toLowerCase() === b
                    }
                },
                CLASS: function(y) {
                    var b = ye[y + " "];
                    return b || (b = new RegExp("(^|" + fe + ")" + y + "(" + fe + "|$)")) && ye(y, function(D) {
                        return b.test(typeof D.className == "string" && D.className || typeof D.getAttribute != "undefined" && D.getAttribute("class") || "")
                    })
                },
                ATTR: function(y, b, D) {
                    return function(z) {
                        var P = he.attr(z, y);
                        return P == null ? b === "!=" : !b || (P += "",
                        b === "=" ? P === D : b === "!=" ? P !== D : b === "^=" ? D && P.indexOf(D) === 0 : b === "*=" ? D && P.indexOf(D) > -1 : b === "$=" ? D && P.slice(-D.length) === D : b === "~=" ? (" " + P.replace(On, " ") + " ").indexOf(D) > -1 : b === "|=" && (P === D || P.slice(0, D.length + 1) === D + "-"))
                    }
                },
                CHILD: function(y, b, D, z, P) {
                    var B = y.slice(0, 3) !== "nth"
                      , R = y.slice(-4) !== "last"
                      , Q = b === "of-type";
                    return z === 1 && P === 0 ? function(J) {
                        return !!J.parentNode
                    }
                    : function(J, ie, ee) {
                        var oe, le, me, ne, $e, Se, De = B !== R ? "nextSibling" : "previousSibling", ge = J.parentNode, ht = Q && J.nodeName.toLowerCase(), pt = !ee && !Q, Ie = !1;
                        if (ge) {
                            if (B) {
                                for (; De; ) {
                                    for (ne = J; ne = ne[De]; )
                                        if (Q ? ne.nodeName.toLowerCase() === ht : ne.nodeType === 1)
                                            return !1;
                                    Se = De = y === "only" && !Se && "nextSibling"
                                }
                                return !0
                            }
                            if (Se = [R ? ge.firstChild : ge.lastChild],
                            R && pt) {
                                for (Ie = ($e = (oe = (le = (me = (ne = ge)[ue] || (ne[ue] = {}))[ne.uniqueID] || (me[ne.uniqueID] = {}))[y] || [])[0] === Ee && oe[1]) && oe[2],
                                ne = $e && ge.childNodes[$e]; ne = ++$e && ne && ne[De] || (Ie = $e = 0) || Se.pop(); )
                                    if (ne.nodeType === 1 && ++Ie && ne === J) {
                                        le[y] = [Ee, $e, Ie];
                                        break
                                    }
                            } else if (pt && (Ie = $e = (oe = (le = (me = (ne = J)[ue] || (ne[ue] = {}))[ne.uniqueID] || (me[ne.uniqueID] = {}))[y] || [])[0] === Ee && oe[1]),
                            Ie === !1)
                                for (; (ne = ++$e && ne && ne[De] || (Ie = $e = 0) || Se.pop()) && !((Q ? ne.nodeName.toLowerCase() === ht : ne.nodeType === 1) && ++Ie && (pt && ((le = (me = ne[ue] || (ne[ue] = {}))[ne.uniqueID] || (me[ne.uniqueID] = {}))[y] = [Ee, Ie]),
                                ne === J)); )
                                    ;
                            return (Ie -= P) === z || Ie % z == 0 && Ie / z >= 0
                        }
                    }
                },
                PSEUDO: function(y, b) {
                    var D, z = c.pseudos[y] || c.setFilters[y.toLowerCase()] || he.error("unsupported pseudo: " + y);
                    return z[ue] ? z(b) : z.length > 1 ? (D = [y, y, "", b],
                    c.setFilters.hasOwnProperty(y.toLowerCase()) ? ze(function(P, B) {
                        for (var R, Q = z(P, b), J = Q.length; J--; )
                            P[R = Qe(P, Q[J])] = !(B[R] = Q[J])
                    }) : function(P) {
                        return z(P, 0, D)
                    }
                    ) : z
                }
            },
            pseudos: {
                not: ze(function(y) {
                    var b = []
                      , D = []
                      , z = S(y.replace(Ct, "$1"));
                    return z[ue] ? ze(function(P, B, R, Q) {
                        for (var J, ie = z(P, null, Q, []), ee = P.length; ee--; )
                            (J = ie[ee]) && (P[ee] = !(B[ee] = J))
                    }) : function(P, B, R) {
                        return b[0] = P,
                        z(b, null, R, D),
                        b[0] = null,
                        !D.pop()
                    }
                }),
                has: ze(function(y) {
                    return function(b) {
                        return he(y, b).length > 0
                    }
                }),
                contains: ze(function(y) {
                    return y = y.replace(We, Re),
                    function(b) {
                        return (b.textContent || b.innerText || p(b)).indexOf(y) > -1
                    }
                }),
                lang: ze(function(y) {
                    return Hn.test(y || "") || he.error("unsupported lang: " + y),
                    y = y.replace(We, Re).toLowerCase(),
                    function(b) {
                        var D;
                        do
                            if (D = ae ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang"))
                                return (D = D.toLowerCase()) === y || D.indexOf(y + "-") === 0;
                        while ((b = b.parentNode) && b.nodeType === 1);
                        return !1
                    }
                }),
                target: function(y) {
                    var b = t.location && t.location.hash;
                    return b && b.slice(1) === y.id
                },
                root: function(y) {
                    return y === K
                },
                focus: function(y) {
                    return y === q.activeElement && (!q.hasFocus || q.hasFocus()) && !!(y.type || y.href || ~y.tabIndex)
                },
                enabled: Mi(!1),
                disabled: Mi(!0),
                checked: function(y) {
                    var b = y.nodeName.toLowerCase();
                    return b === "input" && !!y.checked || b === "option" && !!y.selected
                },
                selected: function(y) {
                    return y.parentNode && y.parentNode.selectedIndex,
                    y.selected === !0
                },
                empty: function(y) {
                    for (y = y.firstChild; y; y = y.nextSibling)
                        if (y.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(y) {
                    return !c.pseudos.empty(y)
                },
                header: function(y) {
                    return Wn.test(y.nodeName)
                },
                input: function(y) {
                    return Bn.test(y.nodeName)
                },
                button: function(y) {
                    var b = y.nodeName.toLowerCase();
                    return b === "input" && y.type === "button" || b === "button"
                },
                text: function(y) {
                    var b;
                    return y.nodeName.toLowerCase() === "input" && y.type === "text" && ((b = y.getAttribute("type")) == null || b.toLowerCase() === "text")
                },
                first: Je(function() {
                    return [0]
                }),
                last: Je(function(y, b) {
                    return [b - 1]
                }),
                eq: Je(function(y, b, D) {
                    return [D < 0 ? D + b : D]
                }),
                even: Je(function(y, b) {
                    for (var D = 0; D < b; D += 2)
                        y.push(D);
                    return y
                }),
                odd: Je(function(y, b) {
                    for (var D = 1; D < b; D += 2)
                        y.push(D);
                    return y
                }),
                lt: Je(function(y, b, D) {
                    for (var z = D < 0 ? D + b : D; --z >= 0; )
                        y.push(z);
                    return y
                }),
                gt: Je(function(y, b, D) {
                    for (var z = D < 0 ? D + b : D; ++z < b; )
                        y.push(z);
                    return y
                })
            }
        }).pseudos.nth = c.pseudos.eq;
        for (o in {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            c.pseudos[o] = Vn(o);
        for (o in {
            submit: !0,
            reset: !0
        })
            c.pseudos[o] = Gn(o);
        function Hi() {}
        Hi.prototype = c.filters = c.pseudos,
        c.setFilters = new Hi,
        v = he.tokenize = function(y, b) {
            var D, z, P, B, R, Q, J, ie = dt[y + " "];
            if (ie)
                return b ? 0 : ie.slice(0);
            for (R = y,
            Q = [],
            J = c.preFilter; R; ) {
                D && !(z = zn.exec(R)) || (z && (R = R.slice(z[0].length) || R),
                Q.push(P = [])),
                D = !1,
                (z = qn.exec(R)) && (D = z.shift(),
                P.push({
                    value: D,
                    type: z[0].replace(Ct, " ")
                }),
                R = R.slice(D.length));
                for (B in c.filter)
                    !(z = _t[B].exec(R)) || J[B] && !(z = J[B](z)) || (D = z.shift(),
                    P.push({
                        value: D,
                        type: B,
                        matches: z
                    }),
                    R = R.slice(D.length));
                if (!D)
                    break
            }
            return b ? R.length : R ? he.error(y) : dt(y, Q).slice(0)
        }
        ;
        function kt(y) {
            for (var b = 0, D = y.length, z = ""; b < D; b++)
                z += y[b].value;
            return z
        }
        function Tt(y, b, D) {
            var z = b.dir
              , P = b.next
              , B = P || z
              , R = D && B === "parentNode"
              , Q = de++;
            return b.first ? function(J, ie, ee) {
                for (; J = J[z]; )
                    if (J.nodeType === 1 || R)
                        return y(J, ie, ee);
                return !1
            }
            : function(J, ie, ee) {
                var oe, le, me, ne = [Ee, Q];
                if (ee) {
                    for (; J = J[z]; )
                        if ((J.nodeType === 1 || R) && y(J, ie, ee))
                            return !0
                } else
                    for (; J = J[z]; )
                        if (J.nodeType === 1 || R)
                            if (me = J[ue] || (J[ue] = {}),
                            le = me[J.uniqueID] || (me[J.uniqueID] = {}),
                            P && P === J.nodeName.toLowerCase())
                                J = J[z] || J;
                            else {
                                if ((oe = le[B]) && oe[0] === Ee && oe[1] === Q)
                                    return ne[2] = oe[2];
                                if (le[B] = ne,
                                ne[2] = y(J, ie, ee))
                                    return !0
                            }
                return !1
            }
        }
        function Xt(y) {
            return y.length > 1 ? function(b, D, z) {
                for (var P = y.length; P--; )
                    if (!y[P](b, D, z))
                        return !1;
                return !0
            }
            : y[0]
        }
        function Qn(y, b, D) {
            for (var z = 0, P = b.length; z < P; z++)
                he(y, b[z], D);
            return D
        }
        function Et(y, b, D, z, P) {
            for (var B, R = [], Q = 0, J = y.length, ie = b != null; Q < J; Q++)
                (B = y[Q]) && (D && !D(B, z, P) || (R.push(B),
                ie && b.push(Q)));
            return R
        }
        function Jt(y, b, D, z, P, B) {
            return z && !z[ue] && (z = Jt(z)),
            P && !P[ue] && (P = Jt(P, B)),
            ze(function(R, Q, J, ie) {
                var ee, oe, le, me = [], ne = [], $e = Q.length, Se = R || Qn(b || "*", J.nodeType ? [J] : J, []), De = !y || !R && b ? Se : Et(Se, me, y, J, ie), ge = D ? P || (R ? y : $e || z) ? [] : Q : De;
                if (D && D(De, ge, J, ie),
                z)
                    for (ee = Et(ge, ne),
                    z(ee, [], J, ie),
                    oe = ee.length; oe--; )
                        (le = ee[oe]) && (ge[ne[oe]] = !(De[ne[oe]] = le));
                if (R) {
                    if (P || y) {
                        if (P) {
                            for (ee = [],
                            oe = ge.length; oe--; )
                                (le = ge[oe]) && ee.push(De[oe] = le);
                            P(null, ge = [], ee, ie)
                        }
                        for (oe = ge.length; oe--; )
                            (le = ge[oe]) && (ee = P ? Qe(R, le) : me[oe]) > -1 && (R[ee] = !(Q[ee] = le))
                    }
                } else
                    ge = Et(ge === Q ? ge.splice($e, ge.length) : ge),
                    P ? P(null, Q, ge, ie) : xe.apply(Q, ge)
            })
        }
        function Yt(y) {
            for (var b, D, z, P = y.length, B = c.relative[y[0].type], R = B || c.relative[" "], Q = B ? 1 : 0, J = Tt(function(oe) {
                return oe === b
            }, R, !0), ie = Tt(function(oe) {
                return Qe(b, oe) > -1
            }, R, !0), ee = [function(oe, le, me) {
                var ne = !B && (me || le !== I) || ((b = le).nodeType ? J(oe, le, me) : ie(oe, le, me));
                return b = null,
                ne
            }
            ]; Q < P; Q++)
                if (D = c.relative[y[Q].type])
                    ee = [Tt(Xt(ee), D)];
                else {
                    if ((D = c.filter[y[Q].type].apply(null, y[Q].matches))[ue]) {
                        for (z = ++Q; z < P && !c.relative[y[z].type]; z++)
                            ;
                        return Jt(Q > 1 && Xt(ee), Q > 1 && kt(y.slice(0, Q - 1).concat({
                            value: y[Q - 2].type === " " ? "*" : ""
                        })).replace(Ct, "$1"), D, Q < z && Yt(y.slice(Q, z)), z < P && Yt(y = y.slice(z)), z < P && kt(y))
                    }
                    ee.push(D)
                }
            return Xt(ee)
        }
        function Xn(y, b) {
            var D = b.length > 0
              , z = y.length > 0
              , P = function(B, R, Q, J, ie) {
                var ee, oe, le, me = 0, ne = "0", $e = B && [], Se = [], De = I, ge = B || z && c.find.TAG("*", ie), ht = Ee += De == null ? 1 : Math.random() || .1, pt = ge.length;
                for (ie && (I = R === q || R || ie); ne !== pt && (ee = ge[ne]) != null; ne++) {
                    if (z && ee) {
                        for (oe = 0,
                        R || ee.ownerDocument === q || (N(ee),
                        Q = !ae); le = y[oe++]; )
                            if (le(ee, R || q, Q)) {
                                J.push(ee);
                                break
                            }
                        ie && (Ee = ht)
                    }
                    D && ((ee = !le && ee) && me--,
                    B && $e.push(ee))
                }
                if (me += ne,
                D && ne !== me) {
                    for (oe = 0; le = b[oe++]; )
                        le($e, Se, R, Q);
                    if (B) {
                        if (me > 0)
                            for (; ne--; )
                                $e[ne] || Se[ne] || (Se[ne] = Ue.call(J));
                        Se = Et(Se)
                    }
                    xe.apply(J, Se),
                    ie && !B && Se.length > 0 && me + b.length > 1 && he.uniqueSort(J)
                }
                return ie && (Ee = ht,
                I = De),
                $e
            };
            return D ? ze(P) : P
        }
        return S = he.compile = function(y, b) {
            var D, z = [], P = [], B = it[y + " "];
            if (!B) {
                for (b || (b = v(y)),
                D = b.length; D--; )
                    (B = Yt(b[D]))[ue] ? z.push(B) : P.push(B);
                (B = it(y, Xn(P, z))).selector = y
            }
            return B
        }
        ,
        T = he.select = function(y, b, D, z) {
            var P, B, R, Q, J, ie = typeof y == "function" && y, ee = !z && v(y = ie.selector || y);
            if (D = D || [],
            ee.length === 1) {
                if ((B = ee[0] = ee[0].slice(0)).length > 2 && (R = B[0]).type === "ID" && b.nodeType === 9 && ae && c.relative[B[1].type]) {
                    if (!(b = (c.find.ID(R.matches[0].replace(We, Re), b) || [])[0]))
                        return D;
                    ie && (b = b.parentNode),
                    y = y.slice(B.shift().value.length)
                }
                for (P = _t.needsContext.test(y) ? 0 : B.length; P-- && (R = B[P],
                !c.relative[Q = R.type]); )
                    if ((J = c.find[Q]) && (z = J(R.matches[0].replace(We, Re), Ut.test(B[0].type) && Qt(b.parentNode) || b))) {
                        if (B.splice(P, 1),
                        !(y = z.length && kt(B)))
                            return xe.apply(D, z),
                            D;
                        break
                    }
            }
            return (ie || S(y, ee))(z, b, !ae, D, !b || Ut.test(y) && Qt(b.parentNode) || b),
            D
        }
        ,
        a.sortStable = ue.split("").sort(Oe).join("") === ue,
        a.detectDuplicates = !!V,
        N(),
        a.sortDetached = Me(function(y) {
            return 1 & y.compareDocumentPosition(q.createElement("fieldset"))
        }),
        Me(function(y) {
            return y.innerHTML = "<a href='#'></a>",
            y.firstChild.getAttribute("href") === "#"
        }) || Gt("type|href|height|width", function(y, b, D) {
            if (!D)
                return y.getAttribute(b, b.toLowerCase() === "type" ? 1 : 2)
        }),
        a.attributes && Me(function(y) {
            return y.innerHTML = "<input/>",
            y.firstChild.setAttribute("value", ""),
            y.firstChild.getAttribute("value") === ""
        }) || Gt("value", function(y, b, D) {
            if (!D && y.nodeName.toLowerCase() === "input")
                return y.defaultValue
        }),
        Me(function(y) {
            return y.getAttribute("disabled") == null
        }) || Gt(Wt, function(y, b, D) {
            var z;
            if (!D)
                return y[b] === !0 ? b.toLowerCase() : (z = y.getAttributeNode(b)) && z.specified ? z.value : null
        }),
        he
    }(n);
    u.find = H,
    u.expr = H.selectors,
    u.expr[":"] = u.expr.pseudos,
    u.uniqueSort = u.unique = H.uniqueSort,
    u.text = H.getText,
    u.isXMLDoc = H.isXML,
    u.contains = H.contains,
    u.escapeSelector = H.escape;
    var W = function(t, o, a) {
        for (var c = [], p = a !== void 0; (t = t[o]) && t.nodeType !== 9; )
            if (t.nodeType === 1) {
                if (p && u(t).is(a))
                    break;
                c.push(t)
            }
        return c
    }
      , Z = function(t, o) {
        for (var a = []; t; t = t.nextSibling)
            t.nodeType === 1 && t !== o && a.push(t);
        return a
    }
      , Y = u.expr.match.needsContext;
    function X(t, o) {
        return t.nodeName && t.nodeName.toLowerCase() === o.toLowerCase()
    }
    var pe = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function Ce(t, o, a) {
        return L(o) ? u.grep(t, function(c, p) {
            return !!o.call(c, p, c) !== a
        }) : o.nodeType ? u.grep(t, function(c) {
            return c === o !== a
        }) : typeof o != "string" ? u.grep(t, function(c) {
            return w.call(o, c) > -1 !== a
        }) : u.filter(o, t, a)
    }
    u.filter = function(t, o, a) {
        var c = o[0];
        return a && (t = ":not(" + t + ")"),
        o.length === 1 && c.nodeType === 1 ? u.find.matchesSelector(c, t) ? [c] : [] : u.find.matches(t, u.grep(o, function(p) {
            return p.nodeType === 1
        }))
    }
    ,
    u.fn.extend({
        find: function(t) {
            var o, a, c = this.length, p = this;
            if (typeof t != "string")
                return this.pushStack(u(t).filter(function() {
                    for (o = 0; o < c; o++)
                        if (u.contains(p[o], this))
                            return !0
                }));
            for (a = this.pushStack([]),
            o = 0; o < c; o++)
                u.find(t, p[o], a);
            return c > 1 ? u.uniqueSort(a) : a
        },
        filter: function(t) {
            return this.pushStack(Ce(this, t || [], !1))
        },
        not: function(t) {
            return this.pushStack(Ce(this, t || [], !0))
        },
        is: function(t) {
            return !!Ce(this, typeof t == "string" && Y.test(t) ? u(t) : t || [], !1).length
        }
    });
    var Le, At = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (u.fn.init = function(t, o, a) {
        var c, p;
        if (!t)
            return this;
        if (a = a || Le,
        typeof t == "string") {
            if (!(c = t[0] === "<" && t[t.length - 1] === ">" && t.length >= 3 ? [null, t, null] : At.exec(t)) || !c[1] && o)
                return !o || o.jquery ? (o || a).find(t) : this.constructor(o).find(t);
            if (c[1]) {
                if (o = o instanceof u ? o[0] : o,
                u.merge(this, u.parseHTML(c[1], o && o.nodeType ? o.ownerDocument || o : f, !0)),
                pe.test(c[1]) && u.isPlainObject(o))
                    for (c in o)
                        L(this[c]) ? this[c](o[c]) : this.attr(c, o[c]);
                return this
            }
            return (p = f.getElementById(c[2])) && (this[0] = p,
            this.length = 1),
            this
        }
        return t.nodeType ? (this[0] = t,
        this.length = 1,
        this) : L(t) ? a.ready !== void 0 ? a.ready(t) : t(u) : u.makeArray(t, this)
    }
    ).prototype = u.fn,
    Le = u(f);
    var Bi = /^(?:parents|prev(?:Until|All))/
      , Wi = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    u.fn.extend({
        has: function(t) {
            var o = u(t, this)
              , a = o.length;
            return this.filter(function() {
                for (var c = 0; c < a; c++)
                    if (u.contains(this, o[c]))
                        return !0
            })
        },
        closest: function(t, o) {
            var a, c = 0, p = this.length, g = [], v = typeof t != "string" && u(t);
            if (!Y.test(t)) {
                for (; c < p; c++)
                    for (a = this[c]; a && a !== o; a = a.parentNode)
                        if (a.nodeType < 11 && (v ? v.index(a) > -1 : a.nodeType === 1 && u.find.matchesSelector(a, t))) {
                            g.push(a);
                            break
                        }
            }
            return this.pushStack(g.length > 1 ? u.uniqueSort(g) : g)
        },
        index: function(t) {
            return t ? typeof t == "string" ? w.call(u(t), this[0]) : w.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(t, o) {
            return this.pushStack(u.uniqueSort(u.merge(this.get(), u(t, o))))
        },
        addBack: function(t) {
            return this.add(t == null ? this.prevObject : this.prevObject.filter(t))
        }
    });
    function Zt(t, o) {
        for (; (t = t[o]) && t.nodeType !== 1; )
            ;
        return t
    }
    u.each({
        parent: function(t) {
            var o = t.parentNode;
            return o && o.nodeType !== 11 ? o : null
        },
        parents: function(t) {
            return W(t, "parentNode")
        },
        parentsUntil: function(t, o, a) {
            return W(t, "parentNode", a)
        },
        next: function(t) {
            return Zt(t, "nextSibling")
        },
        prev: function(t) {
            return Zt(t, "previousSibling")
        },
        nextAll: function(t) {
            return W(t, "nextSibling")
        },
        prevAll: function(t) {
            return W(t, "previousSibling")
        },
        nextUntil: function(t, o, a) {
            return W(t, "nextSibling", a)
        },
        prevUntil: function(t, o, a) {
            return W(t, "previousSibling", a)
        },
        siblings: function(t) {
            return Z((t.parentNode || {}).firstChild, t)
        },
        children: function(t) {
            return Z(t.firstChild)
        },
        contents: function(t) {
            return X(t, "iframe") ? t.contentDocument : (X(t, "template") && (t = t.content || t),
            u.merge([], t.childNodes))
        }
    }, function(t, o) {
        u.fn[t] = function(a, c) {
            var p = u.map(this, o, a);
            return t.slice(-5) !== "Until" && (c = a),
            c && typeof c == "string" && (p = u.filter(c, p)),
            this.length > 1 && (Wi[t] || u.uniqueSort(p),
            Bi.test(t) && p.reverse()),
            this.pushStack(p)
        }
    });
    var qe = /[^\x20\t\r\n\f]+/g;
    function Ri(t) {
        var o = {};
        return u.each(t.match(qe) || [], function(a, c) {
            o[c] = !0
        }),
        o
    }
    u.Callbacks = function(t) {
        t = typeof t == "string" ? Ri(t) : u.extend({}, t);
        var o, a, c, p, g = [], v = [], S = -1, T = function() {
            for (p = p || t.once,
            c = o = !0; v.length; S = -1)
                for (a = v.shift(); ++S < g.length; )
                    g[S].apply(a[0], a[1]) === !1 && t.stopOnFalse && (S = g.length,
                    a = !1);
            t.memory || (a = !1),
            o = !1,
            p && (g = a ? [] : "")
        }, I = {
            add: function() {
                return g && (a && !o && (S = g.length - 1,
                v.push(a)),
                function F(V) {
                    u.each(V, function(N, q) {
                        L(q) ? t.unique && I.has(q) || g.push(q) : q && q.length && U(q) !== "string" && F(q)
                    })
                }(arguments),
                a && !o && T()),
                this
            },
            remove: function() {
                return u.each(arguments, function(F, V) {
                    for (var N; (N = u.inArray(V, g, N)) > -1; )
                        g.splice(N, 1),
                        N <= S && S--
                }),
                this
            },
            has: function(F) {
                return F ? u.inArray(F, g) > -1 : g.length > 0
            },
            empty: function() {
                return g && (g = []),
                this
            },
            disable: function() {
                return p = v = [],
                g = a = "",
                this
            },
            disabled: function() {
                return !g
            },
            lock: function() {
                return p = v = [],
                a || o || (g = a = ""),
                this
            },
            locked: function() {
                return !!p
            },
            fireWith: function(F, V) {
                return p || (V = [F, (V = V || []).slice ? V.slice() : V],
                v.push(V),
                o || T()),
                this
            },
            fire: function() {
                return I.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!c
            }
        };
        return I
    }
    ;
    function Ye(t) {
        return t
    }
    function mt(t) {
        throw t
    }
    function Kt(t, o, a, c) {
        var p;
        try {
            t && L(p = t.promise) ? p.call(t).done(o).fail(a) : t && L(p = t.then) ? p.call(t, o, a) : o.apply(void 0, [t].slice(c))
        } catch (g) {
            a.apply(void 0, [g])
        }
    }
    u.extend({
        Deferred: function(t) {
            var o = [["notify", "progress", u.Callbacks("memory"), u.Callbacks("memory"), 2], ["resolve", "done", u.Callbacks("once memory"), u.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", u.Callbacks("once memory"), u.Callbacks("once memory"), 1, "rejected"]]
              , a = "pending"
              , c = {
                state: function() {
                    return a
                },
                always: function() {
                    return p.done(arguments).fail(arguments),
                    this
                },
                catch: function(g) {
                    return c.then(null, g)
                },
                pipe: function() {
                    var g = arguments;
                    return u.Deferred(function(v) {
                        u.each(o, function(S, T) {
                            var I = L(g[T[4]]) && g[T[4]];
                            p[T[1]](function() {
                                var F = I && I.apply(this, arguments);
                                F && L(F.promise) ? F.promise().progress(v.notify).done(v.resolve).fail(v.reject) : v[T[0] + "With"](this, I ? [F] : arguments)
                            })
                        }),
                        g = null
                    }).promise()
                },
                then: function(g, v, S) {
                    var T = 0;
                    function I(F, V, N, q) {
                        return function() {
                            var K = this
                              , ae = arguments
                              , te = function() {
                                var be, Ae;
                                if (!(F < T)) {
                                    if ((be = N.apply(K, ae)) === V.promise())
                                        throw new TypeError("Thenable self-resolution");
                                    Ae = be && (typeof be == "object" || typeof be == "function") && be.then,
                                    L(Ae) ? q ? Ae.call(be, I(T, V, Ye, q), I(T, V, mt, q)) : (T++,
                                    Ae.call(be, I(T, V, Ye, q), I(T, V, mt, q), I(T, V, Ye, V.notifyWith))) : (N !== Ye && (K = void 0,
                                    ae = [be]),
                                    (q || V.resolveWith)(K, ae))
                                }
                            }
                              , we = q ? te : function() {
                                try {
                                    te()
                                } catch (be) {
                                    u.Deferred.exceptionHook && u.Deferred.exceptionHook(be, we.stackTrace),
                                    F + 1 >= T && (N !== mt && (K = void 0,
                                    ae = [be]),
                                    V.rejectWith(K, ae))
                                }
                            }
                            ;
                            F ? we() : (u.Deferred.getStackHook && (we.stackTrace = u.Deferred.getStackHook()),
                            n.setTimeout(we))
                        }
                    }
                    return u.Deferred(function(F) {
                        o[0][3].add(I(0, F, L(S) ? S : Ye, F.notifyWith)),
                        o[1][3].add(I(0, F, L(g) ? g : Ye)),
                        o[2][3].add(I(0, F, L(v) ? v : mt))
                    }).promise()
                },
                promise: function(g) {
                    return g != null ? u.extend(g, c) : c
                }
            }
              , p = {};
            return u.each(o, function(g, v) {
                var S = v[2]
                  , T = v[5];
                c[v[1]] = S.add,
                T && S.add(function() {
                    a = T
                }, o[3 - g][2].disable, o[3 - g][3].disable, o[0][2].lock, o[0][3].lock),
                S.add(v[3].fire),
                p[v[0]] = function() {
                    return p[v[0] + "With"](this === p ? void 0 : this, arguments),
                    this
                }
                ,
                p[v[0] + "With"] = S.fireWith
            }),
            c.promise(p),
            t && t.call(p, p),
            p
        },
        when: function(t) {
            var o = arguments.length
              , a = o
              , c = Array(a)
              , p = h.call(arguments)
              , g = u.Deferred()
              , v = function(S) {
                return function(T) {
                    c[S] = this,
                    p[S] = arguments.length > 1 ? h.call(arguments) : T,
                    --o || g.resolveWith(c, p)
                }
            };
            if (o <= 1 && (Kt(t, g.done(v(a)).resolve, g.reject, !o),
            g.state() === "pending" || L(p[a] && p[a].then)))
                return g.then();
            for (; a--; )
                Kt(p[a], v(a), g.reject);
            return g.promise()
        }
    });
    var Ui = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    u.Deferred.exceptionHook = function(t, o) {
        n.console && n.console.warn && t && Ui.test(t.name) && n.console.warn("jQuery.Deferred exception: " + t.message, t.stack, o)
    }
    ,
    u.readyException = function(t) {
        n.setTimeout(function() {
            throw t
        })
    }
    ;
    var Dt = u.Deferred();
    u.fn.ready = function(t) {
        return Dt.then(t).catch(function(o) {
            u.readyException(o)
        }),
        this
    }
    ,
    u.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(t) {
            (t === !0 ? --u.readyWait : u.isReady) || (u.isReady = !0,
            t !== !0 && --u.readyWait > 0 || Dt.resolveWith(f, [u]))
        }
    }),
    u.ready.then = Dt.then;
    function gt() {
        f.removeEventListener("DOMContentLoaded", gt),
        n.removeEventListener("load", gt),
        u.ready()
    }
    f.readyState === "complete" || f.readyState !== "loading" && !f.documentElement.doScroll ? n.setTimeout(u.ready) : (f.addEventListener("DOMContentLoaded", gt),
    n.addEventListener("load", gt));
    var He = function(t, o, a, c, p, g, v) {
        var S = 0
          , T = t.length
          , I = a == null;
        if (U(a) === "object") {
            p = !0;
            for (S in a)
                He(t, o, S, a[S], !0, g, v)
        } else if (c !== void 0 && (p = !0,
        L(c) || (v = !0),
        I && (v ? (o.call(t, c),
        o = null) : (I = o,
        o = function(F, V, N) {
            return I.call(u(F), N)
        }
        )),
        o))
            for (; S < T; S++)
                o(t[S], a, v ? c : c.call(t[S], S, o(t[S], a)));
        return p ? t : I ? o.call(t) : T ? o(t[0], a) : g
    }
      , Vi = /^-ms-/
      , Gi = /-([a-z])/g;
    function Qi(t, o) {
        return o.toUpperCase()
    }
    function Fe(t) {
        return t.replace(Vi, "ms-").replace(Gi, Qi)
    }
    var vt = function(t) {
        return t.nodeType === 1 || t.nodeType === 9 || !+t.nodeType
    };
    function ot() {
        this.expando = u.expando + ot.uid++
    }
    ot.uid = 1,
    ot.prototype = {
        cache: function(t) {
            var o = t[this.expando];
            return o || (o = {},
            vt(t) && (t.nodeType ? t[this.expando] = o : Object.defineProperty(t, this.expando, {
                value: o,
                configurable: !0
            }))),
            o
        },
        set: function(t, o, a) {
            var c, p = this.cache(t);
            if (typeof o == "string")
                p[Fe(o)] = a;
            else
                for (c in o)
                    p[Fe(c)] = o[c];
            return p
        },
        get: function(t, o) {
            return o === void 0 ? this.cache(t) : t[this.expando] && t[this.expando][Fe(o)]
        },
        access: function(t, o, a) {
            return o === void 0 || o && typeof o == "string" && a === void 0 ? this.get(t, o) : (this.set(t, o, a),
            a !== void 0 ? a : o)
        },
        remove: function(t, o) {
            var a, c = t[this.expando];
            if (c !== void 0) {
                if (o !== void 0)
                    for (a = (o = Array.isArray(o) ? o.map(Fe) : (o = Fe(o))in c ? [o] : o.match(qe) || []).length; a--; )
                        delete c[o[a]];
                (o === void 0 || u.isEmptyObject(c)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        },
        hasData: function(t) {
            var o = t[this.expando];
            return o !== void 0 && !u.isEmptyObject(o)
        }
    };
    var se = new ot
      , _e = new ot
      , Xi = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , Ji = /[A-Z]/g;
    function Yi(t) {
        return t === "true" || t !== "false" && (t === "null" ? null : t === +t + "" ? +t : Xi.test(t) ? JSON.parse(t) : t)
    }
    function ei(t, o, a) {
        var c;
        if (a === void 0 && t.nodeType === 1)
            if (c = "data-" + o.replace(Ji, "-$&").toLowerCase(),
            typeof (a = t.getAttribute(c)) == "string") {
                try {
                    a = Yi(a)
                } catch (p) {}
                _e.set(t, o, a)
            } else
                a = void 0;
        return a
    }
    u.extend({
        hasData: function(t) {
            return _e.hasData(t) || se.hasData(t)
        },
        data: function(t, o, a) {
            return _e.access(t, o, a)
        },
        removeData: function(t, o) {
            _e.remove(t, o)
        },
        _data: function(t, o, a) {
            return se.access(t, o, a)
        },
        _removeData: function(t, o) {
            se.remove(t, o)
        }
    }),
    u.fn.extend({
        data: function(t, o) {
            var a, c, p, g = this[0], v = g && g.attributes;
            if (t === void 0) {
                if (this.length && (p = _e.get(g),
                g.nodeType === 1 && !se.get(g, "hasDataAttrs"))) {
                    for (a = v.length; a--; )
                        v[a] && (c = v[a].name).indexOf("data-") === 0 && (c = Fe(c.slice(5)),
                        ei(g, c, p[c]));
                    se.set(g, "hasDataAttrs", !0)
                }
                return p
            }
            return typeof t == "object" ? this.each(function() {
                _e.set(this, t)
            }) : He(this, function(S) {
                var T;
                if (g && S === void 0) {
                    if ((T = _e.get(g, t)) !== void 0 || (T = ei(g, t)) !== void 0)
                        return T
                } else
                    this.each(function() {
                        _e.set(this, t, S)
                    })
            }, null, o, arguments.length > 1, null, !0)
        },
        removeData: function(t) {
            return this.each(function() {
                _e.remove(this, t)
            })
        }
    }),
    u.extend({
        queue: function(t, o, a) {
            var c;
            if (t)
                return o = (o || "fx") + "queue",
                c = se.get(t, o),
                a && (!c || Array.isArray(a) ? c = se.access(t, o, u.makeArray(a)) : c.push(a)),
                c || []
        },
        dequeue: function(t, o) {
            o = o || "fx";
            var a = u.queue(t, o)
              , c = a.length
              , p = a.shift()
              , g = u._queueHooks(t, o)
              , v = function() {
                u.dequeue(t, o)
            };
            p === "inprogress" && (p = a.shift(),
            c--),
            p && (o === "fx" && a.unshift("inprogress"),
            delete g.stop,
            p.call(t, v, g)),
            !c && g && g.empty.fire()
        },
        _queueHooks: function(t, o) {
            var a = o + "queueHooks";
            return se.get(t, a) || se.access(t, a, {
                empty: u.Callbacks("once memory").add(function() {
                    se.remove(t, [o + "queue", a])
                })
            })
        }
    }),
    u.fn.extend({
        queue: function(t, o) {
            var a = 2;
            return typeof t != "string" && (o = t,
            t = "fx",
            a--),
            arguments.length < a ? u.queue(this[0], t) : o === void 0 ? this : this.each(function() {
                var c = u.queue(this, t, o);
                u._queueHooks(this, t),
                t === "fx" && c[0] !== "inprogress" && u.dequeue(this, t)
            })
        },
        dequeue: function(t) {
            return this.each(function() {
                u.dequeue(this, t)
            })
        },
        clearQueue: function(t) {
            return this.queue(t || "fx", [])
        },
        promise: function(t, o) {
            var a, c = 1, p = u.Deferred(), g = this, v = this.length, S = function() {
                --c || p.resolveWith(g, [g])
            };
            for (typeof t != "string" && (o = t,
            t = void 0),
            t = t || "fx"; v--; )
                (a = se.get(g[v], t + "queueHooks")) && a.empty && (c++,
                a.empty.add(S));
            return S(),
            p.promise(o)
        }
    });
    var ti = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , rt = new RegExp("^(?:([+-])=|)(" + ti + ")([a-z%]*)$","i")
      , Be = ["Top", "Right", "Bottom", "Left"]
      , yt = function(t, o) {
        return (t = o || t).style.display === "none" || t.style.display === "" && u.contains(t.ownerDocument, t) && u.css(t, "display") === "none"
    }
      , ii = function(t, o, a, c) {
        var p, g, v = {};
        for (g in o)
            v[g] = t.style[g],
            t.style[g] = o[g];
        p = a.apply(t, c || []);
        for (g in o)
            t.style[g] = v[g];
        return p
    };
    function ni(t, o, a, c) {
        var p, g, v = 20, S = c ? function() {
            return c.cur()
        }
        : function() {
            return u.css(t, o, "")
        }
        , T = S(), I = a && a[3] || (u.cssNumber[o] ? "" : "px"), F = (u.cssNumber[o] || I !== "px" && +T) && rt.exec(u.css(t, o));
        if (F && F[3] !== I) {
            for (T /= 2,
            I = I || F[3],
            F = +T || 1; v--; )
                u.style(t, o, F + I),
                (1 - g) * (1 - (g = S() / T || .5)) <= 0 && (v = 0),
                F /= g;
            F *= 2,
            u.style(t, o, F + I),
            a = a || []
        }
        return a && (F = +F || +T || 0,
        p = a[1] ? F + (a[1] + 1) * a[2] : +a[2],
        c && (c.unit = I,
        c.start = F,
        c.end = p)),
        p
    }
    var oi = {};
    function Zi(t) {
        var o, a = t.ownerDocument, c = t.nodeName, p = oi[c];
        return p || (o = a.body.appendChild(a.createElement(c)),
        p = u.css(o, "display"),
        o.parentNode.removeChild(o),
        p === "none" && (p = "block"),
        oi[c] = p,
        p)
    }
    function Ze(t, o) {
        for (var a, c, p = [], g = 0, v = t.length; g < v; g++)
            (c = t[g]).style && (a = c.style.display,
            o ? (a === "none" && (p[g] = se.get(c, "display") || null,
            p[g] || (c.style.display = "")),
            c.style.display === "" && yt(c) && (p[g] = Zi(c))) : a !== "none" && (p[g] = "none",
            se.set(c, "display", a)));
        for (g = 0; g < v; g++)
            p[g] != null && (t[g].style.display = p[g]);
        return t
    }
    u.fn.extend({
        show: function() {
            return Ze(this, !0)
        },
        hide: function() {
            return Ze(this)
        },
        toggle: function(t) {
            return typeof t == "boolean" ? t ? this.show() : this.hide() : this.each(function() {
                yt(this) ? u(this).show() : u(this).hide()
            })
        }
    });
    var ri = /^(?:checkbox|radio)$/i
      , ai = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i
      , si = /^$|^module$|\/(?:java|ecma)script/i
      , je = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    je.optgroup = je.option,
    je.tbody = je.tfoot = je.colgroup = je.caption = je.thead,
    je.th = je.td;
    function ke(t, o) {
        var a;
        return a = typeof t.getElementsByTagName != "undefined" ? t.getElementsByTagName(o || "*") : typeof t.querySelectorAll != "undefined" ? t.querySelectorAll(o || "*") : [],
        o === void 0 || o && X(t, o) ? u.merge([t], a) : a
    }
    function jt(t, o) {
        for (var a = 0, c = t.length; a < c; a++)
            se.set(t[a], "globalEval", !o || se.get(o[a], "globalEval"))
    }
    var Ki = /<|&#?\w+;/;
    function li(t, o, a, c, p) {
        for (var g, v, S, T, I, F, V = o.createDocumentFragment(), N = [], q = 0, K = t.length; q < K; q++)
            if ((g = t[q]) || g === 0)
                if (U(g) === "object")
                    u.merge(N, g.nodeType ? [g] : g);
                else if (Ki.test(g)) {
                    for (v = v || V.appendChild(o.createElement("div")),
                    S = (ai.exec(g) || ["", ""])[1].toLowerCase(),
                    T = je[S] || je._default,
                    v.innerHTML = T[1] + u.htmlPrefilter(g) + T[2],
                    F = T[0]; F--; )
                        v = v.lastChild;
                    u.merge(N, v.childNodes),
                    (v = V.firstChild).textContent = ""
                } else
                    N.push(o.createTextNode(g));
        for (V.textContent = "",
        q = 0; g = N[q++]; )
            if (c && u.inArray(g, c) > -1)
                p && p.push(g);
            else if (I = u.contains(g.ownerDocument, g),
            v = ke(V.appendChild(g), "script"),
            I && jt(v),
            a)
                for (F = 0; g = v[F++]; )
                    si.test(g.type || "") && a.push(g);
        return V
    }
    (function() {
        var t = f.createDocumentFragment().appendChild(f.createElement("div"))
          , o = f.createElement("input");
        o.setAttribute("type", "radio"),
        o.setAttribute("checked", "checked"),
        o.setAttribute("name", "t"),
        t.appendChild(o),
        j.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked,
        t.innerHTML = "<textarea>x</textarea>",
        j.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue
    }
    )();
    var wt = f.documentElement
      , en = /^key/
      , tn = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , ci = /^([^.]*)(?:\.(.+)|)/;
    function bt() {
        return !0
    }
    function Ke() {
        return !1
    }
    function di() {
        try {
            return f.activeElement
        } catch (t) {}
    }
    function Pt(t, o, a, c, p, g) {
        var v, S;
        if (typeof o == "object") {
            typeof a != "string" && (c = c || a,
            a = void 0);
            for (S in o)
                Pt(t, S, a, c, o[S], g);
            return t
        }
        if (c == null && p == null ? (p = a,
        c = a = void 0) : p == null && (typeof a == "string" ? (p = c,
        c = void 0) : (p = c,
        c = a,
        a = void 0)),
        p === !1)
            p = Ke;
        else if (!p)
            return t;
        return g === 1 && (v = p,
        (p = function(T) {
            return u().off(T),
            v.apply(this, arguments)
        }
        ).guid = v.guid || (v.guid = u.guid++)),
        t.each(function() {
            u.event.add(this, o, p, c, a)
        })
    }
    u.event = {
        global: {},
        add: function(t, o, a, c, p) {
            var g, v, S, T, I, F, V, N, q, K, ae, te = se.get(t);
            if (te)
                for (a.handler && (a = (g = a).handler,
                p = g.selector),
                p && u.find.matchesSelector(wt, p),
                a.guid || (a.guid = u.guid++),
                (T = te.events) || (T = te.events = {}),
                (v = te.handle) || (v = te.handle = function(we) {
                    return typeof u != "undefined" && u.event.triggered !== we.type ? u.event.dispatch.apply(t, arguments) : void 0
                }
                ),
                I = (o = (o || "").match(qe) || [""]).length; I--; )
                    q = ae = (S = ci.exec(o[I]) || [])[1],
                    K = (S[2] || "").split(".").sort(),
                    q && (V = u.event.special[q] || {},
                    q = (p ? V.delegateType : V.bindType) || q,
                    V = u.event.special[q] || {},
                    F = u.extend({
                        type: q,
                        origType: ae,
                        data: c,
                        handler: a,
                        guid: a.guid,
                        selector: p,
                        needsContext: p && u.expr.match.needsContext.test(p),
                        namespace: K.join(".")
                    }, g),
                    (N = T[q]) || ((N = T[q] = []).delegateCount = 0,
                    V.setup && V.setup.call(t, c, K, v) !== !1 || t.addEventListener && t.addEventListener(q, v)),
                    V.add && (V.add.call(t, F),
                    F.handler.guid || (F.handler.guid = a.guid)),
                    p ? N.splice(N.delegateCount++, 0, F) : N.push(F),
                    u.event.global[q] = !0)
        },
        remove: function(t, o, a, c, p) {
            var g, v, S, T, I, F, V, N, q, K, ae, te = se.hasData(t) && se.get(t);
            if (te && (T = te.events)) {
                for (I = (o = (o || "").match(qe) || [""]).length; I--; )
                    if (S = ci.exec(o[I]) || [],
                    q = ae = S[1],
                    K = (S[2] || "").split(".").sort(),
                    q) {
                        for (V = u.event.special[q] || {},
                        N = T[q = (c ? V.delegateType : V.bindType) || q] || [],
                        S = S[2] && new RegExp("(^|\\.)" + K.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        v = g = N.length; g--; )
                            F = N[g],
                            !p && ae !== F.origType || a && a.guid !== F.guid || S && !S.test(F.namespace) || c && c !== F.selector && (c !== "**" || !F.selector) || (N.splice(g, 1),
                            F.selector && N.delegateCount--,
                            V.remove && V.remove.call(t, F));
                        v && !N.length && (V.teardown && V.teardown.call(t, K, te.handle) !== !1 || u.removeEvent(t, q, te.handle),
                        delete T[q])
                    } else
                        for (q in T)
                            u.event.remove(t, q + o[I], a, c, !0);
                u.isEmptyObject(T) && se.remove(t, "handle events")
            }
        },
        dispatch: function(t) {
            var o = u.event.fix(t), a, c, p, g, v, S, T = new Array(arguments.length), I = (se.get(this, "events") || {})[o.type] || [], F = u.event.special[o.type] || {};
            for (T[0] = o,
            a = 1; a < arguments.length; a++)
                T[a] = arguments[a];
            if (o.delegateTarget = this,
            !F.preDispatch || F.preDispatch.call(this, o) !== !1) {
                for (S = u.event.handlers.call(this, o, I),
                a = 0; (g = S[a++]) && !o.isPropagationStopped(); )
                    for (o.currentTarget = g.elem,
                    c = 0; (v = g.handlers[c++]) && !o.isImmediatePropagationStopped(); )
                        o.rnamespace && !o.rnamespace.test(v.namespace) || (o.handleObj = v,
                        o.data = v.data,
                        (p = ((u.event.special[v.origType] || {}).handle || v.handler).apply(g.elem, T)) !== void 0 && (o.result = p) === !1 && (o.preventDefault(),
                        o.stopPropagation()));
                return F.postDispatch && F.postDispatch.call(this, o),
                o.result
            }
        },
        handlers: function(t, o) {
            var a, c, p, g, v, S = [], T = o.delegateCount, I = t.target;
            if (T && I.nodeType && !(t.type === "click" && t.button >= 1)) {
                for (; I !== this; I = I.parentNode || this)
                    if (I.nodeType === 1 && (t.type !== "click" || I.disabled !== !0)) {
                        for (g = [],
                        v = {},
                        a = 0; a < T; a++)
                            v[p = (c = o[a]).selector + " "] === void 0 && (v[p] = c.needsContext ? u(p, this).index(I) > -1 : u.find(p, this, null, [I]).length),
                            v[p] && g.push(c);
                        g.length && S.push({
                            elem: I,
                            handlers: g
                        })
                    }
            }
            return I = this,
            T < o.length && S.push({
                elem: I,
                handlers: o.slice(T)
            }),
            S
        },
        addProp: function(t, o) {
            Object.defineProperty(u.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: L(o) ? function() {
                    if (this.originalEvent)
                        return o(this.originalEvent)
                }
                : function() {
                    if (this.originalEvent)
                        return this.originalEvent[t]
                }
                ,
                set: function(a) {
                    Object.defineProperty(this, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: a
                    })
                }
            })
        },
        fix: function(t) {
            return t[u.expando] ? t : new u.Event(t)
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== di() && this.focus)
                        return this.focus(),
                        !1
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    if (this === di() && this.blur)
                        return this.blur(),
                        !1
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    if (this.type === "checkbox" && this.click && X(this, "input"))
                        return this.click(),
                        !1
                },
                _default: function(t) {
                    return X(t.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(t) {
                    t.result !== void 0 && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    },
    u.removeEvent = function(t, o, a) {
        t.removeEventListener && t.removeEventListener(o, a)
    }
    ,
    u.Event = function(t, o) {
        if (!(this instanceof u.Event))
            return new u.Event(t,o);
        t && t.type ? (this.originalEvent = t,
        this.type = t.type,
        this.isDefaultPrevented = t.defaultPrevented || t.defaultPrevented === void 0 && t.returnValue === !1 ? bt : Ke,
        this.target = t.target && t.target.nodeType === 3 ? t.target.parentNode : t.target,
        this.currentTarget = t.currentTarget,
        this.relatedTarget = t.relatedTarget) : this.type = t,
        o && u.extend(this, o),
        this.timeStamp = t && t.timeStamp || Date.now(),
        this[u.expando] = !0
    }
    ,
    u.Event.prototype = {
        constructor: u.Event,
        isDefaultPrevented: Ke,
        isPropagationStopped: Ke,
        isImmediatePropagationStopped: Ke,
        isSimulated: !1,
        preventDefault: function() {
            var t = this.originalEvent;
            this.isDefaultPrevented = bt,
            t && !this.isSimulated && t.preventDefault()
        },
        stopPropagation: function() {
            var t = this.originalEvent;
            this.isPropagationStopped = bt,
            t && !this.isSimulated && t.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = bt,
            t && !this.isSimulated && t.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    u.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(t) {
            var o = t.button;
            return t.which == null && en.test(t.type) ? t.charCode != null ? t.charCode : t.keyCode : !t.which && o !== void 0 && tn.test(t.type) ? 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0 : t.which
        }
    }, u.event.addProp),
    u.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(t, o) {
        u.event.special[t] = {
            delegateType: o,
            bindType: o,
            handle: function(a) {
                var c, p = this, g = a.relatedTarget, v = a.handleObj;
                return g && (g === p || u.contains(p, g)) || (a.type = v.origType,
                c = v.handler.apply(this, arguments),
                a.type = o),
                c
            }
        }
    }),
    u.fn.extend({
        on: function(t, o, a, c) {
            return Pt(this, t, o, a, c)
        },
        one: function(t, o, a, c) {
            return Pt(this, t, o, a, c, 1)
        },
        off: function(t, o, a) {
            var c, p;
            if (t && t.preventDefault && t.handleObj)
                return c = t.handleObj,
                u(t.delegateTarget).off(c.namespace ? c.origType + "." + c.namespace : c.origType, c.selector, c.handler),
                this;
            if (typeof t == "object") {
                for (p in t)
                    this.off(p, o, t[p]);
                return this
            }
            return o !== !1 && typeof o != "function" || (a = o,
            o = void 0),
            a === !1 && (a = Ke),
            this.each(function() {
                u.event.remove(this, t, a, o)
            })
        }
    });
    var nn = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi
      , on = /<script|<style|<link/i
      , rn = /checked\s*(?:[^=]|=\s*.checked.)/i
      , an = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function ui(t, o) {
        return X(t, "table") && X(o.nodeType !== 11 ? o : o.firstChild, "tr") && u(t).children("tbody")[0] || t
    }
    function sn(t) {
        return t.type = (t.getAttribute("type") !== null) + "/" + t.type,
        t
    }
    function ln(t) {
        return (t.type || "").slice(0, 5) === "true/" ? t.type = t.type.slice(5) : t.removeAttribute("type"),
        t
    }
    function fi(t, o) {
        var a, c, p, g, v, S, T, I;
        if (o.nodeType === 1) {
            if (se.hasData(t) && (g = se.access(t),
            v = se.set(o, g),
            I = g.events)) {
                delete v.handle,
                v.events = {};
                for (p in I)
                    for (a = 0,
                    c = I[p].length; a < c; a++)
                        u.event.add(o, p, I[p][a])
            }
            _e.hasData(t) && (S = _e.access(t),
            T = u.extend({}, S),
            _e.set(o, T))
        }
    }
    function cn(t, o) {
        var a = o.nodeName.toLowerCase();
        a === "input" && ri.test(t.type) ? o.checked = t.checked : a !== "input" && a !== "textarea" || (o.defaultValue = t.defaultValue)
    }
    function et(t, o, a, c) {
        o = d.apply([], o);
        var p, g, v, S, T, I, F = 0, V = t.length, N = V - 1, q = o[0], K = L(q);
        if (K || V > 1 && typeof q == "string" && !j.checkClone && rn.test(q))
            return t.each(function(ae) {
                var te = t.eq(ae);
                K && (o[0] = q.call(this, ae, te.html())),
                et(te, o, a, c)
            });
        if (V && (p = li(o, t[0].ownerDocument, !1, t, c),
        g = p.firstChild,
        p.childNodes.length === 1 && (p = g),
        g || c)) {
            for (S = (v = u.map(ke(p, "script"), sn)).length; F < V; F++)
                T = p,
                F !== N && (T = u.clone(T, !0, !0),
                S && u.merge(v, ke(T, "script"))),
                a.call(t[F], T, F);
            if (S)
                for (I = v[v.length - 1].ownerDocument,
                u.map(v, ln),
                F = 0; F < S; F++)
                    T = v[F],
                    si.test(T.type || "") && !se.access(T, "globalEval") && u.contains(I, T) && (T.src && (T.type || "").toLowerCase() !== "module" ? u._evalUrl && u._evalUrl(T.src) : M(T.textContent.replace(an, ""), I, T))
        }
        return t
    }
    function hi(t, o, a) {
        for (var c, p = o ? u.filter(o, t) : t, g = 0; (c = p[g]) != null; g++)
            a || c.nodeType !== 1 || u.cleanData(ke(c)),
            c.parentNode && (a && u.contains(c.ownerDocument, c) && jt(ke(c, "script")),
            c.parentNode.removeChild(c));
        return t
    }
    u.extend({
        htmlPrefilter: function(t) {
            return t.replace(nn, "<$1></$2>")
        },
        clone: function(t, o, a) {
            var c, p, g, v, S = t.cloneNode(!0), T = u.contains(t.ownerDocument, t);
            if (!(j.noCloneChecked || t.nodeType !== 1 && t.nodeType !== 11 || u.isXMLDoc(t)))
                for (v = ke(S),
                c = 0,
                p = (g = ke(t)).length; c < p; c++)
                    cn(g[c], v[c]);
            if (o)
                if (a)
                    for (g = g || ke(t),
                    v = v || ke(S),
                    c = 0,
                    p = g.length; c < p; c++)
                        fi(g[c], v[c]);
                else
                    fi(t, S);
            return (v = ke(S, "script")).length > 0 && jt(v, !T && ke(t, "script")),
            S
        },
        cleanData: function(t) {
            for (var o, a, c, p = u.event.special, g = 0; (a = t[g]) !== void 0; g++)
                if (vt(a)) {
                    if (o = a[se.expando]) {
                        if (o.events)
                            for (c in o.events)
                                p[c] ? u.event.remove(a, c) : u.removeEvent(a, c, o.handle);
                        a[se.expando] = void 0
                    }
                    a[_e.expando] && (a[_e.expando] = void 0)
                }
        }
    }),
    u.fn.extend({
        detach: function(t) {
            return hi(this, t, !0)
        },
        remove: function(t) {
            return hi(this, t)
        },
        text: function(t) {
            return He(this, function(o) {
                return o === void 0 ? u.text(this) : this.empty().each(function() {
                    this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9 || (this.textContent = o)
                })
            }, null, t, arguments.length)
        },
        append: function() {
            return et(this, arguments, function(t) {
                this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9 || ui(this, t).appendChild(t)
            })
        },
        prepend: function() {
            return et(this, arguments, function(t) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var o = ui(this, t);
                    o.insertBefore(t, o.firstChild)
                }
            })
        },
        before: function() {
            return et(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        },
        after: function() {
            return et(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        },
        empty: function() {
            for (var t, o = 0; (t = this[o]) != null; o++)
                t.nodeType === 1 && (u.cleanData(ke(t, !1)),
                t.textContent = "");
            return this
        },
        clone: function(t, o) {
            return t = t != null && t,
            o = o == null ? t : o,
            this.map(function() {
                return u.clone(this, t, o)
            })
        },
        html: function(t) {
            return He(this, function(o) {
                var a = this[0] || {}
                  , c = 0
                  , p = this.length;
                if (o === void 0 && a.nodeType === 1)
                    return a.innerHTML;
                if (typeof o == "string" && !on.test(o) && !je[(ai.exec(o) || ["", ""])[1].toLowerCase()]) {
                    o = u.htmlPrefilter(o);
                    try {
                        for (; c < p; c++)
                            (a = this[c] || {}).nodeType === 1 && (u.cleanData(ke(a, !1)),
                            a.innerHTML = o);
                        a = 0
                    } catch (g) {}
                }
                a && this.empty().append(o)
            }, null, t, arguments.length)
        },
        replaceWith: function() {
            var t = [];
            return et(this, arguments, function(o) {
                var a = this.parentNode;
                u.inArray(this, t) < 0 && (u.cleanData(ke(this)),
                a && a.replaceChild(o, this))
            }, t)
        }
    }),
    u.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(t, o) {
        u.fn[t] = function(a) {
            for (var c, p = [], g = u(a), v = g.length - 1, S = 0; S <= v; S++)
                c = S === v ? this : this.clone(!0),
                u(g[S])[o](c),
                m.apply(p, c.get());
            return this.pushStack(p)
        }
    });
    var It = new RegExp("^(" + ti + ")(?!px)[a-z%]+$","i")
      , xt = function(t) {
        var o = t.ownerDocument.defaultView;
        return o && o.opener || (o = n),
        o.getComputedStyle(t)
    }
      , dn = new RegExp(Be.join("|"),"i");
    (function() {
        function t() {
            if (T) {
                S.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
                T.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
                wt.appendChild(S).appendChild(T);
                var I = n.getComputedStyle(T);
                a = I.top !== "1%",
                v = o(I.marginLeft) === 12,
                T.style.right = "60%",
                g = o(I.right) === 36,
                c = o(I.width) === 36,
                T.style.position = "absolute",
                p = T.offsetWidth === 36 || "absolute",
                wt.removeChild(S),
                T = null
            }
        }
        function o(I) {
            return Math.round(parseFloat(I))
        }
        var a, c, p, g, v, S = f.createElement("div"), T = f.createElement("div");
        T.style && (T.style.backgroundClip = "content-box",
        T.cloneNode(!0).style.backgroundClip = "",
        j.clearCloneStyle = T.style.backgroundClip === "content-box",
        u.extend(j, {
            boxSizingReliable: function() {
                return t(),
                c
            },
            pixelBoxStyles: function() {
                return t(),
                g
            },
            pixelPosition: function() {
                return t(),
                a
            },
            reliableMarginLeft: function() {
                return t(),
                v
            },
            scrollboxSize: function() {
                return t(),
                p
            }
        }))
    }
    )();
    function at(t, o, a) {
        var c, p, g, v, S = t.style;
        return (a = a || xt(t)) && ((v = a.getPropertyValue(o) || a[o]) !== "" || u.contains(t.ownerDocument, t) || (v = u.style(t, o)),
        !j.pixelBoxStyles() && It.test(v) && dn.test(o) && (c = S.width,
        p = S.minWidth,
        g = S.maxWidth,
        S.minWidth = S.maxWidth = S.width = v,
        v = a.width,
        S.width = c,
        S.minWidth = p,
        S.maxWidth = g)),
        v !== void 0 ? v + "" : v
    }
    function pi(t, o) {
        return {
            get: function() {
                if (!t())
                    return (this.get = o).apply(this, arguments);
                delete this.get
            }
        }
    }
    var un = /^(none|table(?!-c[ea]).+)/
      , mi = /^--/
      , fn = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , gi = {
        letterSpacing: "0",
        fontWeight: "400"
    }
      , vi = ["Webkit", "Moz", "ms"]
      , yi = f.createElement("div").style;
    function hn(t) {
        if (t in yi)
            return t;
        for (var o = t[0].toUpperCase() + t.slice(1), a = vi.length; a--; )
            if ((t = vi[a] + o)in yi)
                return t
    }
    function wi(t) {
        var o = u.cssProps[t];
        return o || (o = u.cssProps[t] = hn(t) || t),
        o
    }
    function bi(t, o, a) {
        var c = rt.exec(o);
        return c ? Math.max(0, c[2] - (a || 0)) + (c[3] || "px") : o
    }
    function Lt(t, o, a, c, p, g) {
        var v = o === "width" ? 1 : 0
          , S = 0
          , T = 0;
        if (a === (c ? "border" : "content"))
            return 0;
        for (; v < 4; v += 2)
            a === "margin" && (T += u.css(t, a + Be[v], !0, p)),
            c ? (a === "content" && (T -= u.css(t, "padding" + Be[v], !0, p)),
            a !== "margin" && (T -= u.css(t, "border" + Be[v] + "Width", !0, p))) : (T += u.css(t, "padding" + Be[v], !0, p),
            a !== "padding" ? T += u.css(t, "border" + Be[v] + "Width", !0, p) : S += u.css(t, "border" + Be[v] + "Width", !0, p));
        return !c && g >= 0 && (T += Math.max(0, Math.ceil(t["offset" + o[0].toUpperCase() + o.slice(1)] - g - T - S - .5))),
        T
    }
    function xi(t, o, a) {
        var c = xt(t)
          , p = at(t, o, c)
          , g = u.css(t, "boxSizing", !1, c) === "border-box"
          , v = g;
        if (It.test(p)) {
            if (!a)
                return p;
            p = "auto"
        }
        return v = v && (j.boxSizingReliable() || p === t.style[o]),
        (p === "auto" || !parseFloat(p) && u.css(t, "display", !1, c) === "inline") && (p = t["offset" + o[0].toUpperCase() + o.slice(1)],
        v = !0),
        (p = parseFloat(p) || 0) + Lt(t, o, a || (g ? "border" : "content"), v, c, p) + "px"
    }
    u.extend({
        cssHooks: {
            opacity: {
                get: function(t, o) {
                    if (o) {
                        var a = at(t, "opacity");
                        return a === "" ? "1" : a
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(t, o, a, c) {
            if (t && t.nodeType !== 3 && t.nodeType !== 8 && t.style) {
                var p, g, v, S = Fe(o), T = mi.test(o), I = t.style;
                if (T || (o = wi(S)),
                v = u.cssHooks[o] || u.cssHooks[S],
                a === void 0)
                    return v && "get"in v && (p = v.get(t, !1, c)) !== void 0 ? p : I[o];
                (g = typeof a) == "string" && (p = rt.exec(a)) && p[1] && (a = ni(t, o, p),
                g = "number"),
                a != null && a === a && (g === "number" && (a += p && p[3] || (u.cssNumber[S] ? "" : "px")),
                j.clearCloneStyle || a !== "" || o.indexOf("background") !== 0 || (I[o] = "inherit"),
                v && "set"in v && (a = v.set(t, a, c)) === void 0 || (T ? I.setProperty(o, a) : I[o] = a))
            }
        },
        css: function(t, o, a, c) {
            var p, g, v, S = Fe(o);
            return mi.test(o) || (o = wi(S)),
            (v = u.cssHooks[o] || u.cssHooks[S]) && "get"in v && (p = v.get(t, !0, a)),
            p === void 0 && (p = at(t, o, c)),
            p === "normal" && o in gi && (p = gi[o]),
            a === "" || a ? (g = parseFloat(p),
            a === !0 || isFinite(g) ? g || 0 : p) : p
        }
    }),
    u.each(["height", "width"], function(t, o) {
        u.cssHooks[o] = {
            get: function(a, c, p) {
                if (c)
                    return !un.test(u.css(a, "display")) || a.getClientRects().length && a.getBoundingClientRect().width ? xi(a, o, p) : ii(a, fn, function() {
                        return xi(a, o, p)
                    })
            },
            set: function(a, c, p) {
                var g, v = xt(a), S = u.css(a, "boxSizing", !1, v) === "border-box", T = p && Lt(a, o, p, S, v);
                return S && j.scrollboxSize() === v.position && (T -= Math.ceil(a["offset" + o[0].toUpperCase() + o.slice(1)] - parseFloat(v[o]) - Lt(a, o, "border", !1, v) - .5)),
                T && (g = rt.exec(c)) && (g[3] || "px") !== "px" && (a.style[o] = c,
                c = u.css(a, o)),
                bi(a, c, T)
            }
        }
    }),
    u.cssHooks.marginLeft = pi(j.reliableMarginLeft, function(t, o) {
        if (o)
            return (parseFloat(at(t, "marginLeft")) || t.getBoundingClientRect().left - ii(t, {
                marginLeft: 0
            }, function() {
                return t.getBoundingClientRect().left
            })) + "px"
    }),
    u.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(t, o) {
        u.cssHooks[t + o] = {
            expand: function(a) {
                for (var c = 0, p = {}, g = typeof a == "string" ? a.split(" ") : [a]; c < 4; c++)
                    p[t + Be[c] + o] = g[c] || g[c - 2] || g[0];
                return p
            }
        },
        t !== "margin" && (u.cssHooks[t + o].set = bi)
    }),
    u.fn.extend({
        css: function(t, o) {
            return He(this, function(a, c, p) {
                var g, v, S = {}, T = 0;
                if (Array.isArray(c)) {
                    for (g = xt(a),
                    v = c.length; T < v; T++)
                        S[c[T]] = u.css(a, c[T], !1, g);
                    return S
                }
                return p !== void 0 ? u.style(a, c, p) : u.css(a, c)
            }, t, o, arguments.length > 1)
        }
    });
    function Te(t, o, a, c, p) {
        return new Te.prototype.init(t,o,a,c,p)
    }
    u.Tween = Te,
    Te.prototype = {
        constructor: Te,
        init: function(t, o, a, c, p, g) {
            this.elem = t,
            this.prop = a,
            this.easing = p || u.easing._default,
            this.options = o,
            this.start = this.now = this.cur(),
            this.end = c,
            this.unit = g || (u.cssNumber[a] ? "" : "px")
        },
        cur: function() {
            var t = Te.propHooks[this.prop];
            return t && t.get ? t.get(this) : Te.propHooks._default.get(this)
        },
        run: function(t) {
            var o, a = Te.propHooks[this.prop];
            return this.options.duration ? this.pos = o = u.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = o = t,
            this.now = (this.end - this.start) * o + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            a && a.set ? a.set(this) : Te.propHooks._default.set(this),
            this
        }
    },
    Te.prototype.init.prototype = Te.prototype,
    Te.propHooks = {
        _default: {
            get: function(t) {
                var o;
                return t.elem.nodeType !== 1 || t.elem[t.prop] != null && t.elem.style[t.prop] == null ? t.elem[t.prop] : (o = u.css(t.elem, t.prop, "")) && o !== "auto" ? o : 0
            },
            set: function(t) {
                u.fx.step[t.prop] ? u.fx.step[t.prop](t) : t.elem.nodeType !== 1 || t.elem.style[u.cssProps[t.prop]] == null && !u.cssHooks[t.prop] ? t.elem[t.prop] = t.now : u.style(t.elem, t.prop, t.now + t.unit)
            }
        }
    },
    Te.propHooks.scrollTop = Te.propHooks.scrollLeft = {
        set: function(t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    },
    u.easing = {
        linear: function(t) {
            return t
        },
        swing: function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        },
        _default: "swing"
    },
    u.fx = Te.prototype.init,
    u.fx.step = {};
    var tt, $t, pn = /^(?:toggle|show|hide)$/, mn = /queueHooks$/;
    function Nt() {
        $t && (f.hidden === !1 && n.requestAnimationFrame ? n.requestAnimationFrame(Nt) : n.setTimeout(Nt, u.fx.interval),
        u.fx.tick())
    }
    function $i() {
        return n.setTimeout(function() {
            tt = void 0
        }),
        tt = Date.now()
    }
    function St(t, o) {
        var a, c = 0, p = {
            height: t
        };
        for (o = o ? 1 : 0; c < 4; c += 2 - o)
            p["margin" + (a = Be[c])] = p["padding" + a] = t;
        return o && (p.opacity = p.width = t),
        p
    }
    function Si(t, o, a) {
        for (var c, p = (Ne.tweeners[o] || []).concat(Ne.tweeners["*"]), g = 0, v = p.length; g < v; g++)
            if (c = p[g].call(a, o, t))
                return c
    }
    function gn(t, o, a) {
        var c, p, g, v, S, T, I, F, V = "width"in o || "height"in o, N = this, q = {}, K = t.style, ae = t.nodeType && yt(t), te = se.get(t, "fxshow");
        a.queue || ((v = u._queueHooks(t, "fx")).unqueued == null && (v.unqueued = 0,
        S = v.empty.fire,
        v.empty.fire = function() {
            v.unqueued || S()
        }
        ),
        v.unqueued++,
        N.always(function() {
            N.always(function() {
                v.unqueued--,
                u.queue(t, "fx").length || v.empty.fire()
            })
        }));
        for (c in o)
            if (p = o[c],
            pn.test(p)) {
                if (delete o[c],
                g = g || p === "toggle",
                p === (ae ? "hide" : "show")) {
                    if (p !== "show" || !te || te[c] === void 0)
                        continue;
                    ae = !0
                }
                q[c] = te && te[c] || u.style(t, c)
            }
        if ((T = !u.isEmptyObject(o)) || !u.isEmptyObject(q)) {
            V && t.nodeType === 1 && (a.overflow = [K.overflow, K.overflowX, K.overflowY],
            (I = te && te.display) == null && (I = se.get(t, "display")),
            (F = u.css(t, "display")) === "none" && (I ? F = I : (Ze([t], !0),
            I = t.style.display || I,
            F = u.css(t, "display"),
            Ze([t]))),
            (F === "inline" || F === "inline-block" && I != null) && u.css(t, "float") === "none" && (T || (N.done(function() {
                K.display = I
            }),
            I == null && (F = K.display,
            I = F === "none" ? "" : F)),
            K.display = "inline-block")),
            a.overflow && (K.overflow = "hidden",
            N.always(function() {
                K.overflow = a.overflow[0],
                K.overflowX = a.overflow[1],
                K.overflowY = a.overflow[2]
            })),
            T = !1;
            for (c in q)
                T || (te ? "hidden"in te && (ae = te.hidden) : te = se.access(t, "fxshow", {
                    display: I
                }),
                g && (te.hidden = !ae),
                ae && Ze([t], !0),
                N.done(function() {
                    ae || Ze([t]),
                    se.remove(t, "fxshow");
                    for (c in q)
                        u.style(t, c, q[c])
                })),
                T = Si(ae ? te[c] : 0, c, N),
                c in te || (te[c] = T.start,
                ae && (T.end = T.start,
                T.start = 0))
        }
    }
    function vn(t, o) {
        var a, c, p, g, v;
        for (a in t)
            if (c = Fe(a),
            p = o[c],
            g = t[a],
            Array.isArray(g) && (p = g[1],
            g = t[a] = g[0]),
            a !== c && (t[c] = g,
            delete t[a]),
            (v = u.cssHooks[c]) && "expand"in v) {
                g = v.expand(g),
                delete t[c];
                for (a in g)
                    a in t || (t[a] = g[a],
                    o[a] = p)
            } else
                o[c] = p
    }
    function Ne(t, o, a) {
        var c, p, g = 0, v = Ne.prefilters.length, S = u.Deferred().always(function() {
            delete T.elem
        }), T = function() {
            if (p)
                return !1;
            for (var V = tt || $i(), N = Math.max(0, I.startTime + I.duration - V), q = 1 - (N / I.duration || 0), K = 0, ae = I.tweens.length; K < ae; K++)
                I.tweens[K].run(q);
            return S.notifyWith(t, [I, q, N]),
            q < 1 && ae ? N : (ae || S.notifyWith(t, [I, 1, 0]),
            S.resolveWith(t, [I]),
            !1)
        }, I = S.promise({
            elem: t,
            props: u.extend({}, o),
            opts: u.extend(!0, {
                specialEasing: {},
                easing: u.easing._default
            }, a),
            originalProperties: o,
            originalOptions: a,
            startTime: tt || $i(),
            duration: a.duration,
            tweens: [],
            createTween: function(V, N) {
                var q = u.Tween(t, I.opts, V, N, I.opts.specialEasing[V] || I.opts.easing);
                return I.tweens.push(q),
                q
            },
            stop: function(V) {
                var N = 0
                  , q = V ? I.tweens.length : 0;
                if (p)
                    return this;
                for (p = !0; N < q; N++)
                    I.tweens[N].run(1);
                return V ? (S.notifyWith(t, [I, 1, 0]),
                S.resolveWith(t, [I, V])) : S.rejectWith(t, [I, V]),
                this
            }
        }), F = I.props;
        for (vn(F, I.opts.specialEasing); g < v; g++)
            if (c = Ne.prefilters[g].call(I, t, F, I.opts))
                return L(c.stop) && (u._queueHooks(I.elem, I.opts.queue).stop = c.stop.bind(c)),
                c;
        return u.map(F, Si, I),
        L(I.opts.start) && I.opts.start.call(t, I),
        I.progress(I.opts.progress).done(I.opts.done, I.opts.complete).fail(I.opts.fail).always(I.opts.always),
        u.fx.timer(u.extend(T, {
            elem: t,
            anim: I,
            queue: I.opts.queue
        })),
        I
    }
    u.Animation = u.extend(Ne, {
        tweeners: {
            "*": [function(t, o) {
                var a = this.createTween(t, o);
                return ni(a.elem, t, rt.exec(o), a),
                a
            }
            ]
        },
        tweener: function(t, o) {
            L(t) ? (o = t,
            t = ["*"]) : t = t.match(qe);
            for (var a, c = 0, p = t.length; c < p; c++)
                a = t[c],
                Ne.tweeners[a] = Ne.tweeners[a] || [],
                Ne.tweeners[a].unshift(o)
        },
        prefilters: [gn],
        prefilter: function(t, o) {
            o ? Ne.prefilters.unshift(t) : Ne.prefilters.push(t)
        }
    }),
    u.speed = function(t, o, a) {
        var c = t && typeof t == "object" ? u.extend({}, t) : {
            complete: a || !a && o || L(t) && t,
            duration: t,
            easing: a && o || o && !L(o) && o
        };
        return u.fx.off ? c.duration = 0 : typeof c.duration != "number" && (c.duration in u.fx.speeds ? c.duration = u.fx.speeds[c.duration] : c.duration = u.fx.speeds._default),
        c.queue != null && c.queue !== !0 || (c.queue = "fx"),
        c.old = c.complete,
        c.complete = function() {
            L(c.old) && c.old.call(this),
            c.queue && u.dequeue(this, c.queue)
        }
        ,
        c
    }
    ,
    u.fn.extend({
        fadeTo: function(t, o, a, c) {
            return this.filter(yt).css("opacity", 0).show().end().animate({
                opacity: o
            }, t, a, c)
        },
        animate: function(t, o, a, c) {
            var p = u.isEmptyObject(t)
              , g = u.speed(o, a, c)
              , v = function() {
                var S = Ne(this, u.extend({}, t), g);
                (p || se.get(this, "finish")) && S.stop(!0)
            };
            return v.finish = v,
            p || g.queue === !1 ? this.each(v) : this.queue(g.queue, v)
        },
        stop: function(t, o, a) {
            var c = function(p) {
                var g = p.stop;
                delete p.stop,
                g(a)
            };
            return typeof t != "string" && (a = o,
            o = t,
            t = void 0),
            o && t !== !1 && this.queue(t || "fx", []),
            this.each(function() {
                var p = !0
                  , g = t != null && t + "queueHooks"
                  , v = u.timers
                  , S = se.get(this);
                if (g)
                    S[g] && S[g].stop && c(S[g]);
                else
                    for (g in S)
                        S[g] && S[g].stop && mn.test(g) && c(S[g]);
                for (g = v.length; g--; )
                    v[g].elem !== this || t != null && v[g].queue !== t || (v[g].anim.stop(a),
                    p = !1,
                    v.splice(g, 1));
                !p && a || u.dequeue(this, t)
            })
        },
        finish: function(t) {
            return t !== !1 && (t = t || "fx"),
            this.each(function() {
                var o, a = se.get(this), c = a[t + "queue"], p = a[t + "queueHooks"], g = u.timers, v = c ? c.length : 0;
                for (a.finish = !0,
                u.queue(this, t, []),
                p && p.stop && p.stop.call(this, !0),
                o = g.length; o--; )
                    g[o].elem === this && g[o].queue === t && (g[o].anim.stop(!0),
                    g.splice(o, 1));
                for (o = 0; o < v; o++)
                    c[o] && c[o].finish && c[o].finish.call(this);
                delete a.finish
            })
        }
    }),
    u.each(["toggle", "show", "hide"], function(t, o) {
        var a = u.fn[o];
        u.fn[o] = function(c, p, g) {
            return c == null || typeof c == "boolean" ? a.apply(this, arguments) : this.animate(St(o, !0), c, p, g)
        }
    }),
    u.each({
        slideDown: St("show"),
        slideUp: St("hide"),
        slideToggle: St("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(t, o) {
        u.fn[t] = function(a, c, p) {
            return this.animate(o, a, c, p)
        }
    }),
    u.timers = [],
    u.fx.tick = function() {
        var t, o = 0, a = u.timers;
        for (tt = Date.now(); o < a.length; o++)
            (t = a[o])() || a[o] !== t || a.splice(o--, 1);
        a.length || u.fx.stop(),
        tt = void 0
    }
    ,
    u.fx.timer = function(t) {
        u.timers.push(t),
        u.fx.start()
    }
    ,
    u.fx.interval = 13,
    u.fx.start = function() {
        $t || ($t = !0,
        Nt())
    }
    ,
    u.fx.stop = function() {
        $t = null
    }
    ,
    u.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    u.fn.delay = function(t, o) {
        return t = u.fx && u.fx.speeds[t] || t,
        o = o || "fx",
        this.queue(o, function(a, c) {
            var p = n.setTimeout(a, t);
            c.stop = function() {
                n.clearTimeout(p)
            }
        })
    }
    ,
    function() {
        var t = f.createElement("input")
          , o = f.createElement("select").appendChild(f.createElement("option"));
        t.type = "checkbox",
        j.checkOn = t.value !== "",
        j.optSelected = o.selected,
        (t = f.createElement("input")).value = "t",
        t.type = "radio",
        j.radioValue = t.value === "t"
    }();
    var Ci, st = u.expr.attrHandle;
    u.fn.extend({
        attr: function(t, o) {
            return He(this, u.attr, t, o, arguments.length > 1)
        },
        removeAttr: function(t) {
            return this.each(function() {
                u.removeAttr(this, t)
            })
        }
    }),
    u.extend({
        attr: function(t, o, a) {
            var c, p, g = t.nodeType;
            if (g !== 3 && g !== 8 && g !== 2)
                return typeof t.getAttribute == "undefined" ? u.prop(t, o, a) : (g === 1 && u.isXMLDoc(t) || (p = u.attrHooks[o.toLowerCase()] || (u.expr.match.bool.test(o) ? Ci : void 0)),
                a !== void 0 ? a === null ? void u.removeAttr(t, o) : p && "set"in p && (c = p.set(t, a, o)) !== void 0 ? c : (t.setAttribute(o, a + ""),
                a) : p && "get"in p && (c = p.get(t, o)) !== null ? c : (c = u.find.attr(t, o)) == null ? void 0 : c)
        },
        attrHooks: {
            type: {
                set: function(t, o) {
                    if (!j.radioValue && o === "radio" && X(t, "input")) {
                        var a = t.value;
                        return t.setAttribute("type", o),
                        a && (t.value = a),
                        o
                    }
                }
            }
        },
        removeAttr: function(t, o) {
            var a, c = 0, p = o && o.match(qe);
            if (p && t.nodeType === 1)
                for (; a = p[c++]; )
                    t.removeAttribute(a)
        }
    }),
    Ci = {
        set: function(t, o, a) {
            return o === !1 ? u.removeAttr(t, a) : t.setAttribute(a, a),
            a
        }
    },
    u.each(u.expr.match.bool.source.match(/\w+/g), function(t, o) {
        var a = st[o] || u.find.attr;
        st[o] = function(c, p, g) {
            var v, S, T = p.toLowerCase();
            return g || (S = st[T],
            st[T] = v,
            v = a(c, p, g) != null ? T : null,
            st[T] = S),
            v
        }
    });
    var yn = /^(?:input|select|textarea|button)$/i
      , wn = /^(?:a|area)$/i;
    u.fn.extend({
        prop: function(t, o) {
            return He(this, u.prop, t, o, arguments.length > 1)
        },
        removeProp: function(t) {
            return this.each(function() {
                delete this[u.propFix[t] || t]
            })
        }
    }),
    u.extend({
        prop: function(t, o, a) {
            var c, p, g = t.nodeType;
            if (g !== 3 && g !== 8 && g !== 2)
                return g === 1 && u.isXMLDoc(t) || (o = u.propFix[o] || o,
                p = u.propHooks[o]),
                a !== void 0 ? p && "set"in p && (c = p.set(t, a, o)) !== void 0 ? c : t[o] = a : p && "get"in p && (c = p.get(t, o)) !== null ? c : t[o]
        },
        propHooks: {
            tabIndex: {
                get: function(t) {
                    var o = u.find.attr(t, "tabindex");
                    return o ? parseInt(o, 10) : yn.test(t.nodeName) || wn.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }),
    j.optSelected || (u.propHooks.selected = {
        get: function(t) {
            var o = t.parentNode;
            return o && o.parentNode && o.parentNode.selectedIndex,
            null
        },
        set: function(t) {
            var o = t.parentNode;
            o && (o.selectedIndex,
            o.parentNode && o.parentNode.selectedIndex)
        }
    }),
    u.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        u.propFix[this.toLowerCase()] = this
    });
    function Ve(t) {
        return (t.match(qe) || []).join(" ")
    }
    function Ge(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }
    function Ot(t) {
        return Array.isArray(t) ? t : typeof t == "string" ? t.match(qe) || [] : []
    }
    u.fn.extend({
        addClass: function(t) {
            var o, a, c, p, g, v, S, T = 0;
            if (L(t))
                return this.each(function(I) {
                    u(this).addClass(t.call(this, I, Ge(this)))
                });
            if ((o = Ot(t)).length) {
                for (; a = this[T++]; )
                    if (p = Ge(a),
                    c = a.nodeType === 1 && " " + Ve(p) + " ") {
                        for (v = 0; g = o[v++]; )
                            c.indexOf(" " + g + " ") < 0 && (c += g + " ");
                        p !== (S = Ve(c)) && a.setAttribute("class", S)
                    }
            }
            return this
        },
        removeClass: function(t) {
            var o, a, c, p, g, v, S, T = 0;
            if (L(t))
                return this.each(function(I) {
                    u(this).removeClass(t.call(this, I, Ge(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ((o = Ot(t)).length) {
                for (; a = this[T++]; )
                    if (p = Ge(a),
                    c = a.nodeType === 1 && " " + Ve(p) + " ") {
                        for (v = 0; g = o[v++]; )
                            for (; c.indexOf(" " + g + " ") > -1; )
                                c = c.replace(" " + g + " ", " ");
                        p !== (S = Ve(c)) && a.setAttribute("class", S)
                    }
            }
            return this
        },
        toggleClass: function(t, o) {
            var a = typeof t
              , c = a === "string" || Array.isArray(t);
            return typeof o == "boolean" && c ? o ? this.addClass(t) : this.removeClass(t) : L(t) ? this.each(function(p) {
                u(this).toggleClass(t.call(this, p, Ge(this), o), o)
            }) : this.each(function() {
                var p, g, v, S;
                if (c)
                    for (g = 0,
                    v = u(this),
                    S = Ot(t); p = S[g++]; )
                        v.hasClass(p) ? v.removeClass(p) : v.addClass(p);
                else
                    t !== void 0 && a !== "boolean" || ((p = Ge(this)) && se.set(this, "__className__", p),
                    this.setAttribute && this.setAttribute("class", p || t === !1 ? "" : se.get(this, "__className__") || ""))
            })
        },
        hasClass: function(t) {
            var o, a, c = 0;
            for (o = " " + t + " "; a = this[c++]; )
                if (a.nodeType === 1 && (" " + Ve(Ge(a)) + " ").indexOf(o) > -1)
                    return !0;
            return !1
        }
    });
    var bn = /\r/g;
    u.fn.extend({
        val: function(t) {
            var o, a, c, p = this[0];
            {
                if (arguments.length)
                    return c = L(t),
                    this.each(function(g) {
                        var v;
                        this.nodeType === 1 && ((v = c ? t.call(this, g, u(this).val()) : t) == null ? v = "" : typeof v == "number" ? v += "" : Array.isArray(v) && (v = u.map(v, function(S) {
                            return S == null ? "" : S + ""
                        })),
                        (o = u.valHooks[this.type] || u.valHooks[this.nodeName.toLowerCase()]) && "set"in o && o.set(this, v, "value") !== void 0 || (this.value = v))
                    });
                if (p)
                    return (o = u.valHooks[p.type] || u.valHooks[p.nodeName.toLowerCase()]) && "get"in o && (a = o.get(p, "value")) !== void 0 ? a : typeof (a = p.value) == "string" ? a.replace(bn, "") : a == null ? "" : a
            }
        }
    }),
    u.extend({
        valHooks: {
            option: {
                get: function(t) {
                    var o = u.find.attr(t, "value");
                    return o != null ? o : Ve(u.text(t))
                }
            },
            select: {
                get: function(t) {
                    var o, a, c, p = t.options, g = t.selectedIndex, v = t.type === "select-one", S = v ? null : [], T = v ? g + 1 : p.length;
                    for (c = g < 0 ? T : v ? g : 0; c < T; c++)
                        if (((a = p[c]).selected || c === g) && !a.disabled && (!a.parentNode.disabled || !X(a.parentNode, "optgroup"))) {
                            if (o = u(a).val(),
                            v)
                                return o;
                            S.push(o)
                        }
                    return S
                },
                set: function(t, o) {
                    for (var a, c, p = t.options, g = u.makeArray(o), v = p.length; v--; )
                        ((c = p[v]).selected = u.inArray(u.valHooks.option.get(c), g) > -1) && (a = !0);
                    return a || (t.selectedIndex = -1),
                    g
                }
            }
        }
    }),
    u.each(["radio", "checkbox"], function() {
        u.valHooks[this] = {
            set: function(t, o) {
                if (Array.isArray(o))
                    return t.checked = u.inArray(u(t).val(), o) > -1
            }
        },
        j.checkOn || (u.valHooks[this].get = function(t) {
            return t.getAttribute("value") === null ? "on" : t.value
        }
        )
    }),
    j.focusin = "onfocusin"in n;
    var _i = /^(?:focusinfocus|focusoutblur)$/
      , ki = function(t) {
        t.stopPropagation()
    };
    u.extend(u.event, {
        trigger: function(t, o, a, c) {
            var p, g, v, S, T, I, F, V, N = [a || f], q = A.call(t, "type") ? t.type : t, K = A.call(t, "namespace") ? t.namespace.split(".") : [];
            if (g = V = v = a = a || f,
            a.nodeType !== 3 && a.nodeType !== 8 && !_i.test(q + u.event.triggered) && (q.indexOf(".") > -1 && (q = (K = q.split(".")).shift(),
            K.sort()),
            T = q.indexOf(":") < 0 && "on" + q,
            t = t[u.expando] ? t : new u.Event(q,typeof t == "object" && t),
            t.isTrigger = c ? 2 : 3,
            t.namespace = K.join("."),
            t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + K.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            t.result = void 0,
            t.target || (t.target = a),
            o = o == null ? [t] : u.makeArray(o, [t]),
            F = u.event.special[q] || {},
            c || !F.trigger || F.trigger.apply(a, o) !== !1)) {
                if (!c && !F.noBubble && !C(a)) {
                    for (S = F.delegateType || q,
                    _i.test(S + q) || (g = g.parentNode); g; g = g.parentNode)
                        N.push(g),
                        v = g;
                    v === (a.ownerDocument || f) && N.push(v.defaultView || v.parentWindow || n)
                }
                for (p = 0; (g = N[p++]) && !t.isPropagationStopped(); )
                    V = g,
                    t.type = p > 1 ? S : F.bindType || q,
                    (I = (se.get(g, "events") || {})[t.type] && se.get(g, "handle")) && I.apply(g, o),
                    (I = T && g[T]) && I.apply && vt(g) && (t.result = I.apply(g, o),
                    t.result === !1 && t.preventDefault());
                return t.type = q,
                c || t.isDefaultPrevented() || F._default && F._default.apply(N.pop(), o) !== !1 || !vt(a) || T && L(a[q]) && !C(a) && ((v = a[T]) && (a[T] = null),
                u.event.triggered = q,
                t.isPropagationStopped() && V.addEventListener(q, ki),
                a[q](),
                t.isPropagationStopped() && V.removeEventListener(q, ki),
                u.event.triggered = void 0,
                v && (a[T] = v)),
                t.result
            }
        },
        simulate: function(t, o, a) {
            var c = u.extend(new u.Event, a, {
                type: t,
                isSimulated: !0
            });
            u.event.trigger(c, null, o)
        }
    }),
    u.fn.extend({
        trigger: function(t, o) {
            return this.each(function() {
                u.event.trigger(t, o, this)
            })
        },
        triggerHandler: function(t, o) {
            var a = this[0];
            if (a)
                return u.event.trigger(t, o, a, !0)
        }
    }),
    j.focusin || u.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, o) {
        var a = function(c) {
            u.event.simulate(o, c.target, u.event.fix(c))
        };
        u.event.special[o] = {
            setup: function() {
                var c = this.ownerDocument || this
                  , p = se.access(c, o);
                p || c.addEventListener(t, a, !0),
                se.access(c, o, (p || 0) + 1)
            },
            teardown: function() {
                var c = this.ownerDocument || this
                  , p = se.access(c, o) - 1;
                p ? se.access(c, o, p) : (c.removeEventListener(t, a, !0),
                se.remove(c, o))
            }
        }
    });
    var lt = n.location
      , Ti = Date.now()
      , zt = /\?/;
    u.parseXML = function(t) {
        var o;
        if (!t || typeof t != "string")
            return null;
        try {
            o = new n.DOMParser().parseFromString(t, "text/xml")
        } catch (a) {
            o = void 0
        }
        return o && !o.getElementsByTagName("parsererror").length || u.error("Invalid XML: " + t),
        o
    }
    ;
    var xn = /\[\]$/
      , Ei = /\r?\n/g
      , $n = /^(?:submit|button|image|reset|file)$/i
      , Sn = /^(?:input|select|textarea|keygen)/i;
    function qt(t, o, a, c) {
        var p;
        if (Array.isArray(o))
            u.each(o, function(g, v) {
                a || xn.test(t) ? c(t, v) : qt(t + "[" + (typeof v == "object" && v != null ? g : "") + "]", v, a, c)
            });
        else if (a || U(o) !== "object")
            c(t, o);
        else
            for (p in o)
                qt(t + "[" + p + "]", o[p], a, c)
    }
    u.param = function(t, o) {
        var a, c = [], p = function(g, v) {
            var S = L(v) ? v() : v;
            c[c.length] = encodeURIComponent(g) + "=" + encodeURIComponent(S == null ? "" : S)
        };
        if (Array.isArray(t) || t.jquery && !u.isPlainObject(t))
            u.each(t, function() {
                p(this.name, this.value)
            });
        else
            for (a in t)
                qt(a, t[a], o, p);
        return c.join("&")
    }
    ,
    u.fn.extend({
        serialize: function() {
            return u.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var t = u.prop(this, "elements");
                return t ? u.makeArray(t) : this
            }).filter(function() {
                var t = this.type;
                return this.name && !u(this).is(":disabled") && Sn.test(this.nodeName) && !$n.test(t) && (this.checked || !ri.test(t))
            }).map(function(t, o) {
                var a = u(this).val();
                return a == null ? null : Array.isArray(a) ? u.map(a, function(c) {
                    return {
                        name: o.name,
                        value: c.replace(Ei, "\r\n")
                    }
                }) : {
                    name: o.name,
                    value: a.replace(Ei, "\r\n")
                }
            }).get()
        }
    });
    var Cn = /%20/g
      , _n = /#.*$/
      , kn = /([?&])_=[^&]*/
      , Tn = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , En = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/
      , An = /^(?:GET|HEAD)$/
      , Dn = /^\/\//
      , Ai = {}
      , Ft = {}
      , Di = "*/".concat("*")
      , Mt = f.createElement("a");
    Mt.href = lt.href;
    function ji(t) {
        return function(o, a) {
            typeof o != "string" && (a = o,
            o = "*");
            var c, p = 0, g = o.toLowerCase().match(qe) || [];
            if (L(a))
                for (; c = g[p++]; )
                    c[0] === "+" ? (c = c.slice(1) || "*",
                    (t[c] = t[c] || []).unshift(a)) : (t[c] = t[c] || []).push(a)
        }
    }
    function Pi(t, o, a, c) {
        var p = {}
          , g = t === Ft;
        function v(S) {
            var T;
            return p[S] = !0,
            u.each(t[S] || [], function(I, F) {
                var V = F(o, a, c);
                return typeof V != "string" || g || p[V] ? g ? !(T = V) : void 0 : (o.dataTypes.unshift(V),
                v(V),
                !1)
            }),
            T
        }
        return v(o.dataTypes[0]) || !p["*"] && v("*")
    }
    function Ht(t, o) {
        var a, c, p = u.ajaxSettings.flatOptions || {};
        for (a in o)
            o[a] !== void 0 && ((p[a] ? t : c || (c = {}))[a] = o[a]);
        return c && u.extend(!0, t, c),
        t
    }
    function jn(t, o, a) {
        for (var c, p, g, v, S = t.contents, T = t.dataTypes; T[0] === "*"; )
            T.shift(),
            c === void 0 && (c = t.mimeType || o.getResponseHeader("Content-Type"));
        if (c) {
            for (p in S)
                if (S[p] && S[p].test(c)) {
                    T.unshift(p);
                    break
                }
        }
        if (T[0]in a)
            g = T[0];
        else {
            for (p in a) {
                if (!T[0] || t.converters[p + " " + T[0]]) {
                    g = p;
                    break
                }
                v || (v = p)
            }
            g = g || v
        }
        if (g)
            return g !== T[0] && T.unshift(g),
            a[g]
    }
    function Pn(t, o, a, c) {
        var p, g, v, S, T, I = {}, F = t.dataTypes.slice();
        if (F[1])
            for (v in t.converters)
                I[v.toLowerCase()] = t.converters[v];
        for (g = F.shift(); g; )
            if (t.responseFields[g] && (a[t.responseFields[g]] = o),
            !T && c && t.dataFilter && (o = t.dataFilter(o, t.dataType)),
            T = g,
            g = F.shift()) {
                if (g === "*")
                    g = T;
                else if (T !== "*" && T !== g) {
                    if (!(v = I[T + " " + g] || I["* " + g])) {
                        for (p in I)
                            if ((S = p.split(" "))[1] === g && (v = I[T + " " + S[0]] || I["* " + S[0]])) {
                                v === !0 ? v = I[p] : I[p] !== !0 && (g = S[0],
                                F.unshift(S[1]));
                                break
                            }
                    }
                    if (v !== !0)
                        if (v && t.throws)
                            o = v(o);
                        else
                            try {
                                o = v(o)
                            } catch (V) {
                                return {
                                    state: "parsererror",
                                    error: v ? V : "No conversion from " + T + " to " + g
                                }
                            }
                }
            }
        return {
            state: "success",
            data: o
        }
    }
    u.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: lt.href,
            type: "GET",
            isLocal: En.test(lt.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Di,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": u.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(t, o) {
            return o ? Ht(Ht(t, u.ajaxSettings), o) : Ht(u.ajaxSettings, t)
        },
        ajaxPrefilter: ji(Ai),
        ajaxTransport: ji(Ft),
        ajax: function(t, o) {
            typeof t == "object" && (o = t,
            t = void 0),
            o = o || {};
            var a, c, p, g, v, S, T, I, F, V, N = u.ajaxSetup({}, o), q = N.context || N, K = N.context && (q.nodeType || q.jquery) ? u(q) : u.event, ae = u.Deferred(), te = u.Callbacks("once memory"), we = N.statusCode || {}, be = {}, Ae = {}, ue = "canceled", re = {
                readyState: 0,
                getResponseHeader: function(de) {
                    var ye;
                    if (T) {
                        if (!g)
                            for (g = {}; ye = Tn.exec(p); )
                                g[ye[1].toLowerCase()] = ye[2];
                        ye = g[de.toLowerCase()]
                    }
                    return ye == null ? null : ye
                },
                getAllResponseHeaders: function() {
                    return T ? p : null
                },
                setRequestHeader: function(de, ye) {
                    return T == null && (de = Ae[de.toLowerCase()] = Ae[de.toLowerCase()] || de,
                    be[de] = ye),
                    this
                },
                overrideMimeType: function(de) {
                    return T == null && (N.mimeType = de),
                    this
                },
                statusCode: function(de) {
                    var ye;
                    if (de)
                        if (T)
                            re.always(de[re.status]);
                        else
                            for (ye in de)
                                we[ye] = [we[ye], de[ye]];
                    return this
                },
                abort: function(de) {
                    var ye = de || ue;
                    return a && a.abort(ye),
                    Ee(0, ye),
                    this
                }
            };
            if (ae.promise(re),
            N.url = ((t || N.url || lt.href) + "").replace(Dn, lt.protocol + "//"),
            N.type = o.method || o.type || N.method || N.type,
            N.dataTypes = (N.dataType || "*").toLowerCase().match(qe) || [""],
            N.crossDomain == null) {
                S = f.createElement("a");
                try {
                    S.href = N.url,
                    S.href = S.href,
                    N.crossDomain = Mt.protocol + "//" + Mt.host != S.protocol + "//" + S.host
                } catch (de) {
                    N.crossDomain = !0
                }
            }
            if (N.data && N.processData && typeof N.data != "string" && (N.data = u.param(N.data, N.traditional)),
            Pi(Ai, N, o, re),
            T)
                return re;
            (I = u.event && N.global) && u.active++ == 0 && u.event.trigger("ajaxStart"),
            N.type = N.type.toUpperCase(),
            N.hasContent = !An.test(N.type),
            c = N.url.replace(_n, ""),
            N.hasContent ? N.data && N.processData && (N.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (N.data = N.data.replace(Cn, "+")) : (V = N.url.slice(c.length),
            N.data && (N.processData || typeof N.data == "string") && (c += (zt.test(c) ? "&" : "?") + N.data,
            delete N.data),
            N.cache === !1 && (c = c.replace(kn, "$1"),
            V = (zt.test(c) ? "&" : "?") + "_=" + Ti++ + V),
            N.url = c + V),
            N.ifModified && (u.lastModified[c] && re.setRequestHeader("If-Modified-Since", u.lastModified[c]),
            u.etag[c] && re.setRequestHeader("If-None-Match", u.etag[c])),
            (N.data && N.hasContent && N.contentType !== !1 || o.contentType) && re.setRequestHeader("Content-Type", N.contentType),
            re.setRequestHeader("Accept", N.dataTypes[0] && N.accepts[N.dataTypes[0]] ? N.accepts[N.dataTypes[0]] + (N.dataTypes[0] !== "*" ? ", " + Di + "; q=0.01" : "") : N.accepts["*"]);
            for (F in N.headers)
                re.setRequestHeader(F, N.headers[F]);
            if (N.beforeSend && (N.beforeSend.call(q, re, N) === !1 || T))
                return re.abort();
            if (ue = "abort",
            te.add(N.complete),
            re.done(N.success),
            re.fail(N.error),
            a = Pi(Ft, N, o, re)) {
                if (re.readyState = 1,
                I && K.trigger("ajaxSend", [re, N]),
                T)
                    return re;
                N.async && N.timeout > 0 && (v = n.setTimeout(function() {
                    re.abort("timeout")
                }, N.timeout));
                try {
                    T = !1,
                    a.send(be, Ee)
                } catch (de) {
                    if (T)
                        throw de;
                    Ee(-1, de)
                }
            } else
                Ee(-1, "No Transport");
            function Ee(de, ye, dt, it) {
                var Oe, ut, Pe, Ue, nt, xe = ye;
                T || (T = !0,
                v && n.clearTimeout(v),
                a = void 0,
                p = it || "",
                re.readyState = de > 0 ? 4 : 0,
                Oe = de >= 200 && de < 300 || de === 304,
                dt && (Ue = jn(N, re, dt)),
                Ue = Pn(N, Ue, re, Oe),
                Oe ? (N.ifModified && ((nt = re.getResponseHeader("Last-Modified")) && (u.lastModified[c] = nt),
                (nt = re.getResponseHeader("etag")) && (u.etag[c] = nt)),
                de === 204 || N.type === "HEAD" ? xe = "nocontent" : de === 304 ? xe = "notmodified" : (xe = Ue.state,
                ut = Ue.data,
                Oe = !(Pe = Ue.error))) : (Pe = xe,
                !de && xe || (xe = "error",
                de < 0 && (de = 0))),
                re.status = de,
                re.statusText = (ye || xe) + "",
                Oe ? ae.resolveWith(q, [ut, xe, re]) : ae.rejectWith(q, [re, xe, Pe]),
                re.statusCode(we),
                we = void 0,
                I && K.trigger(Oe ? "ajaxSuccess" : "ajaxError", [re, N, Oe ? ut : Pe]),
                te.fireWith(q, [re, xe]),
                I && (K.trigger("ajaxComplete", [re, N]),
                --u.active || u.event.trigger("ajaxStop")))
            }
            return re
        },
        getJSON: function(t, o, a) {
            return u.get(t, o, a, "json")
        },
        getScript: function(t, o) {
            return u.get(t, void 0, o, "script")
        }
    }),
    u.each(["get", "post"], function(t, o) {
        u[o] = function(a, c, p, g) {
            return L(c) && (g = g || p,
            p = c,
            c = void 0),
            u.ajax(u.extend({
                url: a,
                type: o,
                dataType: g,
                data: c,
                success: p
            }, u.isPlainObject(a) && a))
        }
    }),
    u._evalUrl = function(t) {
        return u.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            throws: !0
        })
    }
    ,
    u.fn.extend({
        wrapAll: function(t) {
            var o;
            return this[0] && (L(t) && (t = t.call(this[0])),
            o = u(t, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && o.insertBefore(this[0]),
            o.map(function() {
                for (var a = this; a.firstElementChild; )
                    a = a.firstElementChild;
                return a
            }).append(this)),
            this
        },
        wrapInner: function(t) {
            return L(t) ? this.each(function(o) {
                u(this).wrapInner(t.call(this, o))
            }) : this.each(function() {
                var o = u(this)
                  , a = o.contents();
                a.length ? a.wrapAll(t) : o.append(t)
            })
        },
        wrap: function(t) {
            var o = L(t);
            return this.each(function(a) {
                u(this).wrapAll(o ? t.call(this, a) : t)
            })
        },
        unwrap: function(t) {
            return this.parent(t).not("body").each(function() {
                u(this).replaceWith(this.childNodes)
            }),
            this
        }
    }),
    u.expr.pseudos.hidden = function(t) {
        return !u.expr.pseudos.visible(t)
    }
    ,
    u.expr.pseudos.visible = function(t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
    }
    ,
    u.ajaxSettings.xhr = function() {
        try {
            return new n.XMLHttpRequest
        } catch (t) {}
    }
    ;
    var In = {
        0: 200,
        1223: 204
    }
      , ct = u.ajaxSettings.xhr();
    j.cors = !!ct && "withCredentials"in ct,
    j.ajax = ct = !!ct,
    u.ajaxTransport(function(t) {
        var o, a;
        if (j.cors || ct && !t.crossDomain)
            return {
                send: function(c, p) {
                    var g, v = t.xhr();
                    if (v.open(t.type, t.url, t.async, t.username, t.password),
                    t.xhrFields)
                        for (g in t.xhrFields)
                            v[g] = t.xhrFields[g];
                    t.mimeType && v.overrideMimeType && v.overrideMimeType(t.mimeType),
                    t.crossDomain || c["X-Requested-With"] || (c["X-Requested-With"] = "XMLHttpRequest");
                    for (g in c)
                        v.setRequestHeader(g, c[g]);
                    o = function(S) {
                        return function() {
                            o && (o = a = v.onload = v.onerror = v.onabort = v.ontimeout = v.onreadystatechange = null,
                            S === "abort" ? v.abort() : S === "error" ? typeof v.status != "number" ? p(0, "error") : p(v.status, v.statusText) : p(In[v.status] || v.status, v.statusText, (v.responseType || "text") !== "text" || typeof v.responseText != "string" ? {
                                binary: v.response
                            } : {
                                text: v.responseText
                            }, v.getAllResponseHeaders()))
                        }
                    }
                    ,
                    v.onload = o(),
                    a = v.onerror = v.ontimeout = o("error"),
                    v.onabort !== void 0 ? v.onabort = a : v.onreadystatechange = function() {
                        v.readyState === 4 && n.setTimeout(function() {
                            o && a()
                        })
                    }
                    ,
                    o = o("abort");
                    try {
                        v.send(t.hasContent && t.data || null)
                    } catch (S) {
                        if (o)
                            throw S
                    }
                },
                abort: function() {
                    o && o()
                }
            }
    }),
    u.ajaxPrefilter(function(t) {
        t.crossDomain && (t.contents.script = !1)
    }),
    u.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(t) {
                return u.globalEval(t),
                t
            }
        }
    }),
    u.ajaxPrefilter("script", function(t) {
        t.cache === void 0 && (t.cache = !1),
        t.crossDomain && (t.type = "GET")
    }),
    u.ajaxTransport("script", function(t) {
        if (t.crossDomain) {
            var o, a;
            return {
                send: function(c, p) {
                    o = u("<script>").prop({
                        charset: t.scriptCharset,
                        src: t.url
                    }).on("load error", a = function(g) {
                        o.remove(),
                        a = null,
                        g && p(g.type === "error" ? 404 : 200, g.type)
                    }
                    ),
                    f.head.appendChild(o[0])
                },
                abort: function() {
                    a && a()
                }
            }
        }
    });
    var Ii = []
      , Bt = /(=)\?(?=&|$)|\?\?/;
    u.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var t = Ii.pop() || u.expando + "_" + Ti++;
            return this[t] = !0,
            t
        }
    }),
    u.ajaxPrefilter("json jsonp", function(t, o, a) {
        var c, p, g, v = t.jsonp !== !1 && (Bt.test(t.url) ? "url" : typeof t.data == "string" && (t.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && Bt.test(t.data) && "data");
        if (v || t.dataTypes[0] === "jsonp")
            return c = t.jsonpCallback = L(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback,
            v ? t[v] = t[v].replace(Bt, "$1" + c) : t.jsonp !== !1 && (t.url += (zt.test(t.url) ? "&" : "?") + t.jsonp + "=" + c),
            t.converters["script json"] = function() {
                return g || u.error(c + " was not called"),
                g[0]
            }
            ,
            t.dataTypes[0] = "json",
            p = n[c],
            n[c] = function() {
                g = arguments
            }
            ,
            a.always(function() {
                p === void 0 ? u(n).removeProp(c) : n[c] = p,
                t[c] && (t.jsonpCallback = o.jsonpCallback,
                Ii.push(c)),
                g && L(p) && p(g[0]),
                g = p = void 0
            }),
            "script"
    }),
    j.createHTMLDocument = function() {
        var t = f.implementation.createHTMLDocument("").body;
        return t.innerHTML = "<form></form><form></form>",
        t.childNodes.length === 2
    }(),
    u.parseHTML = function(t, o, a) {
        if (typeof t != "string")
            return [];
        typeof o == "boolean" && (a = o,
        o = !1);
        var c, p, g;
        return o || (j.createHTMLDocument ? ((c = (o = f.implementation.createHTMLDocument("")).createElement("base")).href = f.location.href,
        o.head.appendChild(c)) : o = f),
        p = pe.exec(t),
        g = !a && [],
        p ? [o.createElement(p[1])] : (p = li([t], o, g),
        g && g.length && u(g).remove(),
        u.merge([], p.childNodes))
    }
    ,
    u.fn.load = function(t, o, a) {
        var c, p, g, v = this, S = t.indexOf(" ");
        return S > -1 && (c = Ve(t.slice(S)),
        t = t.slice(0, S)),
        L(o) ? (a = o,
        o = void 0) : o && typeof o == "object" && (p = "POST"),
        v.length > 0 && u.ajax({
            url: t,
            type: p || "GET",
            dataType: "html",
            data: o
        }).done(function(T) {
            g = arguments,
            v.html(c ? u("<div>").append(u.parseHTML(T)).find(c) : T)
        }).always(a && function(T, I) {
            v.each(function() {
                a.apply(this, g || [T.responseText, I, T])
            })
        }
        ),
        this
    }
    ,
    u.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, o) {
        u.fn[o] = function(a) {
            return this.on(o, a)
        }
    }),
    u.expr.pseudos.animated = function(t) {
        return u.grep(u.timers, function(o) {
            return t === o.elem
        }).length
    }
    ,
    u.offset = {
        setOffset: function(t, o, a) {
            var c, p, g, v, S, T, I, F = u.css(t, "position"), V = u(t), N = {};
            F === "static" && (t.style.position = "relative"),
            S = V.offset(),
            g = u.css(t, "top"),
            T = u.css(t, "left"),
            (I = (F === "absolute" || F === "fixed") && (g + T).indexOf("auto") > -1) ? (v = (c = V.position()).top,
            p = c.left) : (v = parseFloat(g) || 0,
            p = parseFloat(T) || 0),
            L(o) && (o = o.call(t, a, u.extend({}, S))),
            o.top != null && (N.top = o.top - S.top + v),
            o.left != null && (N.left = o.left - S.left + p),
            "using"in o ? o.using.call(t, N) : V.css(N)
        }
    },
    u.fn.extend({
        offset: function(t) {
            if (arguments.length)
                return t === void 0 ? this : this.each(function(p) {
                    u.offset.setOffset(this, t, p)
                });
            var o, a, c = this[0];
            if (c)
                return c.getClientRects().length ? (o = c.getBoundingClientRect(),
                a = c.ownerDocument.defaultView,
                {
                    top: o.top + a.pageYOffset,
                    left: o.left + a.pageXOffset
                }) : {
                    top: 0,
                    left: 0
                }
        },
        position: function() {
            if (this[0]) {
                var t, o, a, c = this[0], p = {
                    top: 0,
                    left: 0
                };
                if (u.css(c, "position") === "fixed")
                    o = c.getBoundingClientRect();
                else {
                    for (o = this.offset(),
                    a = c.ownerDocument,
                    t = c.offsetParent || a.documentElement; t && (t === a.body || t === a.documentElement) && u.css(t, "position") === "static"; )
                        t = t.parentNode;
                    t && t !== c && t.nodeType === 1 && ((p = u(t).offset()).top += u.css(t, "borderTopWidth", !0),
                    p.left += u.css(t, "borderLeftWidth", !0))
                }
                return {
                    top: o.top - p.top - u.css(c, "marginTop", !0),
                    left: o.left - p.left - u.css(c, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var t = this.offsetParent; t && u.css(t, "position") === "static"; )
                    t = t.offsetParent;
                return t || wt
            })
        }
    }),
    u.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, o) {
        var a = o === "pageYOffset";
        u.fn[t] = function(c) {
            return He(this, function(p, g, v) {
                var S;
                if (C(p) ? S = p : p.nodeType === 9 && (S = p.defaultView),
                v === void 0)
                    return S ? S[o] : p[g];
                S ? S.scrollTo(a ? S.pageXOffset : v, a ? v : S.pageYOffset) : p[g] = v
            }, t, c, arguments.length)
        }
    }),
    u.each(["top", "left"], function(t, o) {
        u.cssHooks[o] = pi(j.pixelPosition, function(a, c) {
            if (c)
                return c = at(a, o),
                It.test(c) ? u(a).position()[o] + "px" : c
        })
    }),
    u.each({
        Height: "height",
        Width: "width"
    }, function(t, o) {
        u.each({
            padding: "inner" + t,
            content: o,
            "": "outer" + t
        }, function(a, c) {
            u.fn[c] = function(p, g) {
                var v = arguments.length && (a || typeof p != "boolean")
                  , S = a || (p === !0 || g === !0 ? "margin" : "border");
                return He(this, function(T, I, F) {
                    var V;
                    return C(T) ? c.indexOf("outer") === 0 ? T["inner" + t] : T.document.documentElement["client" + t] : T.nodeType === 9 ? (V = T.documentElement,
                    Math.max(T.body["scroll" + t], V["scroll" + t], T.body["offset" + t], V["offset" + t], V["client" + t])) : F === void 0 ? u.css(T, I, S) : u.style(T, I, F, S)
                }, o, v ? p : void 0, v)
            }
        })
    }),
    u.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(t, o) {
        u.fn[o] = function(a, c) {
            return arguments.length > 0 ? this.on(o, null, a, c) : this.trigger(o)
        }
    }),
    u.fn.extend({
        hover: function(t, o) {
            return this.mouseenter(t).mouseleave(o || t)
        }
    }),
    u.fn.extend({
        bind: function(t, o, a) {
            return this.on(t, null, o, a)
        },
        unbind: function(t, o) {
            return this.off(t, null, o)
        },
        delegate: function(t, o, a, c) {
            return this.on(o, t, a, c)
        },
        undelegate: function(t, o, a) {
            return arguments.length === 1 ? this.off(t, "**") : this.off(o, t || "**", a)
        }
    }),
    u.proxy = function(t, o) {
        var a, c, p;
        if (typeof o == "string" && (a = t[o],
        o = t,
        t = a),
        L(t))
            return c = h.call(arguments, 2),
            p = function() {
                return t.apply(o || this, c.concat(h.call(arguments)))
            }
            ,
            p.guid = t.guid = t.guid || u.guid++,
            p
    }
    ,
    u.holdReady = function(t) {
        t ? u.readyWait++ : u.ready(!0)
    }
    ,
    u.isArray = Array.isArray,
    u.parseJSON = JSON.parse,
    u.nodeName = X,
    u.isFunction = L,
    u.isWindow = C,
    u.camelCase = Fe,
    u.type = U,
    u.now = Date.now,
    u.isNumeric = function(t) {
        var o = u.type(t);
        return (o === "number" || o === "string") && !isNaN(t - parseFloat(t))
    }
    ,
    typeof define == "function" && define.amd && define("jquery", [], function() {
        return u
    });
    var Ln = n.jQuery
      , Nn = n.$;
    return u.noConflict = function(t) {
        return n.$ === u && (n.$ = Nn),
        t && n.jQuery === u && (n.jQuery = Ln),
        u
    }
    ,
    r || (n.jQuery = n.$ = u),
    u
});
var usePageDots = !1
  , imageFunctions = {
    zoom: function(n, r, s) {
        var f = $(n).data("zoom");
        f && $(n + " img").wrap('<span style="display:inline-block"></span>').css("display", "block").parent().zoom({
            touch: r,
            magnify: s || 1
        })
    },
    linkGalleryAndCarousel: function(n, r) {
        r.find(".gallery-cell:nth-child(1)").addClass("is-nav-selected"),
        r.on("click", ".gallery-cell", function() {
            var s = $(this).index();
            r.find(".is-nav-selected").removeClass("is-nav-selected"),
            $(this).addClass("is-nav-selected"),
            n.flickity("select", s)
        }),
        n.on("select.flickity", function() {
            var s = $(this).data("flickity");
            s && (r.find(".is-nav-selected").removeClass("is-nav-selected"),
            r.find(".gallery-cell:nth-child(" + (s.selectedIndex + 1) + ")").addClass("is-nav-selected"))
        })
    },
    fullWidth: function(n, r) {
        $(n).each(function() {
            var s = $(this)
              , f = s.attr("alt")
              , l = s.attr("src");
            if (f.indexOf("[") >= 0) {
                s.remove();
                var h = f.match(/\[(.*?)\]/ig);
                f = f.replace(/\[(.*?)\]/ig, "");
                var d = $.map(h, function(k, A) {
                    return k = k.replace(/[\[\]']+/g, ""),
                    k
                })
                  , m = ['<div class="position-' + (d.length ? d : "center") + ' caption js-caption">', '<div class="caption-content caption-background-false align-' + (d.length ? d : "center") + '">', '<p class="headline">' + f + "</p>", "</div>", "</div>"].join("");
                s.attr({
                    alt: f,
                    class: "lazyload fade-in",
                    src: l,
                    dataSizes: "auto"
                });
                var w = s.prop("outerHTML")
                  , _ = '<div class="banner">' + w + m + "</div>";
                $(r).append(_)
            }
        })
    },
    showSecondaryImage: function() {
        $(window).width() > 798 && ($("body").on("mouseenter", ".swap-true", function() {
            $(this).toggleClass("toggle-images")
        }),
        $("body").on("mouseleave", ".swap-true", function() {
            $(this).toggleClass("toggle-images")
        }))
    }
}
  , recentlyViewed = {
    init: function() {
        var n, r, s, f, l;
        if ($(".js-product_section[data-rv-handle]").length ? (n = $(".js-product_section").data("rv-handle").toString(),
        r = Cookies.get("recentlyViewed"),
        s = recentlyViewed.getCookieProducts(r, n)) : ($(".recently-viewed__section").length || $(".collection-template-section .js-sidebar-recently-viewed").length) && (r = Cookies.get("recentlyViewed"),
        s = recentlyViewed.getCookieProducts(r, n)),
        s && (l = unescape(s).split(",")),
        n ? (!$.inArray(n, l) !== -1 && (f = [],
        l.unshift(n),
        $.each(l, function(d, m) {
            $.inArray(m, f) === -1 && f.push(m)
        })),
        recentlyViewed.setCookieProducts(f)) : f = l,
        $(".recently-viewed__section").length) {
            var h = ".recently-viewed__section";
            recentlyViewed.getProductInformation(h, f)
        } else if ($(".js-recently-viewed .rv-main").length) {
            var h = ".js-recently-viewed";
            recentlyViewed.getProductInformation(h, f, n)
        }
        if ($(".sidebar .js-sidebar-recently-viewed").length) {
            var h = ".sidebar .js-sidebar-recently-viewed";
            n ? recentlyViewed.getProductInformation(h, f, n) : recentlyViewed.getProductInformation(h, f),
            $(".js-sidebar-recently-viewed.hidden").parents(".sidebar-block").hide()
        }
    },
    getCookieProducts: function(n, r) {
        return !n && r && Cookies.set("recentlyViewed", r, {
            expires: 30,
            path: "/"
        }),
        n = Cookies.get("recentlyViewed"),
        n
    },
    setCookieProducts: function(n) {
        Cookies.set("recentlyViewed", escape(n.join(",")), {
            expires: 30,
            path: "/"
        })
    },
    getProductInformation: function(n, r, s) {
        s && r.splice($.inArray(s, r), 1);
        var f = $(n).data("visible-products");
        f && r && (r = r.slice(0, f)),
        $.each(r, function(l, h) {
            h && ($(n).removeClass("hidden"),
            $(n).parents(".sidebar-block").show(),
            $.ajax({
                type: "GET",
                url: "/products/" + h + "?view=rv",
                success: function(d) {
                    var m = $(d).find(".js-recently-viewed-product");
                    $(n).find(" .rv-box-" + l).append(m)
                },
                error: function(d, m, w) {
                    console.log(d),
                    console.log(m),
                    console.log(w)
                },
                dataType: "html"
            })),
            $(n).find(".rv-main").hasClass("js-rv-slider") ? (r.length <= f ? $(".js-rv-slider .gallery-cell").eq(r.length).nextAll().addBack().remove() : $(".js-rv-slider .gallery-cell").eq(f).nextAll().addBack().remove(),
            recentlyViewed.createSlider(n, f)) : $(n).find(".rv-main").hasClass("js-rv-grid") && (r.length <= f ? $(".js-rv-grid .thumbnail").eq(r.length).nextAll().addBack().remove() : $(".js-rv-grid .thumbnail").eq(f).nextAll().addBack().remove())
        })
    },
    createSlider: function(n, r) {
        var s = $(".js-rv-slider").data("products-per-slide"), f = $(".js-rv-slider").data("products-limit"), l = r, h = r - 1, d = $(".js-rv-slider").find(".gallery-cell"), m, w, _, k, A;
        s == "2" && l > s && f > s || s == "4" && l > s && f > s || s == "6" && l > s && f > s ? m = "left" : m = "center",
        l > s && f > s ? (w = !0,
        _ = !0,
        k = !0) : (w = !1,
        _ = !1,
        k = !1),
        s == "2" && l > s || s == "4" && l > s || s == "6" && l > s ? A = 0 : s == "3" && l ? A = 1 : s == "5" && l ? A = 2 : s == "7" && l && (A = 3),
        $(window).width() <= 798 && (m = "center",
        A = 1,
        d.length <= 2 ? (w = !1,
        _ = !1,
        k = !1) : l > 3 && f > 3 ? (w = !0,
        _ = !0,
        k = !0) : (w = !1,
        _ = !1,
        k = !1),
        $(".js-rv-slider").parents(".even-num-slides").removeClass("even-num-slides")),
        $(".js-rv-slider").flickity({
            lazyLoad: 2,
            imagesLoaded: !0,
            draggable: w,
            prevNextButtons: _,
            wrapAround: k,
            cellAlign: m,
            pageDots: usePageDots,
            contain: !0,
            freeScroll: !0,
            arrowShape: arrowSize,
            initialIndex: A
        }),
        $(".js-rv-slider").addClass("slider-initialized")
    }
}
  , featuredCollectionSection = {
    init: function() {
        $(".js-product-slider .products-slider").each(function(n, r) {
            var s = $(this).data("products-per-slide"), f = $(this).data("products-limit"), l = $(this).data("products-available"), h, d, m, w, _;
            s == "2" && l > s && f > s || s == "4" && l > s && f > s || s == "6" && l > s && f > s ? h = "left" : h = "center",
            l > s && f > s ? (d = !0,
            m = !0,
            w = !0) : (d = !1,
            m = !1,
            w = !1),
            s == "2" && l > s || s == "4" && l > s || s == "6" && l > s ? _ = 0 : s == "3" && l ? _ = 1 : s == "5" && l ? _ = 2 : s == "7" && l && (_ = 3),
            $(window).width() <= 798 && (h = "center",
            d = !0,
            m = !0,
            w = !0,
            _ = 1,
            $(this).parents(".even-num-slides").removeClass("even-num-slides")),
            $(this).flickity({
                lazyLoad: 2,
                imagesLoaded: !0,
                draggable: d,
                snapInterval:1,
                prevNextButtons: m,
                wrapAround: w,
                cellAlign: h,
                pageDots: usePageDots,
                contain: !0,
                freeScroll: !0,
                arrowShape: arrowSize,
                initialIndex: _
            }),
            $(this).addClass("slider-initialized")
        })
    },
    unload: function(n) {
        var r = n.find(".js-product-slider");
        r.hasClass("flickity-enabled") && r.flickity("destroy")
    }
}
  , featuredPromotions = {
    init: function() {
        ($(window).width() > 798 || $(window).width() == 0) && ($(".feature-overlay").hover(function() {
            $(this).find(".feature-details").slideDown("100", function() {
                $(this).addClass("reveal-details")
            })
        }, function() {
            $(this).find(".feature-details").removeClass("reveal-details"),
            $(this).find(".feature-details").slideUp("100")
        }),
        $(".js-featured-promotions").each(function(n, r) {
            var s = $(this)
              , f = $(this).data("promo-animation");
            s.waypoint(function() {
                $(this.element).find(".feature-section").addClass("animated " + f)
            }, {
                offset: "80%"
            })
        }))
    }
}
  , slideshow = {
    init: function() {
        $(".js-homepage-slideshow").each(function(n, r) {
            var s = $(this)
              , f = {
                slideshowSpeed: s.data("slideshow-speed") * 1e3,
                slideshowTextAnimation: s.data("slideshow-text-animation"),
                adaptiveHeight: s.data("adaptive-height")
            };
            if (!s.hasClass("flickity-enabled")) {
                var l = s.find(".gallery-cell").length !== 1;
                if (s.flickity({
                    adaptiveHeight: f.adaptiveHeight,
                    wrapAround: !0,
                    cellAlign: "left",
                    imagesLoaded: !0,
                    prevNextButtons: l,
                    draggable: l,
                    pageDots: usePageDots,
                    autoPlay: f.slideshowSpeed,
                    arrowShape: arrowSize
                }),
                f.slideshowTextAnimation != "") {
                    var h = s.data("flickity");
                    setTimeout(function() {
                        s.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + f.slideshowTextAnimation)
                    }, 400),
                    s.on("select.flickity", function() {
                        if (s.is(":visible")) {
                            var d = h.selectedIndex + 1;
                            setTimeout(function() {
                                s.find(".caption-content").removeClass("animated " + f.slideshowTextAnimation),
                                s.find(".gallery-cell:nth-child(" + d + ") .caption-content").addClass("animated " + f.slideshowTextAnimation)
                            }, 400)
                        }
                    })
                }
            }
            s.find(".gallery-cell").length > 1 ? s.addClass("multi-image") : s.addClass("single-image"),
            s.find(".gallery-cell").each(function() {
                var d = 0;
                $(this).find(".action_button").each(function() {
                    $button = $(this),
                    $(this).width() > d && (d = $(this).width())
                }),
                $(this).find(".action_button").width(d)
            })
        })
    },
    unload: function(n) {
        var r = n.find(".js-homepage-slideshow");
        r.flickity("destroy")
    }
}
  , testimonial = {
    init: function() {
        $(".js-testimonial").each(function(n, r) {
            var s = $(this)
              , f = {
                slideshowSpeed: s.data("slideshow-speed") * 1e3,
                slideshowTextAnimation: s.data("slideshow-text-animation")
            };
            if ($(".testimonial-image").length > 0 && $(".testimonial-block").each(function() {
                if ($(this).find(".testimonial-image").length == 0) {
                    var d = $(this).closest(".testimonial-block");
                    $(d).addClass("set-testimonial-height")
                }
            }),
            !s.hasClass("flickity-enabled")) {
                var l = s.find(".gallery-cell").length !== 1;
                if (s.flickity({
                    wrapAround: !0,
                    cellAlign: "left",
                    imagesLoaded: !0,
                    prevNextButtons: l,
                    draggable: l,
                    pageDots: usePageDots,
                    autoPlay: f.slideshowSpeed,
                    arrowShape: arrowSize
                }),
                f.slideshowTextAnimation != "") {
                    var h = s.data("flickity");
                    setTimeout(function() {
                        s.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + f.slideshowTextAnimation)
                    }, 400),
                    s.on("select.flickity", function() {
                        if (s.is(":visible")) {
                            var d = h.selectedIndex + 1;
                            setTimeout(function() {
                                s.find(".caption-content").removeClass("animated " + f.slideshowTextAnimation),
                                s.find(".gallery-cell:nth-child(" + d + ") .caption-content").addClass("animated " + f.slideshowTextAnimation)
                            }, 400)
                        }
                    })
                }
            }
            s.find(".gallery-cell").length > 1 ? s.addClass("multi-image") : s.addClass("single-image"),
            s.find(".gallery-cell").each(function() {
                var d = 0;
                $(this).find(".action_button").each(function() {
                    $button = $(this),
                    $(this).width() > d && (d = $(this).width())
                }),
                $(this).find(".action_button").width(d)
            })
        })
    },
    unload: function(n) {
        var r = n.find(".js-testimonial");
        r.flickity("destroy")
    }
}
  , gallery = {
    init: function() {
        $(".gallery-horizontal").find(".gallery-image-wrapper").each(function() {
            var n = $(this), r = $(this).find("img"), s, f;
            $("<img />").attr("src", $(r).attr("src")).on("load", function() {
                s = this.width,
                f = this.height,
                $(n).css("flex-basis", s * 200 / f),
                $(n).css("flex-grow", s * 200 / f),
                $(n).find("i").css("padding-bottom", f / s * 100 + "%")
            })
        }),
        lightboxGallery.init()
    }
}
  , supports_video = function() {
    return !!document.createElement("video").canPlayType
}
  , videoSection = {
    init: function() {
        var n, r;
        $(".homepage-video").each(function(s, f) {
            $(".homepage-video").length && supports_video() && (n = $(this),
            r = videoSection.getVideoSettings(n),
            is_touch_device() && $(window).width() <= 798 && r.posterImage === !1 || $(window).width() <= 798 && r.posterImage === !1 || r.autoPlayVideo && $(window).width() > 798 || r.autoPlayVideo === !1 && r.posterImage === !1 ? videoSection.appendFrame(n, r) : (n.find(".homepage-video__placeholder").show(),
            n.find(".placeholder-svg--video").show()))
        }),
        $("body").on("click", ".video__play-button", function(s) {
            n = $(this).parents(".video-section").find(".homepage-video"),
            $(this).fadeOut(),
            r = videoSection.getVideoSettings(n),
            n.find(".mediaWrapper").length < 1 && n.find("video").length < 1 && videoSection.appendFrame(n, r)
        }),
        $("body").on("click", "[data-play-video]", function(s) {
            n = $(this).parents(".video-section").find(".homepage-video"),
            $(this).fadeOut(),
            r = videoSection.getVideoSettings(n),
            n.find(".mediaWrapper").length < 1 && n.find("video").length < 1 && videoSection.appendFrame(n, r)
        })
    },
    getVideoSettings: function(n) {
        var r = {
            container: n.find(".homepage-video"),
            header: n.find(".homepage-video--media"),
            posterImage: n.data("poster-image"),
            videoText: n.find(".homepage-video--media .caption"),
            videoTrigger: n.find("[data-play-video]"),
            autoPlayVideo: n.data("autoplay"),
            displayTextOverVideo: n.data("display-text-over-video"),
            autoloop: n.data("autoloop"),
            id: n.attr("data-video-src"),
            aspectRatio: n.attr("data-aspect-ratio").split(":"),
            provider: n.attr("data-provider").toLowerCase(),
            videoMP4: n.attr("data-video-mp4"),
            videoOGV: n.attr("data-video-ogv")
        };
        return r
    },
    createFrame: function(n) {
        var r, s, f, l, h = "";
        return n.provider === "youtube" ? (n.autoloop ? r = "1&iv_load_policy=3&playlist=" + n.id : r = 0,
        n.posterImage === !1 && n.autoPlayVideo === !1 ? l = 0 : l = 1,
        s = 1,
        f = '<iframe src="//www.youtube.com/embed/' + n.id + "?&autoplay=" + l + "&loop=" + r + '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>') : n.provider === "vimeo" ? (n.posterImage === !1 && n.autoPlayVideo === !1 ? l = 0 : l = 1,
        n.autoloop ? r = 1 : r = 0,
        f = '<iframe src="//player.vimeo.com/video/' + n.id + "?loop=" + r + "&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=" + l + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>') : n.provider === "html5" && (n.posterImage !== !1 && (h = ' poster="https://' + n.posterImage),
        n.posterImage === !1 && n.autoPlayVideo === !1 && is_touch_device() === 0 ? l = " " : (n.autoPlayVideo && n.posterImage !== !1 && (h = ' poster="https://' + n.posterImage),
        l = " autoplay "),
        n.autoloop && (r = ' loop="loop" '),
        s = "",
        f = "<video " + s + l + r + h + ' id="video" onclick="this.paused?this.play():this.pause();" ><source src="' + n.videoMP4 + '" type="video/mp4"><source src="' + n.videoOGV + '" type="video/ogg" ></video>'),
        f
    },
    appendFrame: function(n, r) {
        var s;
        if (r.displayTextOverVideo === !1 && r.videoText.fadeOut(),
        n.find(".video__play-button").fadeOut(),
        n.append(videoSection.createFrame(r)),
        r.provider != "html5") {
            var f = r.aspectRatio[1] / r.aspectRatio[0] * 100 + "%";
            n.find("iframe").mediaWrapper({
                intrinsic: !1,
                baseWidth: r.aspectRatio[0],
                baseHeight: r.aspectRatio[1]
            }),
            n.css({
                height: 0,
                paddingBottom: f
            })
        } else
            n.find(".homepage-video__image").hide()
    },
    unload: function(n) {
        n.find("[data-play-video]").off("click")
    }
}
  , cart = {
    init: function() {
        $("#cart_form .tos_agree").length && $("body").on("click", "#cart_form input[type='submit']", function() {
            if ($(this).parents("form").find(".tos_agree").is(":checked"))
                $(this).submit();
            else {
                var n = '<p class="warning animated bounceIn">You must agree with the terms and conditions to checkout.</p>';
                return $("p.warning").length == 0 && $(this).before(n),
                !1
            }
        })
    }
};
selectCallback = function(n, r) {
    var s = $(".product-" + r.product.id)
      , f = $(".notify-form-" + r.product.id)
      , l = $(".product_form", s)
      , h = l.data("variant-inventory");
    if (n && n.featured_image && s.is(":visible")) {
        var d = $(".product_gallery", s);
        d.each(function() {
            var A = $(this)
              , x = Flickity.data(this);
            if (A.is(":visible") && x != null) {
                var E = $('[data-image-id="' + n.featured_image.id + '"]').data("index");
                x.select(E, !1, !0)
            }
        })
    }
    if (n) {
        h && h.forEach(function(A) {
            A.id === n.id && (n.inventory_quantity = A.inventory_quantity,
            n.inventory_management = A.inventory_management,
            n.inventory_policy = A.inventory_policy)
        }),
        $(".sku span", s).text(n.sku);
        for (var m = 0, w = n.options.length; m < w; m++) {
            var _ = l.find('.swatch[data-option-index="' + escape(m) + '"] :radio[value="' + n.options[m].replace(/\"/g, '\\"') + '"]');
            _.length && (_.get(0).checked = !0)
        }
    }
    if (n && n.available == !0)
        n.price < n.compare_at_price ? ($(".was_price", s).html('<span class="money">' + Shopify.formatMoney(n.compare_at_price, l.data("money-format")) + "</span>"),
        $(".savings", s).html("You Save " + parseInt((n.compare_at_price - n.price) * 100 / n.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(n.compare_at_price - n.price, l.data("money-format")) + "</span>)"),
        $(".current_price", s).parent().addClass("sale")) : ($(".was_price", s).html(""),
        $(".savings", s).html(""),
        $(".current_price", s).parent().removeClass("sale")),
        n.inventory_management && n.inventory_quantity > 0 || ($(".items_left", s).text(""),
        $(".quantity", s).removeAttr("max")),
        $(".sold_out", s).text(""),
        n.price > 0 ? $(".current_price", s).html('<span class="money">' + Shopify.formatMoney(n.price, l.data("money-format")) + "</span>") : $(".current_price", s).html("Free"),
        $(".add_to_cart", s).removeClass("disabled").removeAttr("disabled").find("span").text($(".add_to_cart", s).data("label")),
        $(".shopify-payment-button", s).show(),
        f.hide();
    else {
        var k = n ? "Sold Out" : "Unavailable";
        $(".was_price", s).text(""),
        $(".savings", s).text(""),
        $(".current_price", s).text(""),
        $(".items_left", s).text(""),
        $(".quantity", s).removeAttr("max"),
        $(".sold_out", s).text(k),
        $(".add_to_cart", s).addClass("disabled").attr("disabled", "disabled").find("span").text(k),
        $(".shopify-payment-button", s).hide(),
        f.hide(),
        n && !n.available && f.fadeIn()
    }
}
;
var productPage = {
    init: function() {
        var n = !0
          , r = !0
          , s = $(".product_gallery").data("autoplay");
        setTimeout(function() {
            imageFunctions.linkGalleryAndCarousel($(".js-product-page-gallery .product_gallery"), $(".js-product-page-gallery .product_gallery_nav"))
        }, 1e3),
        imageFunctions.zoom(".product_gallery", !1),
        $(".js-full-width-product-images").length && imageFunctions.fullWidth(".product-template .product .description img", ".js-full-width-product-images"),
        $(".product_gallery").hasClass("single-image") && (n = !1,
        r = !1),
        $(".product_gallery").flickity({
            adaptiveHeight: !0,
            wrapAround: "true",
            cellAlign: "left",
            draggable: n,
            contain: !0,
            imagesLoaded: !0,
            lazyLoad: 2,
            pageDots: usePageDots,
            prevNextButtons: r,
            autoPlay: s ? 6e3 : !1,
            selectedAttraction: .01,
            friction: .15,
            arrowShape: arrowSize
        }),
        $(".js-product_section .product_form_options").each(function() {
            new Shopify.OptionSelectors($(this).data("select-id"),{
                product: $(this).data("product"),
                onVariantSelected: selectCallback,
                enableHistoryState: $(this).data("enable-state")
            })
        });
        var f = $(".notify_form .contact-form");
        f.each(function() {
            var l = $(this);
            l.on("submit", function(h) {
                $('input[name="challenge"]', l).val() !== "true" && ($.ajax({
                    type: l.attr("method"),
                    url: l.attr("action"),
                    data: l.serialize(),
                    success: function(d) {
                        l.fadeOut("slow", function() {
                            l.prev(".message").html("Thanks! We will notify you when this product becomes available!")
                        })
                    },
                    error: function(d) {
                        $('input[name="challenge"]', l).val("true"),
                        l.submit()
                    }
                }),
                h.preventDefault())
            })
        }),
        $("body").on("change", ".swatch :radio", function() {
            var l = $(this).closest(".swatch").attr("data-option-index")
              , h = $(this).val()
              , d = $(this).closest(".product_form");
            if (d.siblings(".notify_form").length)
                var m = d.siblings(".notify_form");
            else
                var m = $(".js-notify-form");
            var w = d.find(".swatch_options input:checked").eq(0).val()
              , _ = d.find(".swatch_options input:checked").eq(1).val() || ""
              , k = d.find(".swatch_options input:checked").eq(2).val() || "";
            if (w && _ && k)
                var A = w + " / " + _ + " / " + k;
            else if (w && _)
                var A = w + " / " + _;
            else
                var A = w;
            m.find(".notify_form_message").attr("value", m.find(".notify_form_message").data("body") + " - " + A),
            $(this).closest("form").find(".single-option-selector").eq(l).val(h).trigger("change")
        }),
        lightboxGallery.init()
    },
    productSwatches: function() {
        if ($(".js-product_section").length) {
            var n = $(".js-product_section").find(".product_form");
            n.addClass("is-visible"),
            n.each(function() {
                var r = $(this).data("product")
                  , s = $(this).data("product-id")
                  , f = ".product-" + s + " .js-product_section"
                  , l = $(this).find(".swatch_options .swatch");
                l.length > 1 && Shopify.linkOptionSelectors(r, f)
            })
        }
        $(".js-product_section").length > 1 && $("body").on("click", ".swatch-element", function() {
            var r = $(this).data("value");
            $(this).siblings('input[value="' + r.replace(/\"/g, '\\"') + '"]').prop("checked", !0).trigger("change");
            var s = $(this).parents(".product_form").data("product")
              , f = $(this).parents(".product_form").data("product-id")
              , l = ".product-" + f + " .js-product_section"
              , h = $(this).parents(".product_form").find(".swatch_options .swatch");
            h.length > 1 && Shopify.linkOptionSelectors(s, l)
        })
    },
    relatedProducts: function() {
        $(".js-related-products-slider .products-slider").each(function(n, r) {
            var s = $(this).data("products-per-slide"), f = $(this).data("products-limit"), l = $(this).data("products-available"), h, d, m, w, _;
            s == "2" && l > s && f > s || s == "4" && l > s && f > s || s == "6" && l > s && f > s ? h = "left" : h = "center",
            l > s && f > s ? (d = !0,
            m = !0,
            w = !0) : (d = !1,
            m = !1,
            w = !1),
            s == "2" && l > s || s == "4" && l > s || s == "6" && l > s ? _ = 0 : s == "3" && l ? _ = 1 : s == "5" && l ? _ = 2 : s == "7" && l && (_ = 3),
            $(window).width() <= 798 && (h = "center",
            d = !0,
            m = !0,
            w = !0,
            _ = 1,
            $(this).parents(".even-num-slides").removeClass("even-num-slides")),
            $(this).flickity({
                lazyLoad: 2,
                imagesLoaded: !0,
                draggable: d,
                cellAlign: h,
                prevNextButtons: m,
                wrapAround: w,
                pageDots: usePageDots,
                contain: !0,
                freeScroll: !0,
                arrowShape: arrowSize,
                initialIndex: _
            })
        })
    },
    initializeQuantityBox: function() {
        $("body").on("click", ".js-change-quantity", function() {
            var n = $(this)
              , r = $(this).siblings("input")
              , s = parseInt(r.val())
              , f = 1e29
              , l = r.attr("min") || 0;
            if (r.attr("max") != null && (f = r.attr("max")),
            isNaN(s) || s < l)
                return r.val(l),
                !1;
            if (s > f)
                return r.val(f),
                !1;
            n.data("func") == "plus" ? s < f && r.val(s + 1) : (s > l && r.val(s - 1),
            n.parents(".cart_item").length && s - 1 == 0 && n.closest(".cart_item").addClass("animated fadeOutUp")),
            r.trigger("change")
        })
    },
    unload: function(n) {
        var r = n.find(".products-slider");
        r.flickity("destroy")
    }
}
  , newsletter_popup = {
    init: function() {
        var n = Cookies.get("popup")
          , r = !0;
        if (r && n == "open")
            return !1;
        newsletter_popup.open(),
        r && Cookies.set("popup", "open", {
            expires: 14
        })
    },
    open: function() {
        $(window).width() > 798 && setTimeout(function() {
            $("[data-remodal-id=newsletter]").remodal().open()
        }, 0 * 1e3)
    }
}
  , header = {
    init: function() {
        var n = function() {
            $("body").removeClass("is-active"),
            $(".dropdown_link").removeClass("active_link"),
            $(".dropdown_container").hide(),
            $(".mobile_nav").find("div").removeClass("open")
        }
          , r = function() {
            $("body").removeClass("is-active").removeClass("blocked-scroll"),
            $(".dropdown_link").toggleClass("active_link"),
            $(".cart_container").removeClass("active_link")
        }
          , s = function(h) {
            $("body").addClass("blocked-scroll"),
            $(".mobile_nav div").removeClass("open"),
            $(".dropdown_link").removeClass("active_link"),
            h.addClass("active_link")
        };
        if ($(".dropdown_link--vertical").length && ($(".dropdown_link--vertical, .vertical-menu_submenu").on("mouseover", function(h) {
            var d = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
              , m = $(this).attr("data-click-count");
            $(".active_link").removeClass("active_link"),
            $(this).hasClass("active_link") || ($(this).children("a").addClass("active_link"),
            $(".is-absolute").parent().removeClass("feature_image"))
        }),
        is_touch_device() && $(".vertical-menu .sublink a, .vertical-menu_submenu .sublink a").on("touchstart click", function(h) {
            h.stopPropagation();
            var d = $(this);
            h.type == "touchstart" ? (clicked = !0,
            $(this).attr("data-click-count") < 1 && (m(d),
            h.preventDefault())) : h.type == "click" && !clicked ? $(this).attr("data-click-count") < 1 && (m(d),
            h.preventDefault()) : clicked = !1;
            function m(w) {
                var _ = $(w).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
                  , k = $(w).next(".vertical-menu_submenu")
                  , A = $(w).attr("data-click-count");
                if ($(".dropdown_link--vertical").not(w).attr("data-click-count", 0),
                $(".dropdown_link--vertical").attr("data-no-instant", !0),
                $(".dropdown_container").hide(),
                _.show(),
                $(".vertical-menu_submenu").removeClass("is-visible"),
                k.addClass("is-visible"),
                h.type == "touchstart" && (A++,
                $(w).attr("data-click-count", A),
                A < 2))
                    return h.preventDefault(),
                    h.stopPropagation(),
                    !1
            }
        })),
        $(".promo_banner").length) {
            var f = Cookies.get("promo_banner");
            f != "dismiss" && ($("body").addClass("promo_banner-show"),
            $(".promo_banner").on("click", ".promo_banner-close", function() {
                $("body").removeClass("promo_banner-show"),
                Cookies.set("promo_banner", "dismiss", {
                    expires: 30
                })
            }))
        }
        if ($(".vertical-menu_submenu, .vertical-menu_sub-submenu").each(function() {
            $(this).is(":off-right") && $(this).addClass("vertical-menu--align-right")
        }),
        $("html").on("click", function(h) {
            !$(h.target).closest(".cart_container").length && $(".cart_content").is(":visible") && r(),
            !$(h.target).closest(".dropdown_container").length && $(".dropdown").is(":visible") && n()
        }),
        $(window).width() > 798) {
  
            if ($(".header").hasClass("header-fixed--true")) {
                if ($("body").on("click", '.banner a[href^="#"]', function(h) {
                    h.preventDefault();
                    var d = $(this).attr("href")
                      , m = $(".main_nav_wrapper.sticky_nav").outerHeight();
                    $("html, body").animate({
                        scrollTop: $(d).offset().top - m
                    }, 2e3)
                }),
                !$(".main_nav_wrapper").hasClass("sticky_nav"))
                    var l = new Headhesive(".main_nav_wrapper",{
                        offset: 700,
                        throttle: 300,
                        classes: {
                            clone: "sticky_nav",
                            stick: "sticky_nav--stick",
                            unstick: "sticky_nav--unstick"
                        },
                        onInit: function() {
                            $(".sticky_nav .secondary_logo").css("display", "none"),
                            $(".sticky_nav .primary_logo").css("display", "block"),
                            $(".sticky_nav .icon-search").css("display", "block"),
                            $(".sticky_nav .search_container").css("display", "none"),
                            $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone());
                            var h = $(".sticky_nav").height() + 5;
                            $(".sticky_nav .mini_cart").css("height", $(".sticky_nav").height() + 5),
                            $(".sticky_nav .cart_content").css("top", $(".sticky_nav").height())
                        },
                        onUnstick: function() {
                            $(".cart_container").removeClass("active_link")
                        }
                    })
            } else
                $(".header-fixed--true").removeClass("header-fixed--true"),
                $(".main_nav_wrapper").length > 1 && $(".main_nav_wrapper").first().remove();
            $("img.primary_logo:visible") ? $(".logo img", $(".feature_image .header")).attr("src", $(".logo img").data("src-home")) : $(".logo img").attr("src", $(".logo img").data("src"))
        } else
            $("#header").hasClass("mobile_nav-fixed--true") ? ($("body").addClass("mobile_nav-fixed--true"),
            $("body").on("click", '.banner a[href^="#"]', function(h) {
                h.preventDefault();
                var d = $(this).attr("href")
                  , m = $("#header").outerHeight();
                $("html, body").animate({
                    scrollTop: $(d).offset().top - m
                }, 2e3)
            })) : $("body").addClass("mobile_nav-fixed--false");
        $(".cart_content").length <= 2 && $("#header .cart_container").append($(".cart_content").clone()),
        is_touch_device() || $(window).width() <= 798 ? ($(".dropdown_link").attr("data-no-instant", !0),
        $("body").on("click", ".dropdown_link", function(h) {
          var cart_height = $('.cart_content.animated.fadeIn').innerHeight();
          var cart_items_height = $('ul.cart_items.js-cart_items.clearfix').innerHeight();
          if(cart_items_height>cart_height || cart_height > 766 ){
            $('.suspension').addClass('suspension_add');
            $('.cart_subtotal_suspension').css('display','block')
              if(getOs() == 'Safari'){
              var cart_height = $('.cart_content.animated.fadeIn').innerHeight()+30;
                $('.suspension_add').css('top','calc(90vh - 40px)')
            }

             $(window).width() < 798 && $('.suspension_add').css('top',cart_height);
          }
            if ($(".nav a").removeClass("active_link"),
            $("#header").is(":visible")) {
                var d = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
                $(this).hasClass("mini_cart") || $(".cart_container").removeClass("active_link")
            } else {
                if ($(this).hasClass("icon-search"))
                    return window.location = $(this).attr("href"),
                    !1;
                var d = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
            }
            if (d.is(":visible") || d.attr("class") === void 0 ? (d.hide(),
            $("body").removeClass("is-active")) : ($(".dropdown_container").hide(),
            $(this).hasClass("cart_container") || $(".is-absolute").parent().removeClass("feature_image"),
            d.show(),
            $("body").addClass("is-active"),
            $(".mobile_nav").find("div").removeClass("open")),
            d.is(":visible"))
                return h.stopPropagation(),
                !1
        }),
        $("body").on("click", ".mobile_nav", function() {
            $(this).find("div").toggleClass("open")
        }),
        $(".mini_cart").on("click", function(h) {
            var d = $(this).parent();
            d.hasClass("active_link") ? (r(),
            $("body").removeClass("blocked-scroll")) : (s(d),
            $("body").addClass("blocked-scroll")),
            (is_touch_device() || $(window).width() <= 798) && h.preventDefault()
        }),
        $(".cart_content__continue-shopping").on("click", function(h) {
            r()
        })) : ($(".nav a, .logo a").not(".cart_content a").on("mouseenter", function() {
            $(this).hasClass("active_link") || ($(".dropdown_container").hide(),
            $(".active_link").removeClass("active_link"),
            $(".is-absolute").parent().addClass("feature_image"))
        }),
        $(".main_nav, .top_bar, .cart_container").on("mouseleave", function() {
            $(window).width() > 798 && $(".dropdown_container").hide(),
            $(".active_link").removeClass("active_link"),
            $(".is-absolute").parent().addClass("feature_image")
        }),
        $(".dropdown_link, .dropdown_link--vertical").attr("data-click-count", 0),
        $(".dropdown_link").on("mouseover touchstart", function(h) {
            $(window).width() > 798 && $(".dropdown_container").hide();
            var d = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
              , m = $(this).attr("data-click-count");
              var top = (($(this).offset().top)+50);
          if(top>800){
            top = $(this).position().top + $(this).height() +25
          }
            if ($(".active_link").removeClass("active_link"),
            $(this).hasClass("active_link") || (d.show().css({'position':'absolute','top':top+'px'}),
            $(this).hasClass("mini_cart") ? $(this).parent(".cart_container").addClass("active_link") : ($(window).width() > 798 && $(this).addClass("active_link"),
            $(".is-absolute").parent().removeClass("feature_image"))),
            is_touch_device() && ($(".dropdown_link").not(this).attr("data-click-count", 0),
            $(".dropdown_link").attr("data-no-instant", !0),
            h.type == "touchstart" && (m++,
            $(this).attr("data-click-count", m),
            m < 2)))
                return h.preventDefault(),
                h.stopPropagation(),
                !1
        }))
    },
    removeDataAttributes: function(n) {
        if ($(n).length) {
            var r, s = $(n), f, l = [], h = s.get(0).attributes, d = h.length;
            for (r = 0; r < d; r++)
                h[r].name.substring(0, 5) === "data-" && l.push(h[r].name);
            $.each(l, function(m, w) {
                s.removeAttr(w)
            })
        }
    },
    loadMegaMenu: function() {
        $(".sticky_nav .mega-menu").remove(),
        $(".header .mega-menu").remove(),
        $(".mega-menu-container .mega-menu").clone().appendTo(".sticky_nav .main_nav"),
        header.removeDataAttributes(".sticky_nav .mega-menu.dropdown_container .dropdown_column"),
        $(".mega-menu-container .mega-menu").each(function(n) {
            var r = $(this).data("dropdown");
            $('[data-dropdown-rel="' + r + '"]').find("span").remove(),
            $('[data-dropdown-rel="' + r + '"]').not(".icon-search").append(' <span class="icon-down-arrow"></span>').addClass("mega-menu-parent").addClass("dropdown_link").removeClass("top_link"),
            $('[data-dropdown="' + r + '"]').each(function(s) {
                $(this).hasClass("mega-menu") || $(this).remove()
            }),
            $(this).clone().appendTo(".header .main_nav")
        }),
        $(".dropdown_link--vertical").length && ($(".dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu").remove(),
        $(".dropdown_link--vertical:not(.mega-menu-parent)").each(function(n) {
            var r = $(this).data("dropdown-rel");
            $('[data-dropdown="' + r + '"]').remove()
        })),
        $(".mega-menu-parent").on("mouseenter", function() {
            $(this).hasClass("active_link") || ($(".dropdown_container").hide(),
            $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]').toggle(),
            $(this).addClass("active_link"),
            $(".is-absolute").parent().removeClass("feature_image"))
        }),
        header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column"),
        (is_touch_device() || $(window).width() <= 798) && $(".dropdown_link").attr("data-no-instant", !0),
        header.loadMobileMegaMenu()
    },
    loadMobileMegaMenu: function() {
        $(".mega-menu-container .mobile-mega-menu").each(function(n) {
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find("span").remove(),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr("data-no-instant", "true"),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass("mobile-mega-menu-parent sublink"),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(r) {
                $(this).hasClass("mobile-mega-menu") || $(this).remove()
            })
        })
    },
    unloadMegaMenu: function() {
        $(".header .mega-menu").remove(),
        $(".mega-menu-container .mega-menu").each(function(n) {
            var r = $(this).data("dropdown");
            $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find(".icon-down-arrow").remove()
        })
    },
    unload: function() {
        $("body").off("click", ".mobile_nav"),
        $("body").off("click", ".dropdown_link"),
        $("html").off("click"),
        $(".mini_cart").off("click"),
        $(".cart_content__continue-shopping").off("click"),
        $("body").off("click", '.banner a[href^="#"]')
    }
}
  , enableLoadMoreSearch = function() {
    $("body").on("click", ".js-load-more a", function(n) {
        return enableInfiniteSearchScroll(),
        n.stopPropagation(),
        !1
    })
}
  , enableInfiniteSearchScroll = function() {
    if ($(".search-matrix").length)
        var n = new Waypoint.Infinite({
            element: $(".search-matrix")[0],
            items: ".search-matrix",
            more: ".load-more__btn",
            loadingClass: "loading-in-progress",
            onBeforePageLoad: function() {
                $(".js-load-more").hide()
            },
            onAfterPageLoad: function(r) {}
        })
}
  , mapFunction = {
    init: function() {
        if ($(".maps").hasClass("js-api-map")) {
            var n = [];
            $(".map").each(function(r, s) {
                n.push(this),
                n[r].sectionid = $(this).data("id"),
                n[r].address = $(this).data("address"),
                n[r].directions = $(this).data("directions-address"),
                n[r].zoom = $(this).data("zoom"),
                n[r].mapstyle = $(this).data("style"),
                n[r].showpin = $(this).data("pin"),
                n[r].apikey = $(this).data("api-key")
            }),
            $.each(n, function(r, s) {
                $.ajaxSetup({
                    cache: !0
                }),
                $.getScript("https://maps.googleapis.com/maps/api/js?key=" + n[r].apikey).then(function() {
                    mapFunction.findLocation(n[r]),
                    $.ajaxSetup({
                        cache: !1
                    })
                })
            })
        }
    },
    findLocation: function(n) {
        var r, s, f = new google.maps.Geocoder;
        f.geocode({
            address: n.address
        }, function(l, h) {
            h == google.maps.GeocoderStatus.OK ? (r = l[0].geometry.location.lat(),
            s = l[0].geometry.location.lng(),
            mapFunction.initMap(r, s, n)) : console.log("Error:" + h)
        })
    },
    initMap: function(n, r, s) {
        var f = {
            lat: n,
            lng: r
        }
          , l = [];
        s.mapstyle == "aubergine" ? l = [{
            elementType: "geometry",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#8ec3b9"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1a3646"
            }]
        }, {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#4b6878"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#64779e"
            }]
        }, {
            featureType: "administrative.province",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#4b6878"
            }]
        }, {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#334e87"
            }]
        }, {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{
                color: "#023e58"
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#283d6a"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#6f9ba5"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{
                color: "#023e58"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#3C7680"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#304a7d"
            }]
        }, {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#98a5be"
            }]
        }, {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#2c6675"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#255763"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#b0d5ce"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#023e58"
            }]
        }, {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#98a5be"
            }]
        }, {
            featureType: "transit",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            featureType: "transit.line",
            elementType: "geometry.fill",
            stylers: [{
                color: "#283d6a"
            }]
        }, {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{
                color: "#3a4762"
            }]
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#0e1626"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#4e6d70"
            }]
        }] : s.mapstyle == "retro" ? l = [{
            elementType: "geometry",
            stylers: [{
                color: "#ebe3cd"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#523735"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#f5f1e6"
            }]
        }, {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#c9b2a6"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#dcd2be"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#ae9e90"
            }]
        }, {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#93817c"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{
                color: "#a5b076"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#447530"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#f5f1e6"
            }]
        }, {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{
                color: "#fdfcf8"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#f8c967"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#e9bc62"
            }]
        }, {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{
                color: "#e98d58"
            }]
        }, {
            featureType: "road.highway.controlled_access",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#db8555"
            }]
        }, {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#806b63"
            }]
        }, {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "transit.line",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#8f7d77"
            }]
        }, {
            featureType: "transit.line",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#ebe3cd"
            }]
        }, {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{
                color: "#b9d3c2"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#92998d"
            }]
        }] : s.mapstyle == "silver" ? l = [{
            elementType: "geometry",
            stylers: [{
                color: "#f5f5f5"
            }]
        }, {
            elementType: "labels.icon",
            stylers: [{
                visibility: "off"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#616161"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#f5f5f5"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#bdbdbd"
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#eeeeee"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#757575"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{
                color: "#e5e5e5"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9e9e9e"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#ffffff"
            }]
        }, {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#757575"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#dadada"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#616161"
            }]
        }, {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9e9e9e"
            }]
        }, {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{
                color: "#e5e5e5"
            }]
        }, {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{
                color: "#eeeeee"
            }]
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#c9c9c9"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9e9e9e"
            }]
        }] : s.mapstyle == "night" ? l = [{
            elementType: "geometry",
            stylers: [{
                color: "#242f3e"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#746855"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#242f3e"
            }]
        }, {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#d59563"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#d59563"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{
                color: "#263c3f"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#6b9a76"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#38414e"
            }]
        }, {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#212a37"
            }]
        }, {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#746855"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#1f2835"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#f3d19c"
            }]
        }, {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{
                color: "#2f3948"
            }]
        }, {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#d59563"
            }]
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#17263c"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#515c6d"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#17263c"
            }]
        }] : l = [],
        $(".js-map-link").attr("href", "https://www.google.com/maps/place/" + s.directions + "/@" + n + "," + r);
        var h = {
            zoom: s.zoom,
            center: f,
            styles: l,
            disableDefaultUI: !1
        }
          , d = new google.maps.Map(document.getElementById(s.sectionid),h);
        if (s.showpin == !0)
            var m = new google.maps.Marker({
                position: f,
                map: d
            })
    }
}
  , enableLoadMoreProducts = function() {
    $("body").on("click", ".js-load-more a", function(n) {
        return enableInfiniteScroll(),
        n.stopPropagation(),
        !1
    })
}
  , enableInfiniteScroll = function() {
    if ($(".collection-matrix").length)
        var n = new Waypoint.Infinite({
            element: $(".collection-matrix")[0],
            items: ".collection-matrix",
            more: ".load-more__btn",
            loadingClass: "loading-in-progress",
            onBeforePageLoad: function() {
                $(".js-load-more").hide()
            },
            onAfterPageLoad: function(r) {}
        })
};
if (Shopify.queryParams = {},
location.search.length)
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++)
        aKeyValue = aCouples[i].split("="),
        aKeyValue.length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
var quickFilter = {
    init: function() {
        var n = []
          , r = ""
          , childr = ""
          , s = ""
          , f = "https://" + $.url("hostname")
          , l = $.url("1") ? "/" + $.url("1") + "/" : ""
          , h = $.url("2") ? $.url("2") + "/" : ""
          , d = $.url("3")
          , m = l + h;
        $(".selected-value-collection-custom-color").attr("data-default-collection") != $(".selected-value-collection-custom-color").attr('data-value') && $(".selected-value-collection-custom-style").attr('data-value')? childr = "+" + $(".selected-value-collection-custom-style").attr('data-value'): childr = $(".selected-value-collection-custom-style").attr('data-value') || "",
        $(".selected-value-collection-custom-sort").length ? r = $(".selected-value-collection-custom-sort").attr('data-value') : r = url("?sort_by"),
        $(".selected-value-collection-custom-color").length && $(".selected-value-collection-custom-color").attr("data-default-collection") != $(".selected-value-collection-custom-color").attr('data-value') && (urlTag = $(".selected-value-collection-custom-color").attr('data-value').substr($(".selected-value-collection-custom-color").attr('data-value').lastIndexOf("/") + 1),
        urlTag != "all" && ($.inArray(urlTag, n) > -1 || n.unshift(urlTag))),
        $("[data-option-filter] input:checked").each(function() {
            n.push($(this).val())
        }),
        n = $.makeArray(n),
        $.each(n, function(w, _) {
            w != n.length - 1 ? s += n[w] + "+" : s += n[w]
        }),
        Shopify.queryParams.sort_by = r,
        r = childr+"?" + $.param(Shopify.queryParams),
        quickFilter.processUrl(m, s, r)
    },
    updateView: function(n) {
        $.ajax({
            type: "GET",
            url: n,
            beforeSend: function() {
                $(".collection-matrix").addClass("fadeOut animated loading-in-progress filter-loading"),
                Waypoint.destroyAll()
            },
            success: function(r) {
                $(".collection-matrix").removeClass("loading-in-progress"),
                $(".collection-matrix").removeClass("filter-loading");
                var s = $(r).find(".breadcrumb_text").html();
                $(".breadcrumb_text").html(s);
                var f = $(r).find(".paginate").html();
                $(".paginate").html(f);
                var l = $(r).find(".sidebar").html();
                $(".sidebar").html(l);
                var h = $(r).find(".paginate").html();
                $(".paginate").empty(),
                $(".paginate").html(h);
                var d = $(r).find(".collection-matrix");
                $(".collection-matrix").remove(),
                d.insertBefore($(".load-more__icon")),
                window.history && window.history.pushState && window.history.pushState("", "", n),
                $(".sidebar__collection-filter").length && collectionSidebarFilter.init()
            },
            error: function(r, s, f) {
                console.log(r),
                console.log(s),
                console.log(f),
                location.replace(location.protocol + "//" + location.host + n)
            },
            dataType: "html"
        })
    },
    processUrl: function(n, r, f) {
        var f = f.replace(/\page=(\w+)&/, "")
          , l = "";
        l = n + r + f,
        quickFilter.updateView(l)
    }
};
$("#sort-by").val($("#sort-by").data("default-sort")),
$("body").on("change", "#tag_filter, .selected-value-collection-custom-color,.selected-value-collection-custom-style,.selected-value-collection-custom-sort,#sort-by", function() {
    quickFilter.init()
}),
$("body").on("change", "#blog_filter", function() {
    var n = $(this).val();
    window.location = n
}),
$("input, select, textarea").on("focus blur", function(n) {
    $("meta[name=viewport]").attr("content", "width=device-width,initial-scale=1,maximum-scale=" + (n.type == "blur" ? 10 : 1))
});
var searchAutocomplete = {
    init: function() {
        var n = null
          , r = $("body").data("shop-url")
          , s = r + "/search?type=product&q=";
        $(".search_form, .search__form, .header_search_form").on("submit", function(l) {
            var h = $(this).find('input[name="q"]').val()
              , d = encodeURI(h);
            l.preventDefault(),
            d == null ? window.location.href = "/search" : window.location.href = s + d + "*"
        });
        var f = $("form.search_form, form.search, form.header_search_form").each(function() {
            var l = $(this).find('input[name="q"]');
            $('<div class="search__results-wrapper"><ul class="search__results search__results_custom_my"></ul></div>').appendTo($(this)),
            l.attr("autocomplete", "off").bind("keyup change", function() {
                l.val() == "" && ($(".search__results").hide(),
                $(".search__results").empty());
                var h = $(this).val()
                  , d = encodeURI(h)
                  , m = $(this).closest("form")
                  , w = s + d
                  , _ = m.find(".search__results");
                h.length >= 3 && (n != null && n.abort(),
                n = $.getJSON(w + "*&view=json", function(k) {
                    _.empty(),
                    k.results_count == 0 ? _.hide() : ($.each(k.results, function(A, x) {
                        if (A >= 5)
                            return !1;
                        var E = $("<a></a>").attr("href", x.url);
                        if (x.object_type == "product") {
                            var j = [];
                            for (i = 0; i < x.collections.length; i++)
                                j.push(x.collections[i].handle);
                            if ($.inArray("coming-soon", j) != -1)
                                var L = "Coming Soon";
                            else if (x.available == !0)
                                if (x.raw_compare > x.raw_price)
                                    var L = '<span class="was_price">' + x.compare + "</span> " + x.price;
                                else if (x.price_varies && x.price_min > 0)
                                    var L = "from " + x.price;
                                else if (x.price > 0 || x.raw_price > 0)
                                    var L = x.price;
                                else
                                    var L = "Free";
                            else
                                var L = "Sold Out";
                            x.thumbnail != "NULL" && E.append('<div class="thumbnail"><img class="lazyload fade-in" src="' + x.thumbnail + '" /></div>'),
                            E.append('<div class="title">' + x.title + '<br><span class="item-pricing">' + L + "</span></div>")
                        } else
                            x.object_type == "article" ? (x.thumbnail != "NULL" && E.append('<div class="thumbnail"><img class="lazyload fade-in" src="' + x.thumbnail + '" /></div>'),
                            E.append('<div class="title">' + x.title + '<br><span class="item-pricing">' + x.text_content + "</span></div>")) : x.object_type == "page" && E.append('<div class="title">' + x.title + '<br><span class="item-pricing">' + x.text_content + "</span></div>");
                        E.wrap('<li class="item-result result--' + x.object_type + '"></li>'),
                        _.append(E.parent())
                    }),
                    k.results_count >= 5 && _.append('<li class="all-results"><span class="title see-all"><a href="' + w + '*">View all results (' + k.results_count + ")</a></span></li>"),
                    _.fadeIn(200))
                }))
            })
        });
        $(document).on("click", function(l) {
            var h = $("[data-autocomplete-true]");
            !h.is(l.target) && h.has(l.target).length === 0 && $("[data-autocomplete-true]").find(".search__results-wrapper").hide()
        }),
        $("[data-autocomplete-true] input").on("focus", function() {
            $(".search__results-wrapper").hide(),
            $(this).parents("[data-autocomplete-true]").find(".search__results-wrapper").show()
        })
    },
    unload: function() {
        $("body").off("focus", "[data-autocomplete-true] input")
    }
}
  , collectionSidebarFilter = {
    init: function() {
        $(".filter-active-tag input:checked").parents(".filter-active-tag").siblings(".filter-all-tags").hide(),
        $(".toggle-all--true .toggle_list .filter-active-tag input:checked").parents("ul.toggle_list").prev().click(),
        ($.url(2) === "types" || $.url(2) === "vendors") && $(".sidebar__collection-filter").remove(),
        $(".sidebar-block:empty").prev().css("border-bottom", "none")
    },
    clearAllFilters: function() {
        $("[data-option-filter] input").attr("checked", !1),
        $("[data-option-filter] input").trigger("change")
    },
    clearSelectedFilter: function(n) {
        n.find("[data-option-filter] input").attr("checked", !1),
        n.find("[data-option-filter] input").trigger("change")
    }
};
$("body").on("change", "[data-option-filter] input", function() {
    quickFilter.init(),
    $("html, body").animate({
        scrollTop: $("#pagecontent").offset().top
    }, 500)
}),
$("body").on("click", "[data-reset-filters]", function() {
    collectionSidebarFilter.clearAllFilters()
}),
$("body").on("click", "[data-clear-filter]", function() {
    var n = $(this).parents(".filter-active-tag");
    collectionSidebarFilter.clearSelectedFilter(n)
});
var faqAccordion = {
    init: function() {
        var n = 0
          , r = $(".faqAccordion > dt > button");
        $(".faqAccordion > dd").attr("aria-hidden", !0),
        r.attr("aria-expanded", !1),
        r.on("click activate", function() {
            if (n)
                return !1;
            n = 1;
            var s = $(this).attr("aria-expanded") === "false";
            return $(this).attr("aria-expanded", s),
            $(this).parent().next().slideToggle(function() {
                n = 0
            }),
            $(this).parent().next().attr("aria-hidden", !s),
            !1
        }),
        r.on("keydown", function(s) {
            var f = s.keyCode || e.which;
            f === 13 && $(this).trigger("activate")
        })
    }
}
  , arrowSize = {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 62,
    y2: 40,
    x3: 22
}
  , lightboxGallery = {
    init: function() {
        if ($(".lightbox img").length) {
            var n, r = $("a.lightbox"), s = [];
            r.each(function(f) {
                s.push($(this).attr("rel")),
                s = s.filter(function(l, h, d) {
                    return d.indexOf(l) === h
                })
            }),
            $.each(s, function(f, l) {
                $(".lightbox[rel=" + l + "]").attr("data-remodal-target", "lightbox-id-" + f);
                var h = ['<div class="remodal remodal-lightbox js-remodal-lightbox js-lightbox-' + f + '" data-rel="' + l + '" data-remodal-id="lightbox-id-' + f + '" data-remodal-options="hashTracking: false">', '<a data-remodal-action="close" class="remodal-close"></a>', '<div class="lightbox-gallery"></div>', "</div>"].join("");
                $("body").append(h),
                $(".lightbox[rel=" + l + "]").each(function(d) {
                    $(this).attr("data-image-id", d),
                    $(this).attr("data-no-instant", "")
                })
            })
        }
    }
}
  , utils = {
    createAccordion: function(n, r, s) {
        var f = $(n)
          , l = $(n).find(r)
          , h = $(n).find(s)
          , d = n + " " + r;
        if (n.indexOf(".accordion-tabs") >= 0) {
            var m = $.map(l, function(w, _) {
                return [w, h[_]]
            });
            f.empty(),
            $.each(m, function(w, _) {
                f.append(this)
            }),
            h.removeClass("active"),
            f.find(".active").next().slideToggle(),
            r = n + "> a"
        }
        $(n).children("a").each(function(w, k) {
            var k = $(this)
              , A = k.attr("href");
            k.attr("data-tab-value", A),
            k.removeAttr("href")
        }),
        $(n).find(r + ".active").next().slideToggle(),
        $("body").on("click", d, function(w) {
            w.preventDefault(),
            $(this).toggleClass("active"),
            $(this).next().slideToggle()
        })
    },
    mobileAccordion: function(n, r, s) {
        $container = $(n),
        $tab = $(n).find(r),
        $content = $(n).find(s),
        $(r + ".active").next().slideToggle(),
        $("body").on("click", r, function(f) {
            f.preventDefault(),
            $(this).toggleClass("active"),
            $(this).next().slideToggle()
        })
    },
    mobileParentActiveAccordion: function(n, r, s) {
        $container = $(n),
        $tab = $(n).find(r),
        $content = $(n).find(s),
        $(r + ".active").parent().next().slideToggle(),
        $("body").on("click", r, function(f) {
            f.preventDefault(),
            $(this).toggleClass("active"),
            $(this).parent().next().slideToggle()
        })
    },
    initializeTabs: function() {
        $("ul.tabs > li > a").attr("data-no-instant", !0),
        $("body").on("click", "ul.tabs > li > a", function(n) {
            n.preventDefault();
            var r = $(this).attr("href");
            r.charAt(0) == "#" && ($("ul.tabs > li > a.active").removeClass("active"),
            $(this).addClass("active"),
            $(this).parents("ul.tabs").next().find(r).show().css({
                display: "block"
            }).addClass("active").siblings().hide().removeClass("active"))
        })
    },
    pageBannerCheck: function() {
        !$(".page_banner").length > 0 || $(".header").hasClass("header-background--solid") ? ($(".feature_image").removeClass("feature_image"),
        $(".header.is-absolute").removeClass("is-absolute"),
        $(".secondary_logo--true").find(".secondary_logo").css("display", "none"),
        $(".secondary_logo--true").find(".primary_logo").css("display", "block")) : ($(".header").parent().addClass("feature_image"),
        $(".header").addClass("is-absolute"),
        $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").css("display", "block"),
        $(".secondary_logo--true").find(".primary_logo").css("display", "none"))),
        $(".index-sections").children().first().hasClass("under-menu") ? ($(".header").hasClass("header-background--solid") || ($(".index .header").parent().addClass("feature_image"),
        $(".index .header").addClass("is-absolute")),
        $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").show(),
        $(".secondary_logo--true").find(".primary_logo").hide())) : ($(".index .feature_image").removeClass("feature_image"),
        $(".index .header.is-absolute").removeClass("is-absolute"),
        $("header.feature_image").hasClass("secondary_logo--true") || ($(".secondary_logo--true").find(".secondary_logo").hide(),
        $(".secondary_logo--true").find(".primary_logo").show())),
        $(".detail-sections").children().first().hasClass("under-menu") ? ($(".header").hasClass("header-background--solid") || ($('[class^="page-details"] .header').parent().addClass("feature_image"),
        $('[class^="page-details"] .header').addClass("is-absolute")),
        $("header.feature_image").hasClass("secondary_logo--true") && ($(".secondary_logo--true").find(".secondary_logo").show(),
        $(".secondary_logo--true").find(".primary_logo").hide())) : ($('[class^="page-details"] .feature_image').removeClass("feature_image"),
        $('[class^="page-details"] .header.is-absolute').removeClass("is-absolute"),
        $("header.feature_image").hasClass("secondary_logo--true") || ($(".secondary_logo--true").find(".secondary_logo").hide(),
        $(".secondary_logo--true").find(".primary_logo").show()))
    },
    resizeActionButtons: function() {
        $(".js-caption:visible").each(function() {
            var n = 0;
            $(this).find(".action_button").each(function() {
                $button = $(this),
                $(this).width() > n && (n = $(this).width())
            }),
            $(this).find(".action_button").width(n)
        })
    }
}
  , sliderBlock = {
    select: function(n, r) {
        var s = r.find(".gallery-cell")
          , f = s.map(function() {
            return String($(this).data("block-id"))
        })
          , l = r.find(".js-homepage-slideshow")
          , h = {
            slideshowTextAnimation: l.data("slideshow-text-animation")
        }
          , d = l.data("flickity");
        l.flickity("pausePlayer");
        for (var m = 0; m < f.length; m++)
            if (f[m] === n) {
                var w = m;
                w !== d.selectedIndex && l.flickity("select", parseInt(w), !1, !0)
            }
    },
    deselect: function(n) {
        var r = n.find(".flexslider").data("flexslider");
        r && r.flickity("unpausePlayer")
    }
};
$(function() {
    var oldFlickityCreate = window.Flickity.prototype._create;
    window.Flickity.prototype._create = function() {
        var n = this;
        return this.element.addEventListener && this.element.addEventListener("load", function() {
            n.onresize()
        }, !0),
        this._create = oldFlickityCreate,
        oldFlickityCreate.apply(this, arguments)
    }
    ,
    header.loadMegaMenu(),
    header.init(),
    searchAutocomplete.init(),
    utils.pageBannerCheck(),
    slideshow.init(),
    testimonial.init(),
    gallery.init(),
    videoSection.init(),
    featuredPromotions.init(),
    featuredCollectionSection.init(),
    collectionSidebarFilter.init(),
    cart.init(),
    mapFunction.init(),
    productPage.initializeQuantityBox(),
    productPage.init(),
    productPage.relatedProducts(),
    recentlyViewed.init();
    var resizeTimeout;
    window.addEventListener("resize", function(n) {
        resizeTimeout || (resizeTimeout = setTimeout(function() {
            resizeTimeout = null,
            $(window).width() <= 798 && (cart.init(),
            header.unload(),
            header.init())
        }, 66))
    }, !1);
    var currentValue = $(".search_form input[name='q']").val();
    $(".search_form input[name='q']").length > 0 && $(".search_form input[name='q']").val(currentValue.replace("*", "")),
    $("body").on("click", ".lightbox", function() {
        currentSlide = $(this).data("image-id")
    });
    var touchStartPos = 0;
    if ($(document).bind("touchstart", function(n) {
        touchStartPos = $(window).scrollTop()
    }).bind("touchend", function(n) {
        var r = touchStartPos - $(window).scrollTop();
        (r > 20 || r < -20) && n.preventDefault
    }),
    $("body").on("opened", ".js-remodal-lightbox", function() {
        var n = $(this), r = $(this).data("rel"), s = $(".lightbox[rel=" + r + "]"), f = n.find(".lightbox-gallery"), l = n.find(".lightbox-image"), h = $("body").find(".product_gallery").data("zoom"), d = l.length !== 1, m = l.length !== 1, w = n.find(".lightbox-gallery").hasClass("flickity-enabled"), _;
        if (n.attr("data-zoom", h),
        h ? m = !1 : m = l.length !== 1,
        !w)
            var k = f.flickity({
                wrapAround: "true",
                cellAlign: "center",
                contain: !0,
                imagesLoaded: !0,
                lazyLoad: 2,
                pageDots: usePageDots,
                draggable: m,
                prevNextButtons: d,
                arrowShape: arrowSize,
                adaptiveHeight: !0
            });
        s.each(function(A) {
            var x = $(this).attr("href");
            _ = $('<div class="gallery-cell"><img src="' + x + '" class="lightbox-image"></div>'),
            s.length > f.find(".gallery-cell").length && f.flickity("append", _),
            f.flickity("select", currentSlide, !1, !0).focus(),
            n.find(".lightbox-image").css("opacity", "1")
        }),
        h && imageFunctions.zoom(".js-remodal-lightbox", !0, 1.8)
    }),
    $("body").on("click", ".lightbox", function() {
        currentSlide = $(this).data("image-id")
    }),
    $("body").on("click", ".sidebar .parent-link--false", function(n) {
        n.preventDefault(),
        $menu = $(this).parent("li"),
        $menu.find(".menu-toggle").toggleClass("active"),
        $menu.find("ul").slideToggle()
    }),
    $("body").on("closed", ".js-remodal-lightbox", function() {
        var n = $(this);
        n.find("img").css("opacity", "0")
    }),
    window.location.pathname.indexOf("/comments") != -1 && $("html,body").animate({
        scrollTop: $("#new-comment").offset().top - 140
    }, "slow"),
    $("body").on("mouseenter", ".icon-search", function() {
        $(".search-terms").focus()
    }),
    $("body").on("click", ".icon-search", function() {
        $("input.search-terms").focus()
    }),
    $("body").on("click", ".search-submit", function() {
        $(this).parent().submit()
    }),
    $(window).width() > 798 && ($(".animate_right").waypoint(function() {
        $(this.element).addClass("animated fadeInRight")
    }, {
        offset: "70%"
    }),
    $(".animate_left").waypoint(function() {
        $(this.element).addClass("animated fadeInLeft")
    }, {
        offset: "70%"
    }),
    $(".animate_up").waypoint(function() {
        $(this.element).addClass("animated fadeInUp")
    }, {
        offset: "70%"
    }),
    $(".animate_down").waypoint(function() {
        $(this.element).addClass("animated fadeInDown")
    }, {
        offset: "70%"
    })),
    $(".slider, .flexslider").find("li").unwrap(),
    $(".slider, .flexslider").flickity({
        pageDots: usePageDots,
        imagesLoaded: !0,
        arrowShape: arrowSize,
        lazyLoad: 2
    }),
    utils.createAccordion(".toggle-all--true", "h4.toggle", "ul.toggle_list"),
    utils.createAccordion(".footer_menu", "h6", "ul"),
    utils.createAccordion(".footer_content", "h6", "div.toggle_content"),
    utils.createAccordion(".product_section .accordion-tabs", ".tabs li > a", ".tabs-content li"),
    utils.mobileParentActiveAccordion("#mobile_menu", "li.sublink > a.parent-link--true span", "li.sublink ul"),
    utils.mobileAccordion("#mobile_menu", "li.sublink > a.parent-link--false", "li.sublink ul"),
    utils.initializeTabs(),
    utils.resizeActionButtons(),
    faqAccordion.init(),
    $(window).on("resize", function() {
        utils.resizeActionButtons()
    }),
    $(window).width() <= 798 && utils.createAccordion(".toggle-all--false", "h4.toggle", "ul.toggle_list"),
    $("body").on("click", ".menu-toggle", function(n) {
        var r = $(this).next("ul");
        r.slideToggle(),
        $(this).toggleClass("active"),
        $(this).attr("aria-expanded", $(this).attr("aria-expanded") == "true" ? "false" : "true")
    }),
    $(".shopify-section.page-details-section, .shopify-section.product-details-section").length || ($("body").hasClass("index") ? $(".featured-products-section iframe[src*=youtube], .featured-products-section iframe[src*=vimeo]").mediaWrapper({
        intrinsic: !0
    }) : $("iframe[src*=youtube], iframe[src*=vimeo]").mediaWrapper({
        intrinsic: !0
    })),
    $(window).width() >= 959) {
        var modal_width = "870px";
        ($(window).width() >= 1200 || $("html").hasClass("ie")) && (modal_width = "1110px")
    }
    $("body").on("click", ".cart_content .action_button", function(n) {
        n.preventDefault(),
        document.location.href = "/cart"
    }),
    imageFunctions.showSecondaryImage();
    var $contact_form = $(".newsletter .contact-form");
    $contact_form.each(function() {
        var n = $(this);
        n.on("submit", function(r) {
            $('input[name="challenge"]', n).val() !== "true" && ($.ajax({
                type: n.attr("method"),
                url: n.attr("action"),
                data: n.serialize(),
                success: function(s) {
                    n.fadeOut("slow", function() {
                        n.prev(".message").html("Thank you for joining our mailing list!")
                    })
                },
                error: function(s) {
                    $('input[name="challenge"]', n).val("true"),
                    n.submit()
                }
            }),
            r.preventDefault())
        })
    }),
    $(".maps").click(function() {
        $(".maps iframe").css("pointer-events", "auto")
    }),
    enableLoadMoreProducts();
    var globalQuickShopProduct;
    $("body").on("change", ".currencies", function(n) {
        $("[data-initial-modal-price]").attr("data-initial-modal-price", "")
    }),
    $("body").on("change", ".js-quick-shop select", function(n) {
        var r = $('.js-quick-shop select[name="id"]').val();
        r && globalQuickShopProduct && quickShop.updateVariant(r)
    });
    var quickShop = {
        init: function() {
            var n, r, s;
            $("body").on("click", ".js-quick-shop-link", function(f) {
                f.preventDefault();
                for (var l = $(this).data("images").trim("||").split("||"), h = [], d = [], m = 0; m < l.length; m += 2)
                    h.push(l[m]),
                    l[m + 1] && d.push(l[m + 1]);
                n = {
                    handle: $(this).data("handle"),
                    product_id: $(this).data("id"),
                    single_variant: $(this).attr("data-single-variant"),
                    product_in_collection_url: $(this).data("url"),
                    escaped_title: $(this).data("title"),
                    details_text: $(this).data("details-text"),
                    full_description: $(this).data("full-description"),
                    regular_description: $(this).data("regular-description"),
                    image_ids: h.filter(function(w) {
                        return w !== ""
                    }),
                    image_alts: d,
                    collection_handles: $(this).data("collection-handles").trim(",").split(","),
                    money_format: $(this).data("money-format")
                },
                $(".js-gallery-modal").hasClass("flickity-enabled") || $(".js-gallery-modal").flickity({
                    wrapAround: "true",
                    cellAlign: "left",
                    contain: !0,
                    imagesLoaded: !0,
                    lazyLoad: 2,
                    pageDots: usePageDots,
                    prevNextButtons: !0,
                    autoPlay: autoplay,
                    selectedAttraction: .01,
                    friction: .15,
                    arrowShape: arrowSize
                }),
                s = $(this).next(".js-forms").find(".notify_form"),
                r = $(this).next(".js-forms").find(".product_form"),
                $(".quick-shop .container").attr("class", "container section product-" + n.product_id),
                $(".quick-shop .container").attr("id", "product-" + n.product_id),
                $(".quick-shop .container").attr("data-id", n.product_id),
                quickShop.retrieveProductInfo(n)
            }),
            $("body").on("opened", ".js-quick-shop", function() {
                $(".remodal.quick-shop .js-product-form").html(r),
                $(".remodal.quick-shop .js-notify-form").html(s),
                $(r).hasClass("product_form_options") && !$(r).hasClass("viewed") && new Shopify.OptionSelectors($(r).data("select-id"),{
                    product: $(r).data("product"),
                    onVariantSelected: selectCallback,
                    enableHistoryState: $(r).data("enable-state")
                });
                var f = $(r).data("product")
                  , l = $(r).find(".swatch_options .swatch");
                l.length > 1 && Shopify.linkOptionSelectors(f, ".js-quick-shop"),
                utils.initializeTabs(),
                $('.js-quick-shop select[name="id"]').trigger("change")
            }),
            $("body").on("closed", ".js-quick-shop", function(f) {
                var l = $(".js-quick-shop .product_form")
                  , h = $(".js-quick-shop .notify_form");
                $(".form-holder-" + n.product_id).append(l),
                $(".form-holder-" + n.product_id).append(h),
                $(".form-holder-" + n.product_id + " .product_form").addClass("viewed"),
                $(".form-holder-" + n.product_id + " .notify_form").addClass("viewed");
                var d = $(".js-current-price .money").text();
                if ($(".js-quick-shop-link[data-id=" + n.product_id + "]").attr("data-initial-modal-price", d),
                $(".js-current-price, .js-was-price, .js-savings").empty(),
                $(".js-product_section").length) {
                    var m = $(".js-product_section").find(".product_form")
                      , w = m.data("product")
                      , _ = m.data("product-id")
                      , k = ".product-" + _ + " .js-product_section"
                      , A = m.find(".swatch_options .swatch");
                    A.length > 1 && Shopify.linkOptionSelectors(w, k)
                }
            })
        },
        retrieveProductInfo: function(n) {
            $.ajax({
                dataType: "json",
                async: !1,
                cache: !1,
                url: "/products/" + n.handle + ".js",
                success: function(s) {
                    var s = $.extend({}, s, n);
                    quickShop.populateGallery(s),
                    globalQuickShopProduct = s,
                    quickShop.updateVariant(s.variants[0].id.toString())
                }
            })
        },
        updateVariant: function(n) {
            if ($(".js-sale-banner, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-banner, .js-pre-order-banner").empty(),
            globalQuickShopProduct != "undefined") {
                var r = globalQuickShopProduct;
                $(".modal_price, .js-notify-form").show(),
                $(".js-product-title").html('<a href="' + r.product_in_collection_url + '" title="' + r.escaped_title + '">' + r.title + "</a>"),
                $(".js-product-vendor").html('<a href="/collections/vendors?q=' + r.vendor + '">' + r.vendor + "</a>"),
                $(".js-full-description").html(r.full_description),
                $(".js-regular-description").html(r.regular_description);
                var s = '<a href="' + r.product_in_collection_url + '" class="secondary_button" title="' + r.escaped_title + ' Details">' + r.details_text + "</a>";
                if ($(".js-product-details").html(s),
                $.each(r.collection_handles, function(l, h) {
                    this.toString() == "new" && $(".js-new-banner").html("New"),
                    this.toString() == "pre-order" && $(".js-pre-order-banner").html("Pre-Order"),
                    this.toString() == "coming-soon" && (r.price = "Coming Soon")
                }),
                r.single_variant == "true")
                    r.compare_at_price > r.price && $(".js-sale-banner").html("Ships Free"),
                    r.compare_at_price > r.price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"),
                    r.available == !1 && $(".js-sold-out").html("Sold Out"),
                    r.available == !0 && (r.compare_at_price > r.price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(r.compare_at_price, r.money_format) + "</span>"),
                    $(".js-savings").html("You Save " + parseInt((r.compare_at_price - r.price) * 100 / r.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(r.compare_at_price - r.price, r.money_format) + "</span>)")),
                    r.price == "Coming Soon" ? $(".js-current-price").html("Coming Soon") : r.price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(r.variants[0].price, r.money_format) + "</span>") : $(".js-current-price").html("Free"));
                else
                    for (var f = 0; f < r.variants.length; f++)
                        n == r.variants[f].id.toString() && (r.variants[f].compare_at_price > r.variants[f].price && $(".js-sale-banner").html("Ships Free"),
                        r.variants[f].compare_at_price > r.variants[f].price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"),
                        r.variants[f].available == !1 && $(".js-sold-out").html("Sold Out"),
                        r.variants[f].available == !0 && (r.variants[f].compare_at_price > r.variants[f].price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(r.variants[f].compare_at_price, r.money_format) + "</span>"),
                        $(".js-savings").html("You Save " + parseInt((r.variants[f].compare_at_price - r.variants[f].price) * 100 / r.variants[f].compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(r.variants[f].compare_at_price - r.variants[f].price, r.money_format) + "</span>)")),
                        r.variants[f].price == "Coming Soon" ? $(".js-current-price").html("Coming Soon") : r.variants[f].price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(r.variants[f].price, r.money_format) + "</span>") : $(".js-current-price").html("Free")))
            }
            $(".js-quick-shop .text-modal-wrap iframe[src*=youtube], .js-quick-shop .text-modal-wrap iframe[src*=vimeo]").mediaWrapper({
                intrinsic: !0
            })
        },
        populateGallery: function(n) {
            var r = $(".js-gallery-modal")
              , s = $(".js-gallery-carousel");
            $(document).on("closed", ".js-quick-shop", function(d) {
                r.flickity("remove", $(".js-gallery-modal .gallery-cell")),
                s.empty()
            });
            function f(d) {
                $.each(n.images, function(m, w) {
                    var _ = w.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", ""), k = w.replace(/(\.[^.]*)$/, "_1024x1024$1").replace("http:", ""), A = w.replace(/(\.[^.]*)$/, "_2048x2048$1").replace("http:", ""), x = n.image_alts[m], E;
                    x.indexOf("youtube") >= 0 ? E = '<div class="video-container youtube"><div>' + x + "</div></div>" : x.indexOf("vimeo") >= 0 ? E = '<div class="video-container vimeo"><div>' + x + "</div></div>" : E = '<img src="' + _ + '" data-src="' + k + '" alt="' + x + '" data-image-id="' + n.image_ids[m].trim() + '" data-index="' + m + '" srcset="' + _ + " 600w, " + k + " 1024w, " + A + ' 2048w" sizes="(min-width: 800px) 50vw, 100vw"/>';
                    var j = $('<div class="gallery-cell">' + E + "</div>");
                    r.flickity("append", j)
                }),
                r.removeClass("single-image multi-image").addClass(d ? "multi-image" : "single-image")
            }
            function l() {
                $.each(n.images, function(d, m) {
                    var w = m.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", "")
                      , _ = '<img src="' + w + '" alt="' + escape(n.image_alts[d]) + '" />'
                      , k = $('<div class="gallery-cell">' + _ + "</div>");
                    s.append(k)
                }),
                imageFunctions.linkGalleryAndCarousel(r, s)
            }
            var h;
            n.images.length > 1 ? (h = !0,
            f(h),
            l()) : (h = !1,
            f(h)),
            imageFunctions.zoom(".js-gallery-modal", !1)
        }
    };
    function ajaxSubmitCart(n) {
        $cart = n,
        $.ajax({
            url: "/cart/update.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $cart.serialize(),
            success: function(r) {
                refreshCart(r)
            }
        })
    }
    function ajaxUpdateCart(n, r, s) {
        $.ajax({
            url: "/cart/change.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: {
                quantity: r,
                line: n
            },
            success: function(f) {
                refreshCart(f);
                var l = n - 1;
                if (typeof f.items[l] == "undefined")
                    var h = 0;
                else
                    var h = f.items[l].quantity;
                if (r > 0 && r != h) {
                    h == 1 ? items_left_text = "item left" : items_left_text = "items left",
                    $(".warning--quantity").remove();
                    var d = '<p class="warning warning--quantity animated bounceIn">' + h + " " + items_left_text + "</p>";
                    s.find("input[data-line-id='" + n + "']").parent().after(d),
                    s.find("input[data-line-id='" + n + "']").val(h)
                } else
                    s.is("#cart_form") && $("#cart_form").submit()
            }
        })
    }
    function refreshCart(n) {
        $(".cart_count").empty(),
        $cartBtn = $(".cart_count");
        var r = $cartBtn.text() || "0"
          , s = ""
          , f = ""
          , l = ""
          , h = $(".cart_content form")
          , d = 0
          , m = 0;
        $cartBtn.text(r.replace(/[0-9]+/, n.item_count)),
        n.item_count == 0 ? ($(".js-empty-cart__message").removeClass("hidden"),
        $(".js-cart_content__form").addClass("hidden")) : ($(".js-empty-cart__message").addClass("hidden"),
        $(".js-cart_content__form").removeClass("hidden"),
        $.each(n.items, function(w, _) {
            var k = w + 1;
            s += '<li class="cart_item clearfix"><a href="' + _.url + '">',
            _.image && (s += '<div class="cart_image"><img src="' + _.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "") + '" alt="' + htmlEncode(_.title) + '" /></div>'),
            s += '<div class="cart_item__title"><div class="item_title">' + _.title,
            _.properties && $.each(_.properties, function(A, x) {
                x && (s += '<div class="line-item">' + A + ": " + x + "</div>")
            }),
            s += "</div></a>",
            s += '<div class="left product-was-price"><div class="right price"><span>Base Price: ',
            s += '<span class="money">' + Shopify.formatMoney(_.price, $("body").data("money-format")) + "</span></span></div></div>"
            s += '<div class="left product-quantity-box"><span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span><input type="number" min="0" class="quantity" name="updates[]" id="updates_' + _.id + '" value="' + _.quantity + '" data-line-id="' + k + '" /><span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span></div></div>',
            s += "</div>"
        }),
        f += '<span class="right"><span class="money">' + Shopify.formatMoney(n.total_price, $("body").data("money-format")) + "</span></span><span>Subtotal</span>",
        m > 0 ? l = '<span class="right"><span class="money">' + Shopify.formatMoney(m - d, $("body").data("money-format")) + "</span></span><span>Total Savings</span>" : l = ""),
        $(".js-cart_items").html(s),
        $(".js-cart_subtotal").html(f),
        $(".js-cart_savings").html(l)
    }
    if ($("body").on("change", "#cart_form input.quantity", function() {
        ajaxUpdateCart($(this).data("line-id"), $(this).val(), $(this).parents("#cart_form"))
    }),
    $("body").on("change", ".cart_content input.quantity", function() {
        ajaxUpdateCart($(this).data("line-id"), $(this).val(), $(this).parents(".cart_content"))
    }),
    $("body").on("submit", ".product_form form", function(e) {
        e.preventDefault();
        var $addToCartForm = $(this)
          , $addToCartBtn = $addToCartForm.find(".add_to_cart");
        return $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $addToCartForm.serialize(),
            beforeSend: function() {
                $addToCartBtn.attr("disabled", "disabled").addClass("disabled"),
                $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")
            },
            success: function(n) {
                $addToCartBtn.find(".checkmark").addClass("checkmark-active"),
                window.setTimeout(function() {
                    $addToCartBtn.removeAttr("disabled").removeClass("disabled"),
                    $addToCartBtn.find(".checkmark").removeClass("checkmark-active"),
                    $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")
                }, 1e3),
                $.ajax({
                    url: "/cart.js",
                    dataType: "json",
                    cache: !1,
                    success: function(r) {
                        if (refreshCart(r),
                        $("html").hasClass("remodal-is-locked") && $(".remodal-close").click(),
                        $("#header").is(":visible") ? $("#header .cart_container").addClass("active_link") : $(".sticky_nav--stick").length ? $(".sticky_nav .cart_container").addClass("active_link") : $(".top_bar .cart_container").addClass("active_link"),
                        $(window).width() <= 798) {
                            var s = $(this).parent();
                            s.hasClass("active_link"),
                            $("body").addClass("blocked-scroll")
                        }
                    }
                })
            },
            error: function(XMLHttpRequest) {
                var response = eval("(" + XMLHttpRequest.responseText + ")");
                response = response.description,
                $(".warning").remove();
                var warning = '<p class="warning animated bounceIn">' + response.replace("All 1 ", "All ") + "</p>";
                $addToCartForm.after(warning),
                $addToCartBtn.removeAttr("disabled").removeClass("disabled"),
                $addToCartBtn.find("span").text("Add to Cart").removeClass("zoomOut").addClass("zoomIn")
            }
        }),
        !1
    }),
    $(".js-product_section").length) {
        var $productForms = $(".js-product_section").find(".product_form");
        $productForms.addClass("is-visible"),
        $productForms.each(function() {
            var n = $(this).data("product")
              , r = $(this).data("product-id")
              , s = ".product-" + r + " .js-product_section"
              , f = $(this).find(".swatch_options .swatch");
            f.length > 1 && Shopify.linkOptionSelectors(n, s)
        })
    }
    $(".js-product_section").length > 1 && $("body").on("click", ".swatch-element", function() {
        var n = $(this).data("value");
        $(this).siblings('input[value="' + n.replace(/\"/g, '\\"') + '"]').prop("checked", !0).trigger("change");
        var r = $(this).parents(".product_form").data("product")
          , s = $(this).parents(".product_form").data("product-id")
          , f = ".product-" + s + " .js-product_section"
          , l = $(this).parents(".product_form").find(".swatch_options .swatch");
        l.length > 1 && Shopify.linkOptionSelectors(r, f)
    })
}),
Shopify.updateOptionsInSelector = function(n, r) {
    switch (n) {
    case 0:
        var s = "root"
          , f = $(r + " .single-option-selector:eq(0)");
        break;
    case 1:
        var s = $(r + " .single-option-selector:eq(0)").val()
          , f = $(r + " .single-option-selector:eq(1)");
        break;
    case 2:
        var s = $(r + " .single-option-selector:eq(0)").val();
        s += " / " + $(r + " .single-option-selector:eq(1)").val();
        var f = $(r + " .single-option-selector:eq(2)")
    }
    var l = Shopify.optionsMap[s];
    $(r + ' .swatch[data-option-index="' + n + '"] .swatch-element').each(function() {
        $.inArray($(this).attr("data-value"), l) !== -1 ? $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
    })
}
,
Shopify.linkOptionSelectors = function(n, r) {
    Shopify.optionsMap = {};
    for (var s = 0; s < n.variants.length; s++) {
        var f = n.variants[s];
        if (f.available) {
            if (Shopify.optionsMap.root = Shopify.optionsMap.root || [],
            Shopify.optionsMap.root.push(f.option1),
            Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root),
            n.options.length > 1) {
                var l = f.option1;
                Shopify.optionsMap[l] = Shopify.optionsMap[l] || [],
                Shopify.optionsMap[l].push(f.option2),
                Shopify.optionsMap[l] = Shopify.uniq(Shopify.optionsMap[l])
            }
            if (n.options.length === 3) {
                var l = f.option1 + " / " + f.option2;
                Shopify.optionsMap[l] = Shopify.optionsMap[l] || [],
                Shopify.optionsMap[l].push(f.option3),
                Shopify.optionsMap[l] = Shopify.uniq(Shopify.optionsMap[l])
            }
        }
    }
    Shopify.updateOptionsInSelector(0, r),
    n.options.length > 1 && Shopify.updateOptionsInSelector(1, r),
    n.options.length === 3 && Shopify.updateOptionsInSelector(2, r),
    $(r + " .single-option-selector:eq(0)").change(function() {
        return Shopify.updateOptionsInSelector(1, r),
        n.options.length === 3 && Shopify.updateOptionsInSelector(2, r),
        !0
    }),
    $(r + " .single-option-selector:eq(1)").change(function() {
        return n.options.length === 3 && Shopify.updateOptionsInSelector(2, r),
        !0
    })
}
;
function htmlEncode(n) {
    return n ? $("<div/>").text(n).html() : ""
}
function is_touch_device() {
    return "ontouchstart"in window || navigator.maxTouchPoints
}
function floatToString(n, r) {
    var s = n.toFixed(r).toString();
    return s.match(/^\.\d+/) ? "0" + s : s
}
if (typeof Shopify == "undefined")
    var Shopify = {};
Shopify.each = function(n, r) {
    for (var s = 0; s < n.length; s++)
        r(n[s], s)
}
,
Shopify.map = function(n, r) {
    for (var s = [], f = 0; f < n.length; f++)
        s.push(r(n[f], f));
    return s
}
,
Shopify.arrayIncludes = function(n, r) {
    for (var s = 0; s < n.length; s++)
        if (n[s] == r)
            return !0;
    return !1
}
,
Shopify.uniq = function(n) {
    for (var r = [], s = 0; s < n.length; s++)
        Shopify.arrayIncludes(r, n[s]) || r.push(n[s]);
    return r
}
,
Shopify.isDefined = function(n) {
    return typeof n != "undefined"
}
,
Shopify.getClass = function(n) {
    return Object.prototype.toString.call(n).slice(8, -1)
}
,
Shopify.extend = function(n, r) {
    function s() {}
    s.prototype = r.prototype,
    n.prototype = new s,
    n.prototype.constructor = n,
    n.baseConstructor = r,
    n.superClass = r.prototype
}
,
Shopify.locationSearch = function() {
    return window.location.search
}
,
Shopify.locationHash = function() {
    return window.location.hash
}
,
Shopify.replaceState = function(n) {
    window.history.replaceState({}, document.title, n)
}
,
Shopify.urlParam = function(n) {
    var r = RegExp("[?&]" + n + "=([^&#]*)").exec(Shopify.locationSearch());
    return r && decodeURIComponent(r[1].replace(/\+/g, " "))
}
,
Shopify.newState = function(n, r) {
    var s;
    return s = Shopify.urlParam(n) ? Shopify.locationSearch().replace(RegExp("(" + n + "=)[^&#]+"), "$1" + r) : Shopify.locationSearch() === "" ? "?" + n + "=" + r : Shopify.locationSearch() + "&" + n + "=" + r,
    s + Shopify.locationHash()
}
,
Shopify.setParam = function(n, r) {
    Shopify.replaceState(Shopify.newState(n, r))
}
,
Shopify.Product = function(n) {
    Shopify.isDefined(n) && this.update(n)
}
,
Shopify.Product.prototype.update = function(n) {
    for (property in n)
        this[property] = n[property]
}
,
Shopify.Product.prototype.optionNames = function() {
    return Shopify.getClass(this.options) == "Array" ? this.options : []
}
,
Shopify.Product.prototype.optionValues = function(n) {
    if (!Shopify.isDefined(this.variants))
        return null;
    var r = Shopify.map(this.variants, function(s) {
        var f = "option" + (n + 1);
        return s[f] == null ? null : s[f]
    });
    return r[0] == null ? null : Shopify.uniq(r)
}
,
Shopify.Product.prototype.getVariant = function(n) {
    var r = null;
    return n.length != this.options.length || Shopify.each(this.variants, function(s) {
        for (var f = !0, l = 0; l < n.length; l++) {
            var h = "option" + (l + 1);
            s[h] != n[l] && (f = !1)
        }
        return f == 1 ? void (r = s) : void 0
    }),
    r
}
,
Shopify.Product.prototype.getVariantById = function(n) {
    for (var r = 0; r < this.variants.length; r++) {
        var s = this.variants[r];
        if (n == s.id)
            return s
    }
    return null
}
,
Shopify.money_format = "$",
Shopify.formatMoney = function(n, r) {
    function s(m, w) {
        return typeof m == "undefined" ? w : m
    }
    function f(m, w, _, k) {
        if (w = s(w, 2),
        _ = s(_, ","),
        k = s(k, "."),
        isNaN(m) || m == null)
            return 0;
        m = (m / 100).toFixed(w);
        var A = m.split(".")
          , x = A[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + _)
          , E = A[1] ? k + A[1] : "";
        return x + E
    }
    typeof n == "string" && (n = n.replace(".", ""));
    var l = ""
      , h = /\{\{\s*(\w+)\s*\}\}/
      , d = r || this.money_format;
    switch (d.match(h)[1]) {
    case "amount":
        l = f(n, 2);
        break;
    case "amount_no_decimals":
        l = f(n, 0);
        break;
    case "amount_with_comma_separator":
        l = f(n, 2, ".", ",");
        break;
    case "amount_no_decimals_with_comma_separator":
        l = f(n, 0, ".", ",")
    }
    return d.replace(h, l)
}
,
Shopify.OptionSelectors = function(n, r) {
    return this.selectorDivClass = "selector-wrapper",
    this.selectorClass = "single-option-selector",
    this.variantIdFieldIdSuffix = "-variant-id",
    this.variantIdField = null,
    this.historyState = null,
    this.selectors = [],
    this.domIdPrefix = n,
    this.product = new Shopify.Product(r.product),
    this.onVariantSelected = Shopify.isDefined(r.onVariantSelected) ? r.onVariantSelected : function() {}
    ,
    this.replaceSelector(n),
    this.initDropdown(),
    r.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
    !0
}
,
Shopify.OptionSelectors.prototype.initDropdown = function() {
    var n = {
        initialLoad: !0
    }
      , r = this.selectVariantFromDropdown(n);
    if (!r) {
        var s = this;
        setTimeout(function() {
            s.selectVariantFromParams(n) || s.fireOnChangeForFirstDropdown.call(s, n)
        })
    }
}
,
Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(n) {
    this.selectors[0].element.onchange(n)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(n) {
    var r = this.selectVariantFromParams(n);
    r || this.selectVariantFromDropdown(n)
}
,
Shopify.OptionSelectors.prototype.replaceSelector = function(n) {
    var r = document.getElementById(n)
      , s = r.parentNode;
    Shopify.each(this.buildSelectors(), function(f) {
        s.insertBefore(f, r)
    }),
    r.style.display = "none",
    this.variantIdField = r
}
,
Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(n) {
    var r = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (r || (r = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),
    !r)
        return !1;
    var s = r.value;
    return this.selectVariant(s, n)
}
,
Shopify.OptionSelectors.prototype.selectVariantFromParams = function(n) {
    var r = Shopify.urlParam("variant");
    return this.selectVariant(r, n)
}
,
Shopify.OptionSelectors.prototype.selectVariant = function(n, r) {
    var s = this.product.getVariantById(n);
    if (s == null)
        return !1;
    for (var f = 0; f < this.selectors.length; f++) {
        var l = this.selectors[f].element
          , h = l.getAttribute("data-option")
          , d = s[h];
        d != null && this.optionExistInSelect(l, d) && (l.value = d)
    }
    return typeof jQuery != "undefined" ? jQuery(this.selectors[0].element).trigger("change", r) : this.selectors[0].element.onchange(r),
    !0
}
,
Shopify.OptionSelectors.prototype.optionExistInSelect = function(n, r) {
    for (var s = 0; s < n.options.length; s++)
        if (n.options[s].value == r)
            return !0
}
,
Shopify.OptionSelectors.prototype.insertSelectors = function(n, r) {
    Shopify.isDefined(r) && this.setMessageElement(r),
    this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var s = document.getElementById(n);
    Shopify.each(this.buildSelectors(), function(f) {
        s.appendChild(f)
    })
}
,
Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var n = 0; n < this.product.optionNames().length; n++) {
        var r = new Shopify.SingleOptionSelector(this,n,this.product.optionNames()[n],this.product.optionValues(n));
        r.element.disabled = !1,
        this.selectors.push(r)
    }
    var s = this.selectorDivClass
      , f = this.product.optionNames()
      , l = Shopify.map(this.selectors, function(h) {
        var d = document.createElement("div");
        if (d.setAttribute("class", s),
        f.length > 1) {
            var m = document.createElement("label");
            m.htmlFor = h.element.id,
            m.innerHTML = h.name,
            d.appendChild(m)
        }
        return d.appendChild(h.element),
        d
    });
    return l
}
,
Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var n = [], r = 0; r < this.selectors.length; r++) {
        var s = this.selectors[r].element.value;
        n.push(s)
    }
    return n
}
,
Shopify.OptionSelectors.prototype.updateSelectors = function(n, r) {
    var s = this.selectedValues()
      , f = this.product.getVariant(s);
    f ? (this.variantIdField.disabled = !1,
    this.variantIdField.value = f.id) : this.variantIdField.disabled = !0,
    this.onVariantSelected(f, this, r),
    this.historyState != null && this.historyState.onVariantChange(f, this, r)
}
,
Shopify.OptionSelectorsFromDOM = function(n, r) {
    var s = r.optionNames || []
      , f = r.priceFieldExists || !0
      , l = r.delimiter || "/"
      , h = this.createProductFromSelector(n, s, f, l);
    r.product = h,
    Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, n, r)
}
,
Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(n, r, l, h) {
    if (!Shopify.isDefined(l))
        var l = !0;
    if (!Shopify.isDefined(h))
        var h = "/";
    var d = document.getElementById(n)
      , m = d.childNodes
      , w = (d.parentNode,
    r.length)
      , _ = [];
    Shopify.each(m, function(x, E) {
        if (x.nodeType == 1 && x.tagName.toLowerCase() == "option") {
            var j = x.innerHTML.split(new RegExp("\\s*\\" + h + "\\s*"));
            r.length == 0 && (w = j.length - (l ? 1 : 0));
            var L = j.slice(0, w)
              , C = l ? j[w] : ""
              , O = (x.getAttribute("value"),
            {
                available: !x.disabled,
                id: parseFloat(x.value),
                price: C,
                option1: L[0],
                option2: L[1],
                option3: L[2]
            });
            _.push(O)
        }
    });
    var k = {
        variants: _
    };
    if (r.length == 0) {
        k.options = [];
        for (var A = 0; w > A; A++)
            k.options[A] = "option " + (A + 1)
    } else
        k.options = r;
    return k
}
,
Shopify.SingleOptionSelector = function(n, r, s, f) {
    this.multiSelector = n,
    this.values = f,
    this.index = r,
    this.name = s,
    this.element = document.createElement("select");
    for (var l = 0; l < f.length; l++) {
        var h = document.createElement("option");
        h.value = f[l],
        h.innerHTML = f[l],
        this.element.appendChild(h)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass),
    this.element.setAttribute("data-option", "option" + (r + 1)),
    this.element.id = n.domIdPrefix + "-option-" + r,
    this.element.onchange = function(d, m) {
        m = m || {},
        n.updateSelectors(r, m)
    }
    ,
    !0
}
,
Shopify.Image = {
    preload: function(n, r) {
        for (var s = 0; s < n.length; s++) {
            var f = n[s];
            this.loadImage(this.getSizedImageUrl(f, r))
        }
    },
    loadImage: function(n) {
        new Image().src = n
    },
    switchImage: function(n, r, s) {
        if (n && r) {
            var f = this.imageSize(r.src)
              , l = this.getSizedImageUrl(n.src, f);
            s ? s(l, n, r) : r.src = l
        }
    },
    imageSize: function(n) {
        var r = n.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return r != null ? r[1] : null
    },
    getSizedImageUrl: function(n, r) {
        if (r == null)
            return n;
        if (r == "master")
            return this.removeProtocol(n);
        var s = n.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (s != null) {
            var f = n.split(s[0])
              , l = s[0];
            return this.removeProtocol(f[0] + "_" + r + l)
        }
        return null
    },
    removeProtocol: function(n) {
        return n.replace(/http(s)?:/, "")
    }
},
Shopify.OptionSelectors.HistoryState = function(n) {
    this.browserSupports() && this.register(n)
}
,
Shopify.OptionSelectors.HistoryState.prototype.register = function(n) {
    window.addEventListener("popstate", function(r) {
        n.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
}
,
Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(n, r, s) {
    this.browserSupports() && (!n || s.initialLoad || s.popStateCall || Shopify.setParam("variant", n.id))
}
,
Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
}
;
/*
 * jQuery offscreen plugin
 *
 * Copyright Cory LaViska for A Beautiful Site, LLC
 *
 * @license: http://opensource.org/licenses/MIT
 *
 */
(function(n) {
    n.extend(n.expr[":"], {
        "off-top": function(r) {
            return n(r).offset().top < n(window).scrollTop()
        },
        "off-right": function(r) {
            return n(r).offset().left + n(r).outerWidth() - n(window).scrollLeft() > n(window).width()
        },
        "off-bottom": function(r) {
            return n(r).offset().top + n(r).outerHeight() - n(window).scrollTop() > n(window).height()
        },
        "off-left": function(r) {
            return n(r).offset().left < n(window).scrollLeft()
        },
        "off-screen": function(r) {
            return n(r).is(":off-top, :off-right, :off-bottom, :off-left")
        }
    })
}
)(jQuery);
/*!
  Zoom 1.7.15
  license: MIT
  http://www.jacklmoore.com/zoom
*/
(function(n) {
    var r = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
    };
    n.zoom = function(s, f, l, h) {
        var d, m, w, _, k, A, x, E = n(s), j = E.css("position"), L = n(f);
        return E.css("position", /(absolute|fixed)/.test(j) ? j : "relative"),
        E.css("overflow", "hidden"),
        l.style.width = l.style.height = "",
        n(l).addClass("zoomImg").css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: l.width * h,
            height: l.height * h,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
        }).appendTo(s),
        {
            init: function() {
                m = E.outerWidth(),
                d = E.outerHeight(),
                f === E[0] ? (_ = m,
                w = d) : (_ = L.outerWidth(),
                w = L.outerHeight()),
                k = (l.width - m) / _,
                A = (l.height - d) / w,
                x = L.offset()
            },
            move: function(C) {
                var O = C.pageX - x.left
                  , M = C.pageY - x.top;
                M = Math.max(Math.min(M, w), 0),
                O = Math.max(Math.min(O, _), 0),
                l.style.left = O * -k + "px",
                l.style.top = M * -A + "px"
            }
        }
    }
    ,
    n.fn.zoom = function(s) {
        return this.each(function() {
            var f = n.extend({}, r, s || {}), l = f.target || this, h = this, d = n(h), m = n(l), w = document.createElement("img"), _ = n(w), k = "mousemove.zoom", A = !1, x = !1, E;
            !f.url && (E = d.find("img"),
            E[0] && (f.url = E.data("src") || E.attr("src")),
            !f.url) || (function() {
                var j = m.css("position")
                  , L = m.css("overflow");
                d.one("zoom.destroy", function() {
                    d.off(".zoom"),
                    m.css("position", j),
                    m.css("overflow", L),
                    _.remove()
                })
            }(),
            w.onload = function() {
                var j = n.zoom(l, h, w, f.magnify);
                function L(O) {
                    j.init(),
                    j.move(O),
                    _.stop().fadeTo(n.support.opacity ? f.duration : 0, 1, n.isFunction(f.onZoomIn) ? f.onZoomIn.call(w) : !1)
                }
                function C() {
                    _.stop().fadeTo(f.duration, 0, n.isFunction(f.onZoomOut) ? f.onZoomOut.call(w) : !1)
                }
                f.on === "grab" ? d.on("mousedown.zoom", function(O) {
                    O.which === 1 && (n(document).one("mouseup.zoom", function() {
                        C(),
                        n(document).off(k, j.move)
                    }),
                    L(O),
                    n(document).on(k, j.move),
                    O.preventDefault())
                }) : f.on === "click" ? d.on("click.zoom", function(O) {
                    if (!A)
                        return A = !0,
                        L(O),
                        n(document).on(k, j.move),
                        n(document).one("click.zoom", function() {
                            C(),
                            A = !1,
                            n(document).off(k, j.move)
                        }),
                        !1
                }) : f.on === "toggle" ? d.on("click.zoom", function(O) {
                    A ? C() : L(O),
                    A = !A
                }) : f.on === "mouseover" && (j.init(),
                d.on("mouseenter.zoom", L).on("mouseleave.zoom", C).on(k, j.move)),
                f.touch && d.on("touchstart.zoom", function(O) {
                    O.preventDefault(),
                    x ? (x = !1,
                    C()) : (x = !0,
                    L(O.originalEvent.touches[0] || O.originalEvent.changedTouches[0]))
                }).on("touchmove.zoom", function(O) {
                    O.preventDefault(),
                    j.move(O.originalEvent.touches[0] || O.originalEvent.changedTouches[0])
                }).on("touchend.zoom", function(O) {
                    O.preventDefault(),
                    x && (x = !1,
                    C())
                }),
                n.isFunction(f.callback) && f.callback.call(w)
            }
            ,
            w.src = f.url)
        })
    }
    ,
    n.fn.zoom.defaults = r
}
)(window.jQuery),
function(n, r) {
    typeof define == "function" && define.amd ? define(["jquery"], function(s) {
        return r(n, s)
    }) : typeof exports == "object" ? r(n, require("jquery")) : r(n, n.jQuery || n.Zepto)
}(this, function(n, r) {
    "use strict";
    function s(H) {
        if (ce && H.css("animation-name") === "none" && H.css("-webkit-animation-name") === "none" && H.css("-moz-animation-name") === "none" && H.css("-o-animation-name") === "none" && H.css("-ms-animation-name") === "none")
            return 0;
        var W, Z, Y, X, pe = H.css("animation-duration") || H.css("-webkit-animation-duration") || H.css("-moz-animation-duration") || H.css("-o-animation-duration") || H.css("-ms-animation-duration") || "0s", Ce = H.css("animation-delay") || H.css("-webkit-animation-delay") || H.css("-moz-animation-delay") || H.css("-o-animation-delay") || H.css("-ms-animation-delay") || "0s", Le = H.css("animation-iteration-count") || H.css("-webkit-animation-iteration-count") || H.css("-moz-animation-iteration-count") || H.css("-o-animation-iteration-count") || H.css("-ms-animation-iteration-count") || "1";
        for (pe = pe.split(", "),
        Ce = Ce.split(", "),
        Le = Le.split(", "),
        X = 0,
        Z = pe.length,
        W = Number.NEGATIVE_INFINITY; X < Z; X++)
            Y = parseFloat(pe[X]) * parseInt(Le[X], 10) + parseFloat(Ce[X]),
            Y > W && (W = Y);
        return W
    }
    function f() {
        if (r(document.body).height() <= r(window).height())
            return 0;
        var H, W, Z = document.createElement("div"), Y = document.createElement("div");
        return Z.style.visibility = "hidden",
        Z.style.width = "100px",
        document.body.appendChild(Z),
        H = Z.offsetWidth,
        Z.style.overflow = "scroll",
        Y.style.width = "100%",
        Z.appendChild(Y),
        W = Y.offsetWidth,
        Z.parentNode.removeChild(Z),
        H - W
    }
    function l() {
        if (!ve) {
            var H, W, Z = r("html"), Y = k("is-locked");
            Z.hasClass(Y) || (W = r(document.body),
            H = parseInt(W.css("padding-right"), 10) + f(),
            W.css("padding-right", H + "px"),
            Z.addClass(Y))
        }
    }
    function h() {
        if (!ve) {
            var H, W, Z = r("html"), Y = k("is-locked");
            Z.hasClass(Y) && (W = r(document.body),
            H = parseInt(W.css("padding-right"), 10) - f(),
            W.css("padding-right", H + "px"),
            Z.removeClass(Y))
        }
    }
    function d(H, W, Z, Y) {
        var X = k("is", W)
          , pe = [k("is", G.CLOSING), k("is", G.OPENING), k("is", G.CLOSED), k("is", G.OPENED)].join(" ");
        H.$bg.removeClass(pe).addClass(X),
        H.$overlay.removeClass(pe).addClass(X),
        H.$wrapper.removeClass(pe).addClass(X),
        H.$modal.removeClass(pe).addClass(X),
        H.state = W,
        !Z && H.$modal.trigger({
            type: W,
            reason: Y
        }, [{
            reason: Y
        }])
    }
    function m(H, W, Z) {
        var Y = 0
          , X = function(Ce) {
            Ce.target === this && Y++
        }
          , pe = function(Ce) {
            Ce.target === this && --Y === 0 && (r.each(["$bg", "$overlay", "$wrapper", "$modal"], function(Le, At) {
                Z[At].off(O + " " + M)
            }),
            W())
        };
        r.each(["$bg", "$overlay", "$wrapper", "$modal"], function(Ce, Le) {
            Z[Le].on(O, X).on(M, pe)
        }),
        H(),
        s(Z.$bg) === 0 && s(Z.$overlay) === 0 && s(Z.$wrapper) === 0 && s(Z.$modal) === 0 && (r.each(["$bg", "$overlay", "$wrapper", "$modal"], function(Ce, Le) {
            Z[Le].off(O + " " + M)
        }),
        W())
    }
    function w(H) {
        H.state !== G.CLOSED && (r.each(["$bg", "$overlay", "$wrapper", "$modal"], function(W, Z) {
            H[Z].off(O + " " + M)
        }),
        H.$bg.removeClass(H.settings.modifier),
        H.$overlay.removeClass(H.settings.modifier).hide(),
        H.$wrapper.hide(),
        h(),
        d(H, G.CLOSED, !0))
    }
    function _(H) {
        var W, Z, Y, X, pe = {};
        for (H = H.replace(/\s*:\s*/g, ":").replace(/\s*,\s*/g, ","),
        W = H.split(","),
        X = 0,
        Z = W.length; X < Z; X++)
            W[X] = W[X].split(":"),
            Y = W[X][1],
            (typeof Y == "string" || Y instanceof String) && (Y = Y === "true" || Y !== "false" && Y),
            (typeof Y == "string" || Y instanceof String) && (Y = isNaN(Y) ? Y : +Y),
            pe[W[X][0]] = Y;
        return pe
    }
    function k() {
        for (var H = C, W = 0; W < arguments.length; ++W)
            H += "-" + arguments[W];
        return H
    }
    function A() {
        var H, W, Z = location.hash.replace("#", "");
        if (Z) {
            try {
                W = r('[data-remodal-id="' + Z + '"]')
            } catch (Y) {}
            W && W.length && (H = r[L].lookup[W.data(L)],
            H && H.settings.hashTracking && H.open())
        } else
            E && E.state === G.OPENED && E.settings.hashTracking && E.close()
    }
    function x(H, W) {
        var Z = r(document.body)
          , Y = Z
          , X = this;
        X.settings = r.extend({}, U, W),
        X.index = r[L].lookup.push(X) - 1,
        X.state = G.CLOSED,
        X.$overlay = r("." + k("overlay")),
        X.settings.appendTo !== null && X.settings.appendTo.length && (Y = r(X.settings.appendTo)),
        X.$overlay.length || (X.$overlay = r("<div>").addClass(k("overlay") + " " + k("is", G.CLOSED)).hide(),
        Y.append(X.$overlay)),
        X.$bg = r("." + k("bg")).addClass(k("is", G.CLOSED)),
        X.$modal = H.addClass(C + " " + k("is-initialized") + " " + X.settings.modifier + " " + k("is", G.CLOSED)).attr("tabindex", "-1"),
        X.$wrapper = r("<div>").addClass(k("wrapper") + " " + X.settings.modifier + " " + k("is", G.CLOSED)).hide().append(X.$modal),
        Y.append(X.$wrapper),
        X.$wrapper.on("click." + C, '[data-remodal-action="close"]', function(pe) {
            pe.preventDefault(),
            X.close()
        }),
        X.$wrapper.on("click." + C, '[data-remodal-action="cancel"]', function(pe) {
            pe.preventDefault(),
            X.$modal.trigger(u.CANCELLATION),
            X.settings.closeOnCancel && X.close(u.CANCELLATION)
        }),
        X.$wrapper.on("click." + C, '[data-remodal-action="confirm"]', function(pe) {
            pe.preventDefault(),
            X.$modal.trigger(u.CONFIRMATION),
            X.settings.closeOnConfirm && X.close(u.CONFIRMATION)
        }),
        X.$wrapper.on("click." + C, function(pe) {
            var Ce = r(pe.target);
            Ce.hasClass(k("wrapper")) && X.settings.closeOnOutsideClick && X.close()
        })
    }
    var E, j, L = "remodal", C = n.REMODAL_GLOBALS && n.REMODAL_GLOBALS.NAMESPACE || L, O = r.map(["animationstart", "webkitAnimationStart", "MSAnimationStart", "oAnimationStart"], function(H) {
        return H + "." + C
    }).join(" "), M = r.map(["animationend", "webkitAnimationEnd", "MSAnimationEnd", "oAnimationEnd"], function(H) {
        return H + "." + C
    }).join(" "), U = r.extend({
        hashTracking: !0,
        closeOnConfirm: !0,
        closeOnCancel: !0,
        closeOnEscape: !0,
        closeOnOutsideClick: !0,
        modifier: "",
        appendTo: null
    }, n.REMODAL_GLOBALS && n.REMODAL_GLOBALS.DEFAULTS), G = {
        CLOSING: "closing",
        CLOSED: "closed",
        OPENING: "opening",
        OPENED: "opened"
    }, u = {
        CONFIRMATION: "confirmation",
        CANCELLATION: "cancellation"
    }, ce = function() {
        var H = document.createElement("div").style;
        return H.animationName !== void 0 || H.WebkitAnimationName !== void 0 || H.MozAnimationName !== void 0 || H.msAnimationName !== void 0 || H.OAnimationName !== void 0
    }(), ve = /iPad|iPhone|iPod/.test(navigator.platform);
    x.prototype.open = function() {
        var H, W = this;
        W.state !== G.OPENING && W.state !== G.CLOSING && (H = W.$modal.attr("data-remodal-id"),
        H && W.settings.hashTracking && (j = r(window).scrollTop(),
        location.hash = H),
        E && E !== W && w(E),
        E = W,
        l(),
        W.$bg.addClass(W.settings.modifier),
        W.$overlay.addClass(W.settings.modifier).show(),
        W.$wrapper.show().scrollTop(0),
        W.$modal.focus(),
        m(function() {
            d(W, G.OPENING)
        }, function() {
            d(W, G.OPENED)
        }, W))
    }
    ,
    x.prototype.close = function(H) {
        var W = this;
        W.state !== G.OPENING && W.state !== G.CLOSING && (W.settings.hashTracking && W.$modal.attr("data-remodal-id") === location.hash.substr(1) && (location.hash = "",
        r(window).scrollTop(j)),
        m(function() {
            d(W, G.CLOSING, !1, H)
        }, function() {
            W.$bg.removeClass(W.settings.modifier),
            W.$overlay.removeClass(W.settings.modifier).hide(),
            W.$wrapper.hide(),
            h(),
            d(W, G.CLOSED, !1, H)
        }, W))
    }
    ,
    x.prototype.getState = function() {
        return this.state
    }
    ,
    x.prototype.destroy = function() {
        var H, W = r[L].lookup;
        w(this),
        this.$wrapper.remove(),
        delete W[this.index],
        H = r.grep(W, function(Z) {
            return !!Z
        }).length,
        H === 0 && (this.$overlay.remove(),
        this.$bg.removeClass(k("is", G.CLOSING) + " " + k("is", G.OPENING) + " " + k("is", G.CLOSED) + " " + k("is", G.OPENED)))
    }
    ,
    r[L] = {
        lookup: []
    },
    r.fn[L] = function(H) {
        var W, Z;
        return this.each(function(Y, X) {
            Z = r(X),
            Z.data(L) == null ? (W = new x(Z,H),
            Z.data(L, W.index),
            W.settings.hashTracking && Z.attr("data-remodal-id") === location.hash.substr(1) && W.open()) : W = r[L].lookup[Z.data(L)]
        }),
        W
    }
    ,
    r(document).ready(function() {
        r("body").on("click", "[data-remodal-target]", function(H) {
            H.preventDefault();
            var W = H.currentTarget
              , Z = W.getAttribute("data-remodal-target")
              , Y = r('[data-remodal-id="' + Z + '"]');
            r[L].lookup[Y.data(L)].open()
        }),
        r("body").find("." + C).each(function(H, W) {
            var Z = r(W)
              , Y = Z.data("remodal-options");
            Y ? (typeof Y == "string" || Y instanceof String) && (Y = _(Y)) : Y = {},
            Z[L](Y)
        }),
        r("body").on("keydown." + C, function(H) {
            E && E.settings.closeOnEscape && E.state === G.OPENED && H.keyCode === 27 && E.close()
        }),
        r(window).on("hashchange." + C, A)
    })
});
/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(n) {
    var r = !1;
    if (typeof define == "function" && define.amd && (define(n),
    r = !0),
    typeof exports == "object" && (module.exports = n(),
    r = !0),
    !r) {
        var s = window.Cookies
          , f = window.Cookies = n();
        f.noConflict = function() {
            return window.Cookies = s,
            f
        }
    }
}
)(function() {
    function n() {
        for (var s = 0, f = {}; s < arguments.length; s++) {
            var l = arguments[s];
            for (var h in l)
                f[h] = l[h]
        }
        return f
    }
    function r(s) {
        function f(l, h, d) {
            var m;
            if (typeof document != "undefined") {
                if (arguments.length > 1) {
                    if (typeof (d = n({
                        path: "/"
                    }, f.defaults, d)).expires == "number") {
                        var w = new Date;
                        w.setMilliseconds(w.getMilliseconds() + 864e5 * d.expires),
                        d.expires = w
                    }
                    d.expires = d.expires ? d.expires.toUTCString() : "";
                    try {
                        m = JSON.stringify(h),
                        /^[\{\[]/.test(m) && (h = m)
                    } catch (O) {}
                    h = s.write ? s.write(h, l) : encodeURIComponent(String(h)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent),
                    l = (l = (l = encodeURIComponent(String(l))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
                    var _ = "";
                    for (var k in d)
                        d[k] && (_ += "; " + k,
                        d[k] !== !0 && (_ += "=" + d[k]));
                    return document.cookie = l + "=" + h + _
                }
                l || (m = {});
                for (var A = document.cookie ? document.cookie.split("; ") : [], x = /(%[0-9A-Z]{2})+/g, E = 0; E < A.length; E++) {
                    var j = A[E].split("=")
                      , L = j.slice(1).join("=");
                    L.charAt(0) === '"' && (L = L.slice(1, -1));
                    try {
                        var C = j[0].replace(x, decodeURIComponent);
                        if (L = s.read ? s.read(L, C) : s(L, C) || L.replace(x, decodeURIComponent),
                        this.json)
                            try {
                                L = JSON.parse(L)
                            } catch (O) {}
                        if (l === C) {
                            m = L;
                            break
                        }
                        l || (m[C] = L)
                    } catch (O) {}
                }
                return m
            }
        }
        return f.set = f,
        f.get = function(l) {
            return f.call(f, l)
        }
        ,
        f.getJSON = function() {
            return f.apply({
                json: !0
            }, [].slice.call(arguments))
        }
        ,
        f.defaults = {},
        f.remove = function(l, h) {
            f(l, "", n(h, {
                expires: -1
            }))
        }
        ,
        f.withConverter = r,
        f
    }
    return r(function() {})
});
/*!
Waypoints - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
(function() {
    "use strict";
    function n(f) {
        if (!f)
            throw new Error("No options passed to Waypoint constructor");
        if (!f.element)
            throw new Error("No element option passed to Waypoint constructor");
        if (!f.handler)
            throw new Error("No handler option passed to Waypoint constructor");
        this.key = "waypoint-" + r,
        this.options = n.Adapter.extend({}, n.defaults, f),
        this.element = this.options.element,
        this.adapter = new n.Adapter(this.element),
        this.callback = f.handler,
        this.axis = this.options.horizontal ? "horizontal" : "vertical",
        this.enabled = this.options.enabled,
        this.triggerPoint = null,
        this.group = n.Group.findOrCreate({
            name: this.options.group,
            axis: this.axis
        }),
        this.context = n.Context.findOrCreateByElement(this.options.context),
        n.offsetAliases[this.options.offset] && (this.options.offset = n.offsetAliases[this.options.offset]),
        this.group.add(this),
        this.context.add(this),
        s[this.key] = this,
        r += 1
    }
    var r = 0
      , s = {};
    n.prototype.queueTrigger = function(f) {
        this.group.queueTrigger(this, f)
    }
    ,
    n.prototype.trigger = function(f) {
        this.enabled && this.callback && this.callback.apply(this, f)
    }
    ,
    n.prototype.destroy = function() {
        this.context.remove(this),
        this.group.remove(this),
        delete s[this.key]
    }
    ,
    n.prototype.disable = function() {
        return this.enabled = !1,
        this
    }
    ,
    n.prototype.enable = function() {
        return this.context.refresh(),
        this.enabled = !0,
        this
    }
    ,
    n.prototype.next = function() {
        return this.group.next(this)
    }
    ,
    n.prototype.previous = function() {
        return this.group.previous(this)
    }
    ,
    n.invokeAll = function(f) {
        var l = [];
        for (var h in s)
            l.push(s[h]);
        for (var d = 0, m = l.length; m > d; d++)
            l[d][f]()
    }
    ,
    n.destroyAll = function() {
        n.invokeAll("destroy")
    }
    ,
    n.disableAll = function() {
        n.invokeAll("disable")
    }
    ,
    n.enableAll = function() {
        n.invokeAll("enable")
    }
    ,
    n.refreshAll = function() {
        n.Context.refreshAll()
    }
    ,
    n.viewportHeight = function() {
        return window.innerHeight || document.documentElement.clientHeight
    }
    ,
    n.viewportWidth = function() {
        return document.documentElement.clientWidth
    }
    ,
    n.adapters = [],
    n.defaults = {
        context: window,
        continuous: !0,
        enabled: !0,
        group: "default",
        horizontal: !1,
        offset: 0
    },
    n.offsetAliases = {
        "bottom-in-view": function() {
            return this.context.innerHeight() - this.adapter.outerHeight()
        },
        "right-in-view": function() {
            return this.context.innerWidth() - this.adapter.outerWidth()
        }
    },
    window.Waypoint = n
}
)(),
function() {
    "use strict";
    function n(d) {
        window.setTimeout(d, 1e3 / 60)
    }
    function r(d) {
        this.element = d,
        this.Adapter = l.Adapter,
        this.adapter = new this.Adapter(d),
        this.key = "waypoint-context-" + s,
        this.didScroll = !1,
        this.didResize = !1,
        this.oldScroll = {
            x: this.adapter.scrollLeft(),
            y: this.adapter.scrollTop()
        },
        this.waypoints = {
            vertical: {},
            horizontal: {}
        },
        d.waypointContextKey = this.key,
        f[d.waypointContextKey] = this,
        s += 1,
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler()
    }
    var s = 0
      , f = {}
      , l = window.Waypoint
      , h = window.onload;
    r.prototype.add = function(d) {
        var m = d.options.horizontal ? "horizontal" : "vertical";
        this.waypoints[m][d.key] = d,
        this.refresh()
    }
    ,
    r.prototype.checkEmpty = function() {
        var d = this.Adapter.isEmptyObject(this.waypoints.horizontal)
          , m = this.Adapter.isEmptyObject(this.waypoints.vertical);
        d && m && (this.adapter.off(".waypoints"),
        delete f[this.key])
    }
    ,
    r.prototype.createThrottledResizeHandler = function() {
        function d() {
            m.handleResize(),
            m.didResize = !1
        }
        var m = this;
        this.adapter.on("resize.waypoints", function() {
            m.didResize || (m.didResize = !0,
            l.requestAnimationFrame(d))
        })
    }
    ,
    r.prototype.createThrottledScrollHandler = function() {
        function d() {
            m.handleScroll(),
            m.didScroll = !1
        }
        var m = this;
        this.adapter.on("scroll.waypoints", function() {
            (!m.didScroll || l.isTouch) && (m.didScroll = !0,
            l.requestAnimationFrame(d))
        })
    }
    ,
    r.prototype.handleResize = function() {
        l.Context.refreshAll()
    }
    ,
    r.prototype.handleScroll = function() {
        var d = {}
          , m = {
            horizontal: {
                newScroll: this.adapter.scrollLeft(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left"
            },
            vertical: {
                newScroll: this.adapter.scrollTop(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up"
            }
        };
        for (var w in m) {
            var _ = m[w]
              , k = _.newScroll > _.oldScroll
              , A = k ? _.forward : _.backward;
            for (var x in this.waypoints[w]) {
                var E = this.waypoints[w][x]
                  , j = _.oldScroll < E.triggerPoint
                  , L = _.newScroll >= E.triggerPoint
                  , C = j && L
                  , O = !j && !L;
                (C || O) && (E.queueTrigger(A),
                d[E.group.id] = E.group)
            }
        }
        for (var M in d)
            d[M].flushTriggers();
        this.oldScroll = {
            x: m.horizontal.newScroll,
            y: m.vertical.newScroll
        }
    }
    ,
    r.prototype.innerHeight = function() {
        return this.element == this.element.window ? l.viewportHeight() : this.adapter.innerHeight()
    }
    ,
    r.prototype.remove = function(d) {
        delete this.waypoints[d.axis][d.key],
        this.checkEmpty()
    }
    ,
    r.prototype.innerWidth = function() {
        return this.element == this.element.window ? l.viewportWidth() : this.adapter.innerWidth()
    }
    ,
    r.prototype.destroy = function() {
        var d = [];
        for (var m in this.waypoints)
            for (var w in this.waypoints[m])
                d.push(this.waypoints[m][w]);
        for (var _ = 0, k = d.length; k > _; _++)
            d[_].destroy()
    }
    ,
    r.prototype.refresh = function() {
        var d, m = this.element == this.element.window, w = m ? void 0 : this.adapter.offset(), _ = {};
        this.handleScroll(),
        d = {
            horizontal: {
                contextOffset: m ? 0 : w.left,
                contextScroll: m ? 0 : this.oldScroll.x,
                contextDimension: this.innerWidth(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left",
                offsetProp: "left"
            },
            vertical: {
                contextOffset: m ? 0 : w.top,
                contextScroll: m ? 0 : this.oldScroll.y,
                contextDimension: this.innerHeight(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up",
                offsetProp: "top"
            }
        };
        for (var k in d) {
            var A = d[k];
            for (var x in this.waypoints[k]) {
                var E, j, L, C, O, M = this.waypoints[k][x], U = M.options.offset, G = M.triggerPoint, u = 0, ce = G == null;
                M.element !== M.element.window && (u = M.adapter.offset()[A.offsetProp]),
                typeof U == "function" ? U = U.apply(M) : typeof U == "string" && (U = parseFloat(U),
                M.options.offset.indexOf("%") > -1 && (U = Math.ceil(A.contextDimension * U / 100))),
                E = A.contextScroll - A.contextOffset,
                M.triggerPoint = u + E - U,
                j = G < A.oldScroll,
                L = M.triggerPoint >= A.oldScroll,
                C = j && L,
                O = !j && !L,
                !ce && C ? (M.queueTrigger(A.backward),
                _[M.group.id] = M.group) : (!ce && O || ce && A.oldScroll >= M.triggerPoint) && (M.queueTrigger(A.forward),
                _[M.group.id] = M.group)
            }
        }
        return l.requestAnimationFrame(function() {
            for (var ve in _)
                _[ve].flushTriggers()
        }),
        this
    }
    ,
    r.findOrCreateByElement = function(d) {
        return r.findByElement(d) || new r(d)
    }
    ,
    r.refreshAll = function() {
        for (var d in f)
            f[d].refresh()
    }
    ,
    r.findByElement = function(d) {
        return f[d.waypointContextKey]
    }
    ,
    window.onload = function() {
        h && h(),
        r.refreshAll()
    }
    ,
    l.requestAnimationFrame = function(d) {
        var m = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || n;
        m.call(window, d)
    }
    ,
    l.Context = r
}(),
function() {
    "use strict";
    function n(h, d) {
        return h.triggerPoint - d.triggerPoint
    }
    function r(h, d) {
        return d.triggerPoint - h.triggerPoint
    }
    function s(h) {
        this.name = h.name,
        this.axis = h.axis,
        this.id = this.name + "-" + this.axis,
        this.waypoints = [],
        this.clearTriggerQueues(),
        f[this.axis][this.name] = this
    }
    var f = {
        vertical: {},
        horizontal: {}
    }
      , l = window.Waypoint;
    s.prototype.add = function(h) {
        this.waypoints.push(h)
    }
    ,
    s.prototype.clearTriggerQueues = function() {
        this.triggerQueues = {
            up: [],
            down: [],
            left: [],
            right: []
        }
    }
    ,
    s.prototype.flushTriggers = function() {
        for (var h in this.triggerQueues) {
            var d = this.triggerQueues[h]
              , m = h === "up" || h === "left";
            d.sort(m ? r : n);
            for (var w = 0, _ = d.length; _ > w; w += 1) {
                var k = d[w];
                (k.options.continuous || w === d.length - 1) && k.trigger([h])
            }
        }
        this.clearTriggerQueues()
    }
    ,
    s.prototype.next = function(h) {
        this.waypoints.sort(n);
        var d = l.Adapter.inArray(h, this.waypoints)
          , m = d === this.waypoints.length - 1;
        return m ? null : this.waypoints[d + 1]
    }
    ,
    s.prototype.previous = function(h) {
        this.waypoints.sort(n);
        var d = l.Adapter.inArray(h, this.waypoints);
        return d ? this.waypoints[d - 1] : null
    }
    ,
    s.prototype.queueTrigger = function(h, d) {
        this.triggerQueues[d].push(h)
    }
    ,
    s.prototype.remove = function(h) {
        var d = l.Adapter.inArray(h, this.waypoints);
        d > -1 && this.waypoints.splice(d, 1)
    }
    ,
    s.prototype.first = function() {
        return this.waypoints[0]
    }
    ,
    s.prototype.last = function() {
        return this.waypoints[this.waypoints.length - 1]
    }
    ,
    s.findOrCreate = function(h) {
        return f[h.axis][h.name] || new s(h)
    }
    ,
    l.Group = s
}(),
function() {
    "use strict";
    function n(f) {
        this.$element = r(f)
    }
    var r = window.jQuery
      , s = window.Waypoint;
    r.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function(f, l) {
        n.prototype[l] = function() {
            var h = Array.prototype.slice.call(arguments);
            return this.$element[l].apply(this.$element, h)
        }
    }),
    r.each(["extend", "inArray", "isEmptyObject"], function(f, l) {
        n[l] = r[l]
    }),
    s.adapters.push({
        name: "jquery",
        Adapter: n
    }),
    s.Adapter = n
}(),
function() {
    "use strict";
    function n(s) {
        return function() {
            var f = []
              , l = arguments[0];
            return s.isFunction(arguments[0]) && (l = s.extend({}, arguments[1]),
            l.handler = arguments[0]),
            this.each(function() {
                var h = s.extend({}, l, {
                    element: this
                });
                typeof h.context == "string" && (h.context = s(this).closest(h.context)[0]),
                f.push(new r(h))
            }),
            f
        }
    }
    var r = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = n(window.jQuery)),
    window.Zepto && (window.Zepto.fn.waypoint = n(window.Zepto))
}();
/*!
Waypoints Infinite Scroll Shortcut - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
(function() {
    "use strict";
    function n(f) {
        this.options = r.extend({}, n.defaults, f),
        this.container = this.options.element,
        this.options.container !== "auto" && (this.container = this.options.container),
        this.$container = r(this.container),
        this.$more = r(this.options.more),
        this.$more.length && (this.setupHandler(),
        this.waypoint = new s(this.options))
    }
    var r = window.jQuery
      , s = window.Waypoint;
    n.prototype.setupHandler = function() {
        this.options.handler = r.proxy(function() {
            this.options.onBeforePageLoad(),
            this.destroy(),
            this.$container.addClass(this.options.loadingClass),
            r.get(r(this.options.more).attr("href"), r.proxy(function(f) {
                var l = r(r.parseHTML(f))
                  , h = l.find(this.options.more)
                  , d = l.find(this.options.items);
                d.length || (d = l.filter(this.options.items)),
                this.$container.append(d),
                this.$container.removeClass(this.options.loadingClass),
                h.length || (h = l.filter(this.options.more)),
                h.length ? (this.$more.replaceWith(h),
                this.$more = h,
                this.waypoint = new s(this.options)) : this.$more.remove(),
                this.options.onAfterPageLoad(d)
            }, this))
        }, this)
    }
    ,
    n.prototype.destroy = function() {
        this.waypoint && this.waypoint.destroy()
    }
    ,
    n.defaults = {
        container: "auto",
        items: ".infinite-item",
        more: ".infinite-more-link",
        offset: "bottom-in-view",
        loadingClass: "infinite-loading",
        onBeforePageLoad: r.noop,
        onAfterPageLoad: r.noop
    },
    s.Infinite = n
}
)(),
function(n) {
    n.fn.mediaWrapper = function(r) {
        var s = n.extend({
            intrinsic: !0,
            baseWidth: 16,
            baseHeight: 9
        }, r);
        return this.each(function() {
            var f = "";
            f = s.intrinsic == 1 && n(this).attr("width") !== "" && n(this).attr("height") !== "" ? n(this).attr("height") / n(this).attr("width") * 100 : s.baseHeight / s.baseWidth * 100,
            n(this).wrap('<div class="mediaWrapper" style="position: relative; width: 100%; height: 0; padding: ' + f + '% 0 0 0; " />').css({
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0"
            })
        })
    }
}(jQuery);
function PointerEventsPolyfill(n) {
    if (this.options = {
        selector: "*",
        mouseEvents: ["click", "dblclick", "mousedown", "mouseup"],
        usePolyfillIf: function() {
            if (navigator.appName == "Microsoft Internet Explorer") {
                var s = navigator.userAgent;
                if (s.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/) != null) {
                    var f = parseFloat(RegExp.$1);
                    if (11 > f)
                        return !0
                }
            }
            return !1
        }
    },
    n) {
        var r = this;
        $.each(n, function(s, f) {
            r.options[s] = f
        })
    }
    this.options.usePolyfillIf() && this.register_mouse_events()
}
PointerEventsPolyfill.initialize = function(n) {
    return PointerEventsPolyfill.singleton == null && (PointerEventsPolyfill.singleton = new PointerEventsPolyfill(n)),
    PointerEventsPolyfill.singleton
}
,
PointerEventsPolyfill.prototype.register_mouse_events = function() {
    $(document).on(this.options.mouseEvents.join(" "), this.options.selector, function(n) {
        if ($(this).css("pointer-events") == "none") {
            var r = $(this).css("display");
            $(this).css("display", "none");
            var s = document.elementFromPoint(n.clientX, n.clientY);
            return r ? $(this).css("display", r) : $(this).css("display", ""),
            n.target = s,
            $(s).trigger(n),
            !1
        }
        return !0
    })
}
;
/*!
 * Flickity PACKAGED v2.0.10
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * http://flickity.metafizzy.co
 * Copyright 2017 Metafizzy
 */
(function(n, r) {
    typeof define == "function" && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(s) {
        return r(n, s)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("jquery")) : n.jQueryBridget = r(n, n.jQuery)
}
)(window, function(n, r) {
    "use strict";
    function s(m, w, _) {
        function k(x, E, j) {
            var L, C = "$()." + m + '("' + E + '")';
            return x.each(function(O, M) {
                var U = _.data(M, m);
                if (!U)
                    return void d(m + " not initialized. Cannot call methods, i.e. " + C);
                var G = U[E];
                if (!G || E.charAt(0) == "_")
                    return void d(C + " is not a valid method");
                var u = G.apply(U, j);
                L = L === void 0 ? u : L
            }),
            L !== void 0 ? L : x
        }
        function A(x, E) {
            x.each(function(j, L) {
                var C = _.data(L, m);
                C ? (C.option(E),
                C._init()) : (C = new w(L,E),
                _.data(L, m, C))
            })
        }
        _ = _ || r || n.jQuery,
        _ && (w.prototype.option || (w.prototype.option = function(x) {
            _.isPlainObject(x) && (this.options = _.extend(!0, this.options, x))
        }
        ),
        _.fn[m] = function(x) {
            if (typeof x == "string") {
                var E = l.call(arguments, 1);
                return k(this, x, E)
            }
            return A(this, x),
            this
        }
        ,
        f(_))
    }
    function f(m) {
        !m || m && m.bridget || (m.bridget = s)
    }
    var l = Array.prototype.slice
      , h = n.console
      , d = typeof h == "undefined" ? function() {}
    : function(m) {
        h.error(m)
    }
    ;
    return f(r || n.jQuery),
    s
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("ev-emitter/ev-emitter", r) : typeof module == "object" && module.exports ? module.exports = r() : n.EvEmitter = r()
}(typeof window != "undefined" ? window : this, function() {
    function n() {}
    var r = n.prototype;
    return r.on = function(s, f) {
        if (s && f) {
            var l = this._events = this._events || {}
              , h = l[s] = l[s] || [];
            return h.indexOf(f) == -1 && h.push(f),
            this
        }
    }
    ,
    r.once = function(s, f) {
        if (s && f) {
            this.on(s, f);
            var l = this._onceEvents = this._onceEvents || {}
              , h = l[s] = l[s] || {};
            return h[f] = !0,
            this
        }
    }
    ,
    r.off = function(s, f) {
        var l = this._events && this._events[s];
        if (l && l.length) {
            var h = l.indexOf(f);
            return h != -1 && l.splice(h, 1),
            this
        }
    }
    ,
    r.emitEvent = function(s, f) {
        var l = this._events && this._events[s];
        if (l && l.length) {
            l = l.slice(0),
            f = f || [];
            for (var h = this._onceEvents && this._onceEvents[s], d = 0; d < l.length; d++) {
                var m = l[d]
                  , w = h && h[m];
                w && (this.off(s, m),
                delete h[m]),
                m.apply(this, f)
            }
            return this
        }
    }
    ,
    r.allOff = function() {
        delete this._events,
        delete this._onceEvents
    }
    ,
    n
}),
function(n, r) {
    "use strict";
    typeof define == "function" && define.amd ? define("get-size/get-size", [], function() {
        return r()
    }) : typeof module == "object" && module.exports ? module.exports = r() : n.getSize = r()
}(window, function() {
    "use strict";
    function n(A) {
        var x = parseFloat(A)
          , E = A.indexOf("%") == -1 && !isNaN(x);
        return E && x
    }
    function r() {}
    function s() {
        for (var A = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        }, x = 0; x < _; x++) {
            var E = w[x];
            A[E] = 0
        }
        return A
    }
    function f(A) {
        var x = getComputedStyle(A);
        return x || m("Style returned " + x + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"),
        x
    }
    function l() {
        if (!k) {
            k = !0;
            var A = document.createElement("div");
            A.style.width = "200px",
            A.style.padding = "1px 2px 3px 4px",
            A.style.borderStyle = "solid",
            A.style.borderWidth = "1px 2px 3px 4px",
            A.style.boxSizing = "border-box";
            var x = document.body || document.documentElement;
            x.appendChild(A);
            var E = f(A);
            h.isBoxSizeOuter = d = n(E.width) == 200,
            x.removeChild(A)
        }
    }
    function h(A) {
        if (l(),
        typeof A == "string" && (A = document.querySelector(A)),
        A && typeof A == "object" && A.nodeType) {
            var x = f(A);
            if (x.display == "none")
                return s();
            var E = {};
            E.width = A.offsetWidth,
            E.height = A.offsetHeight;
            for (var j = E.isBorderBox = x.boxSizing == "border-box", L = 0; L < _; L++) {
                var C = w[L]
                  , O = x[C]
                  , M = parseFloat(O);
                E[C] = isNaN(M) ? 0 : M
            }
            var U = E.paddingLeft + E.paddingRight
              , G = E.paddingTop + E.paddingBottom
              , u = E.marginLeft + E.marginRight
              , ce = E.marginTop + E.marginBottom
              , ve = E.borderLeftWidth + E.borderRightWidth
              , H = E.borderTopWidth + E.borderBottomWidth
              , W = j && d
              , Z = n(x.width);
            Z !== !1 && (E.width = Z + (W ? 0 : U + ve));
            var Y = n(x.height);
            return Y !== !1 && (E.height = Y + (W ? 0 : G + H)),
            E.innerWidth = E.width - (U + ve),
            E.innerHeight = E.height - (G + H),
            E.outerWidth = E.width + u,
            E.outerHeight = E.height + ce,
            E
        }
    }
    var d, m = typeof console == "undefined" ? r : function(A) {
        console.error(A)
    }
    , w = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"], _ = w.length, k = !1;
    return h
}),
function(n, r) {
    "use strict";
    typeof define == "function" && define.amd ? define("desandro-matches-selector/matches-selector", r) : typeof module == "object" && module.exports ? module.exports = r() : n.matchesSelector = r()
}(window, function() {
    "use strict";
    var n = function() {
        var r = window.Element.prototype;
        if (r.matches)
            return "matches";
        if (r.matchesSelector)
            return "matchesSelector";
        for (var s = ["webkit", "moz", "ms", "o"], f = 0; f < s.length; f++) {
            var l = s[f]
              , h = l + "MatchesSelector";
            if (r[h])
                return h
        }
    }();
    return function(r, s) {
        return r[n](s)
    }
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(s) {
        return r(n, s)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("desandro-matches-selector")) : n.fizzyUIUtils = r(n, n.matchesSelector)
}(window, function(n, r) {
    var s = {};
    s.extend = function(l, h) {
        for (var d in h)
            l[d] = h[d];
        return l
    }
    ,
    s.modulo = function(l, h) {
        return (l % h + h) % h
    }
    ,
    s.makeArray = function(l) {
        var h = [];
        if (Array.isArray(l))
            h = l;
        else if (l && typeof l == "object" && typeof l.length == "number")
            for (var d = 0; d < l.length; d++)
                h.push(l[d]);
        else
            h.push(l);
        return h
    }
    ,
    s.removeFrom = function(l, h) {
        var d = l.indexOf(h);
        d != -1 && l.splice(d, 1)
    }
    ,
    s.getParent = function(l, h) {
        for (; l.parentNode && l != document.body; )
            if (l = l.parentNode,
            r(l, h))
                return l
    }
    ,
    s.getQueryElement = function(l) {
        return typeof l == "string" ? document.querySelector(l) : l
    }
    ,
    s.handleEvent = function(l) {
        var h = "on" + l.type;
        this[h] && this[h](l)
    }
    ,
    s.filterFindElements = function(l, h) {
        l = s.makeArray(l);
        var d = [];
        return l.forEach(function(m) {
            if (m instanceof HTMLElement) {
                if (!h)
                    return void d.push(m);
                r(m, h) && d.push(m);
                for (var w = m.querySelectorAll(h), _ = 0; _ < w.length; _++)
                    d.push(w[_])
            }
        }),
        d
    }
    ,
    s.debounceMethod = function(l, h, d) {
        var m = l.prototype[h]
          , w = h + "Timeout";
        l.prototype[h] = function() {
            var _ = this[w];
            _ && clearTimeout(_);
            var k = arguments
              , A = this;
            this[w] = setTimeout(function() {
                m.apply(A, k),
                delete A[w]
            }, d || 100)
        }
    }
    ,
    s.docReady = function(l) {
        var h = document.readyState;
        h == "complete" || h == "interactive" ? setTimeout(l) : document.addEventListener("DOMContentLoaded", l)
    }
    ,
    s.toDashed = function(l) {
        return l.replace(/(.)([A-Z])/g, function(h, d, m) {
            return d + "-" + m
        }).toLowerCase()
    }
    ;
    var f = n.console;
    return s.htmlInit = function(l, h) {
        s.docReady(function() {
            var d = s.toDashed(h)
              , m = "data-" + d
              , w = document.querySelectorAll("[" + m + "]")
              , _ = document.querySelectorAll(".js-" + d)
              , k = s.makeArray(w).concat(s.makeArray(_))
              , A = m + "-options"
              , x = n.jQuery;
            k.forEach(function(E) {
                var j, L = E.getAttribute(m) || E.getAttribute(A);
                try {
                    j = L && JSON.parse(L)
                } catch (O) {
                    return void (f && f.error("Error parsing " + m + " on " + E.className + ": " + O))
                }
                var C = new l(E,j);
                x && x.data(E, h, C)
            })
        })
    }
    ,
    s
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function(s) {
        return r(n, s)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("get-size")) : (n.Flickity = n.Flickity || {},
    n.Flickity.Cell = r(n, n.getSize))
}(window, function(n, r) {
    function s(l, h) {
        this.element = l,
        this.parent = h,
        this.create()
    }
    var f = s.prototype;
    return f.create = function() {
        this.element.style.position = "absolute",
        this.x = 0,
        this.shift = 0
    }
    ,
    f.destroy = function() {
        this.element.style.position = "";
        var l = this.parent.originSide;
        this.element.style[l] = ""
    }
    ,
    f.getSize = function() {
        this.size = r(this.element)
    }
    ,
    f.setPosition = function(l) {
        this.x = l,
        this.updateTarget(),
        this.renderPosition(l)
    }
    ,
    f.updateTarget = f.setDefaultTarget = function() {
        var l = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[l] + this.size.width * this.parent.cellAlign
    }
    ,
    f.renderPosition = function(l) {
        var h = this.parent.originSide;
        this.element.style[h] = this.parent.getPositionValue(l)
    }
    ,
    f.wrapShift = function(l) {
        this.shift = l,
        this.renderPosition(this.x + this.parent.slideableWidth * l)
    }
    ,
    f.remove = function() {
        this.element.parentNode.removeChild(this.element)
    }
    ,
    s
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/slide", r) : typeof module == "object" && module.exports ? module.exports = r() : (n.Flickity = n.Flickity || {},
    n.Flickity.Slide = r())
}(window, function() {
    "use strict";
    function n(s) {
        this.parent = s,
        this.isOriginLeft = s.originSide == "left",
        this.cells = [],
        this.outerWidth = 0,
        this.height = 0
    }
    var r = n.prototype;
    return r.addCell = function(s) {
        if (this.cells.push(s),
        this.outerWidth += s.size.outerWidth,
        this.height = Math.max(s.size.outerHeight, this.height),
        this.cells.length == 1) {
            this.x = s.x;
            var f = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = s.size[f]
        }
    }
    ,
    r.updateTarget = function() {
        var s = this.isOriginLeft ? "marginRight" : "marginLeft"
          , f = this.getLastCell()
          , l = f ? f.size[s] : 0
          , h = this.outerWidth - (this.firstMargin + l);
        this.target = this.x + this.firstMargin + h * this.parent.cellAlign
    }
    ,
    r.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }
    ,
    r.select = function() {
        this.changeSelectedClass("add")
    }
    ,
    r.unselect = function() {
        this.changeSelectedClass("remove")
    }
    ,
    r.changeSelectedClass = function(s) {
        this.cells.forEach(function(f) {
            f.element.classList[s]("is-selected")
        })
    }
    ,
    r.getCellElements = function() {
        return this.cells.map(function(s) {
            return s.element
        })
    }
    ,
    n
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function(s) {
        return r(n, s)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("fizzy-ui-utils")) : (n.Flickity = n.Flickity || {},
    n.Flickity.animatePrototype = r(n, n.fizzyUIUtils))
}(window, function(n, r) {
    var s = n.requestAnimationFrame || n.webkitRequestAnimationFrame
      , f = 0;
    s || (s = function(d) {
        var m = new Date().getTime()
          , w = Math.max(0, 16 - (m - f))
          , _ = setTimeout(d, w);
        return f = m + w,
        _
    }
    );
    var l = {};
    l.startAnimation = function() {
        this.isAnimating || (this.isAnimating = !0,
        this.restingFrames = 0,
        this.animate())
    }
    ,
    l.animate = function() {
        this.applyDragForce(),
        this.applySelectedAttraction();
        var d = this.x;
        if (this.integratePhysics(),
        this.positionSlider(),
        this.settle(d),
        this.isAnimating) {
            var m = this;
            s(function() {
                m.animate()
            })
        }
    }
    ;
    var h = function() {
        var d = document.documentElement.style;
        return typeof d.transform == "string" ? "transform" : "WebkitTransform"
    }();
    return l.positionSlider = function() {
        var d = this.x;
        this.options.wrapAround && this.cells.length > 1 && (d = r.modulo(d, this.slideableWidth),
        d -= this.slideableWidth,
        this.shiftWrapCells(d)),
        d += this.cursorPosition,
        d = this.options.rightToLeft && h ? -d : d;
        var m = this.getPositionValue(d);
        this.slider.style[h] = this.isAnimating ? "translate3d(" + m + ",0,0)" : "translateX(" + m + ")";
        var w = this.slides[0];
        if (w) {
            var _ = -this.x - w.target
              , k = _ / this.slidesWidth;
            this.dispatchEvent("scroll", null, [k, _])
        }
    }
    ,
    l.positionSliderAtSelected = function() {
        this.cells.length && (this.x = -this.selectedSlide.target,
        this.positionSlider())
    }
    ,
    l.getPositionValue = function(d) {
        return this.options.percentPosition ? .01 * Math.round(d / this.size.innerWidth * 1e4) + "%" : Math.round(d) + "px"
    }
    ,
    l.settle = function(d) {
        this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * d) || this.restingFrames++,
        this.restingFrames > 2 && (this.isAnimating = !1,
        delete this.isFreeScrolling,
        this.positionSlider(),
        this.dispatchEvent("settle"))
    }
    ,
    l.shiftWrapCells = function(d) {
        var m = this.cursorPosition + d;
        this._shiftCells(this.beforeShiftCells, m, -1);
        var w = this.size.innerWidth - (d + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, w, 1)
    }
    ,
    l._shiftCells = function(d, m, w) {
        for (var _ = 0; _ < d.length; _++) {
            var k = d[_]
              , A = m > 0 ? w : 0;
            k.wrapShift(A),
            m -= k.size.outerWidth
        }
    }
    ,
    l._unshiftCells = function(d) {
        if (d && d.length)
            for (var m = 0; m < d.length; m++)
                d[m].wrapShift(0)
    }
    ,
    l.integratePhysics = function() {
        this.x += this.velocity,
        this.velocity *= this.getFrictionFactor()
    }
    ,
    l.applyForce = function(d) {
        this.velocity += d
    }
    ,
    l.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
    }
    ,
    l.getRestingPosition = function() {
        return this.x + this.velocity / (1 - this.getFrictionFactor())
    }
    ,
    l.applyDragForce = function() {
        if (this.isPointerDown) {
            var d = this.dragX - this.x
              , m = d - this.velocity;
            this.applyForce(m)
        }
    }
    ,
    l.applySelectedAttraction = function() {
        if (!this.isPointerDown && !this.isFreeScrolling && this.cells.length) {
            var d = this.selectedSlide.target * -1 - this.x
              , m = d * this.options.selectedAttraction;
            this.applyForce(m)
        }
    }
    ,
    l
}),
function(n, r) {
    if (typeof define == "function" && define.amd)
        define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function(f, l, h, d, m, w) {
            return r(n, f, l, h, d, m, w)
        });
    else if (typeof module == "object" && module.exports)
        module.exports = r(n, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
    else {
        var s = n.Flickity;
        n.Flickity = r(n, n.EvEmitter, n.getSize, n.fizzyUIUtils, s.Cell, s.Slide, s.animatePrototype)
    }
}(window, function(n, r, s, f, l, h, d) {
    function m(C, O) {
        for (C = f.makeArray(C); C.length; )
            O.appendChild(C.shift())
    }
    function w(C, O) {
        var M = f.getQueryElement(C);
        if (!M)
            return void (A && A.error("Bad element for Flickity: " + (M || C)));
        if (this.element = M,
        this.element.flickityGUID) {
            var U = E[this.element.flickityGUID];
            return U.option(O),
            U
        }
        _ && (this.$element = _(this.element)),
        this.options = f.extend({}, this.constructor.defaults),
        this.option(O),
        this._create()
    }
    var _ = n.jQuery
      , k = n.getComputedStyle
      , A = n.console
      , x = 0
      , E = {};
    w.defaults = {
        accessibility: !0,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        namespaceJQueryEvents: !0,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0
    },
    w.createMethods = [];
    var j = w.prototype;
    f.extend(j, r.prototype),
    j._create = function() {
        var C = this.guid = ++x;
        this.element.flickityGUID = C,
        E[C] = this,
        this.selectedIndex = 0,
        this.restingFrames = 0,
        this.x = 0,
        this.velocity = 0,
        this.originSide = this.options.rightToLeft ? "right" : "left",
        this.viewport = document.createElement("div"),
        this.viewport.className = "flickity-viewport",
        this._createSlider(),
        (this.options.resize || this.options.watchCSS) && n.addEventListener("resize", this),
        w.createMethods.forEach(function(O) {
            this[O]()
        }, this),
        this.options.watchCSS ? this.watchCSS() : this.activate()
    }
    ,
    j.option = function(C) {
        f.extend(this.options, C)
    }
    ,
    j.activate = function() {
        if (!this.isActive) {
            this.isActive = !0,
            this.element.classList.add("flickity-enabled"),
            this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
            this.getSize();
            var C = this._filterFindCellElements(this.element.children);
            m(C, this.slider),
            this.viewport.appendChild(this.slider),
            this.element.appendChild(this.viewport),
            this.reloadCells(),
            this.options.accessibility && (this.element.tabIndex = 0,
            this.element.addEventListener("keydown", this)),
            this.emitEvent("activate");
            var O, M = this.options.initialIndex;
            O = this.isInitActivated ? this.selectedIndex : M !== void 0 && this.cells[M] ? M : 0,
            this.select(O, !1, !0),
            this.isInitActivated = !0
        }
    }
    ,
    j._createSlider = function() {
        var C = document.createElement("div");
        C.className = "flickity-slider",
        C.style[this.originSide] = 0,
        this.slider = C
    }
    ,
    j._filterFindCellElements = function(C) {
        return f.filterFindElements(C, this.options.cellSelector)
    }
    ,
    j.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children),
        this.positionCells(),
        this._getWrapShiftCells(),
        this.setGallerySize()
    }
    ,
    j._makeCells = function(C) {
        var O = this._filterFindCellElements(C)
          , M = O.map(function(U) {
            return new l(U,this)
        }, this);
        return M
    }
    ,
    j.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }
    ,
    j.getLastSlide = function() {
        return this.slides[this.slides.length - 1]
    }
    ,
    j.positionCells = function() {
        this._sizeCells(this.cells),
        this._positionCells(0)
    }
    ,
    j._positionCells = function(C) {
        C = C || 0,
        this.maxCellHeight = C && this.maxCellHeight || 0;
        var O = 0;
        if (C > 0) {
            var M = this.cells[C - 1];
            O = M.x + M.size.outerWidth
        }
        for (var U = this.cells.length, G = C; G < U; G++) {
            var u = this.cells[G];
            u.setPosition(O),
            O += u.size.outerWidth,
            this.maxCellHeight = Math.max(u.size.outerHeight, this.maxCellHeight)
        }
        this.slideableWidth = O,
        this.updateSlides(),
        this._containSlides(),
        this.slidesWidth = U ? this.getLastSlide().target - this.slides[0].target : 0
    }
    ,
    j._sizeCells = function(C) {
        C.forEach(function(O) {
            O.getSize()
        })
    }
    ,
    j.updateSlides = function() {
        if (this.slides = [],
        this.cells.length) {
            var C = new h(this);
            this.slides.push(C);
            var O = this.originSide == "left"
              , M = O ? "marginRight" : "marginLeft"
              , U = this._getCanCellFit();
            this.cells.forEach(function(G, u) {
                if (!C.cells.length)
                    return void C.addCell(G);
                var ce = C.outerWidth - C.firstMargin + (G.size.outerWidth - G.size[M]);
                U.call(this, u, ce) || (C.updateTarget(),
                C = new h(this),
                this.slides.push(C)),
                C.addCell(G)
            }, this),
            C.updateTarget(),
            this.updateSelectedSlide()
        }
    }
    ,
    j._getCanCellFit = function() {
        var C = this.options.groupCells;
        if (!C)
            return function() {
                return !1
            }
            ;
        if (typeof C == "number") {
            var O = parseInt(C, 10);
            return function(G) {
                return G % O !== 0
            }
        }
        var M = typeof C == "string" && C.match(/^(\d+)%$/)
          , U = M ? parseInt(M[1], 10) / 100 : 1;
        return function(G, u) {
            return u <= (this.size.innerWidth + 1) * U
        }
    }
    ,
    j._init = j.reposition = function() {
        this.positionCells(),
        this.positionSliderAtSelected()
    }
    ,
    j.getSize = function() {
        this.size = s(this.element),
        this.setCellAlign(),
        this.cursorPosition = this.size.innerWidth * this.cellAlign
    }
    ;
    var L = {
        center: {
            left: .5,
            right: .5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    return j.setCellAlign = function() {
        var C = L[this.options.cellAlign];
        this.cellAlign = C ? C[this.originSide] : this.options.cellAlign
    }
    ,
    j.setGallerySize = function() {
        if (this.options.setGallerySize) {
            var C = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = C + "px"
        }
    }
    ,
    j._getWrapShiftCells = function() {
        if (this.options.wrapAround) {
            this._unshiftCells(this.beforeShiftCells),
            this._unshiftCells(this.afterShiftCells);
            var C = this.cursorPosition
              , O = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(C, O, -1),
            C = this.size.innerWidth - this.cursorPosition,
            this.afterShiftCells = this._getGapCells(C, 0, 1)
        }
    }
    ,
    j._getGapCells = function(C, O, M) {
        for (var U = []; C > 0; ) {
            var G = this.cells[O];
            if (!G)
                break;
            U.push(G),
            O += M,
            C -= G.size.outerWidth
        }
        return U
    }
    ,
    j._containSlides = function() {
        if (this.options.contain && !this.options.wrapAround && this.cells.length) {
            var C = this.options.rightToLeft
              , O = C ? "marginRight" : "marginLeft"
              , M = C ? "marginLeft" : "marginRight"
              , U = this.slideableWidth - this.getLastCell().size[M]
              , G = U < this.size.innerWidth
              , u = this.cursorPosition + this.cells[0].size[O]
              , ce = U - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach(function(ve) {
                G ? ve.target = U * this.cellAlign : (ve.target = Math.max(ve.target, u),
                ve.target = Math.min(ve.target, ce))
            }, this)
        }
    }
    ,
    j.dispatchEvent = function(C, O, M) {
        var U = O ? [O].concat(M) : M;
        if (this.emitEvent(C, U),
        _ && this.$element) {
            C += this.options.namespaceJQueryEvents ? ".flickity" : "";
            var G = C;
            if (O) {
                var u = _.Event(O);
                u.type = C,
                G = u
            }
            this.$element.trigger(G, M)
        }
    }
    ,
    j.select = function(C, O, M) {
        this.isActive && (C = parseInt(C, 10),
        this._wrapSelect(C),
        (this.options.wrapAround || O) && (C = f.modulo(C, this.slides.length)),
        this.slides[C] && (this.selectedIndex = C,
        this.updateSelectedSlide(),
        M ? this.positionSliderAtSelected() : this.startAnimation(),
        this.options.adaptiveHeight && this.setGallerySize(),
        this.dispatchEvent("select"),
        this.dispatchEvent("cellSelect")))
    }
    ,
    j._wrapSelect = function(C) {
        var O = this.slides.length
          , M = this.options.wrapAround && O > 1;
        if (!M)
            return C;
        var U = f.modulo(C, O)
          , G = Math.abs(U - this.selectedIndex)
          , u = Math.abs(U + O - this.selectedIndex)
          , ce = Math.abs(U - O - this.selectedIndex);
        !this.isDragSelect && u < G ? C += O : !this.isDragSelect && ce < G && (C -= O),
        C < 0 ? this.x -= this.slideableWidth : C >= O && (this.x += this.slideableWidth)
    }
    ,
    j.previous = function(C, O) {
        this.select(this.selectedIndex - 1, C, O)
    }
    ,
    j.next = function(C, O) {
        this.select(this.selectedIndex + 1, C, O)
    }
    ,
    j.updateSelectedSlide = function() {
        var C = this.slides[this.selectedIndex];
        C && (this.unselectSelectedSlide(),
        this.selectedSlide = C,
        C.select(),
        this.selectedCells = C.cells,
        this.selectedElements = C.getCellElements(),
        this.selectedCell = C.cells[0],
        this.selectedElement = this.selectedElements[0])
    }
    ,
    j.unselectSelectedSlide = function() {
        this.selectedSlide && this.selectedSlide.unselect()
    }
    ,
    j.selectCell = function(C, O, M) {
        var U;
        typeof C == "number" ? U = this.cells[C] : (typeof C == "string" && (C = this.element.querySelector(C)),
        U = this.getCell(C));
        for (var G = 0; U && G < this.slides.length; G++) {
            var u = this.slides[G]
              , ce = u.cells.indexOf(U);
            if (ce != -1)
                return void this.select(G, O, M)
        }
    }
    ,
    j.getCell = function(C) {
        for (var O = 0; O < this.cells.length; O++) {
            var M = this.cells[O];
            if (M.element == C)
                return M
        }
    }
    ,
    j.getCells = function(C) {
        C = f.makeArray(C);
        var O = [];
        return C.forEach(function(M) {
            var U = this.getCell(M);
            U && O.push(U)
        }, this),
        O
    }
    ,
    j.getCellElements = function() {
        return this.cells.map(function(C) {
            return C.element
        })
    }
    ,
    j.getParentCell = function(C) {
        var O = this.getCell(C);
        return O || (C = f.getParent(C, ".flickity-slider > *"),
        this.getCell(C))
    }
    ,
    j.getAdjacentCellElements = function(C, O) {
        if (!C)
            return this.selectedSlide.getCellElements();
        O = O === void 0 ? this.selectedIndex : O;
        var M = this.slides.length;
        if (1 + 2 * C >= M)
            return this.getCellElements();
        for (var U = [], G = O - C; G <= O + C; G++) {
            var u = this.options.wrapAround ? f.modulo(G, M) : G
              , ce = this.slides[u];
            ce && (U = U.concat(ce.getCellElements()))
        }
        return U
    }
    ,
    j.uiChange = function() {
        this.emitEvent("uiChange")
    }
    ,
    j.childUIPointerDown = function(C) {
        this.emitEvent("childUIPointerDown", [C])
    }
    ,
    j.onresize = function() {
        this.watchCSS(),
        this.resize()
    }
    ,
    f.debounceMethod(w, "onresize", 150),
    j.resize = function() {
        if (this.isActive) {
            this.getSize(),
            this.options.wrapAround && (this.x = f.modulo(this.x, this.slideableWidth)),
            this.positionCells(),
            this._getWrapShiftCells(),
            this.setGallerySize(),
            this.emitEvent("resize");
            var C = this.selectedElements && this.selectedElements[0];
            this.selectCell(C, !1, !0)
        }
    }
    ,
    j.watchCSS = function() {
        var C = this.options.watchCSS;
        if (C) {
            var O = k(this.element, ":after").content;
            O.indexOf("flickity") != -1 ? this.activate() : this.deactivate()
        }
    }
    ,
    j.onkeydown = function(C) {
        if (this.options.accessibility && (!document.activeElement || document.activeElement == this.element)) {
            if (C.keyCode == 37) {
                var O = this.options.rightToLeft ? "next" : "previous";
                this.uiChange(),
                this[O]()
            } else if (C.keyCode == 39) {
                var M = this.options.rightToLeft ? "previous" : "next";
                this.uiChange(),
                this[M]()
            }
        }
    }
    ,
    j.deactivate = function() {
        this.isActive && (this.element.classList.remove("flickity-enabled"),
        this.element.classList.remove("flickity-rtl"),
        this.cells.forEach(function(C) {
            C.destroy()
        }),
        this.unselectSelectedSlide(),
        this.element.removeChild(this.viewport),
        m(this.slider.children, this.element),
        this.options.accessibility && (this.element.removeAttribute("tabIndex"),
        this.element.removeEventListener("keydown", this)),
        this.isActive = !1,
        this.emitEvent("deactivate"))
    }
    ,
    j.destroy = function() {
        this.deactivate(),
        n.removeEventListener("resize", this),
        this.emitEvent("destroy"),
        _ && this.$element && _.removeData(this.element, "flickity"),
        delete this.element.flickityGUID,
        delete E[this.guid]
    }
    ,
    f.extend(j, d),
    w.data = function(C) {
        C = f.getQueryElement(C);
        var O = C && C.flickityGUID;
        return O && E[O]
    }
    ,
    f.htmlInit(w, "flickity"),
    _ && _.bridget && _.bridget("flickity", w),
    w.setJQuery = function(C) {
        _ = C
    }
    ,
    w.Cell = l,
    w
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function(s) {
        return r(n, s)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("ev-emitter")) : n.Unipointer = r(n, n.EvEmitter)
}(window, function(n, r) {
    function s() {}
    function f() {}
    var l = f.prototype = Object.create(r.prototype);
    l.bindStartEvent = function(d) {
        this._bindStartEvent(d, !0)
    }
    ,
    l.unbindStartEvent = function(d) {
        this._bindStartEvent(d, !1)
    }
    ,
    l._bindStartEvent = function(d, m) {
        m = m === void 0 || !!m;
        var w = m ? "addEventListener" : "removeEventListener";
        n.PointerEvent ? d[w]("pointerdown", this) : (d[w]("mousedown", this),
        d[w]("touchstart", this))
    }
    ,
    l.handleEvent = function(d) {
        var m = "on" + d.type;
        this[m] && this[m](d)
    }
    ,
    l.getTouch = function(d) {
        for (var m = 0; m < d.length; m++) {
            var w = d[m];
            if (w.identifier == this.pointerIdentifier)
                return w
        }
    }
    ,
    l.onmousedown = function(d) {
        var m = d.button;
        m && m !== 0 && m !== 1 || this._pointerDown(d, d)
    }
    ,
    l.ontouchstart = function(d) {
        this._pointerDown(d, d.changedTouches[0])
    }
    ,
    l.onpointerdown = function(d) {
        this._pointerDown(d, d)
    }
    ,
    l._pointerDown = function(d, m) {
        this.isPointerDown || (this.isPointerDown = !0,
        this.pointerIdentifier = m.pointerId !== void 0 ? m.pointerId : m.identifier,
        this.pointerDown(d, m))
    }
    ,
    l.pointerDown = function(d, m) {
        this._bindPostStartEvents(d),
        this.emitEvent("pointerDown", [d, m])
    }
    ;
    var h = {
        mousedown: ["mousemove", "mouseup"],
        touchstart: ["touchmove", "touchend", "touchcancel"],
        pointerdown: ["pointermove", "pointerup", "pointercancel"]
    };
    return l._bindPostStartEvents = function(d) {
        if (d) {
            var m = h[d.type];
            m.forEach(function(w) {
                n.addEventListener(w, this)
            }, this),
            this._boundPointerEvents = m
        }
    }
    ,
    l._unbindPostStartEvents = function() {
        this._boundPointerEvents && (this._boundPointerEvents.forEach(function(d) {
            n.removeEventListener(d, this)
        }, this),
        delete this._boundPointerEvents)
    }
    ,
    l.onmousemove = function(d) {
        this._pointerMove(d, d)
    }
    ,
    l.onpointermove = function(d) {
        d.pointerId == this.pointerIdentifier && this._pointerMove(d, d)
    }
    ,
    l.ontouchmove = function(d) {
        var m = this.getTouch(d.changedTouches);
        m && this._pointerMove(d, m)
    }
    ,
    l._pointerMove = function(d, m) {
        this.pointerMove(d, m)
    }
    ,
    l.pointerMove = function(d, m) {
        this.emitEvent("pointerMove", [d, m])
    }
    ,
    l.onmouseup = function(d) {
        this._pointerUp(d, d)
    }
    ,
    l.onpointerup = function(d) {
        d.pointerId == this.pointerIdentifier && this._pointerUp(d, d)
    }
    ,
    l.ontouchend = function(d) {
        var m = this.getTouch(d.changedTouches);
        m && this._pointerUp(d, m)
    }
    ,
    l._pointerUp = function(d, m) {
        this._pointerDone(),
        this.pointerUp(d, m)
    }
    ,
    l.pointerUp = function(d, m) {
        this.emitEvent("pointerUp", [d, m])
    }
    ,
    l._pointerDone = function() {
        this.isPointerDown = !1,
        delete this.pointerIdentifier,
        this._unbindPostStartEvents(),
        this.pointerDone()
    }
    ,
    l.pointerDone = s,
    l.onpointercancel = function(d) {
        d.pointerId == this.pointerIdentifier && this._pointerCancel(d, d)
    }
    ,
    l.ontouchcancel = function(d) {
        var m = this.getTouch(d.changedTouches);
        m && this._pointerCancel(d, m)
    }
    ,
    l._pointerCancel = function(d, m) {
        this._pointerDone(),
        this.pointerCancel(d, m)
    }
    ,
    l.pointerCancel = function(d, m) {
        this.emitEvent("pointerCancel", [d, m])
    }
    ,
    f.getPointerPoint = function(d) {
        return {
            x: d.pageX,
            y: d.pageY
        }
    }
    ,
    f
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], function(s) {
        return r(n, s)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("unipointer")) : n.Unidragger = r(n, n.Unipointer)
}(window, function(n, r) {
    function s() {}
    var f = s.prototype = Object.create(r.prototype);
    return f.bindHandles = function() {
        this._bindHandles(!0)
    }
    ,
    f.unbindHandles = function() {
        this._bindHandles(!1)
    }
    ,
    f._bindHandles = function(l) {
        l = l === void 0 || !!l;
        for (var h = l ? "addEventListener" : "removeEventListener", d = 0; d < this.handles.length; d++) {
            var m = this.handles[d];
            this._bindStartEvent(m, l),
            m[h]("click", this),
            n.PointerEvent && (m.style.touchAction = l ? this._touchActionValue : "")
        }
    }
    ,
    f._touchActionValue = "none",
    f.pointerDown = function(l, h) {
        if (l.target.nodeName == "INPUT" && l.target.type == "range")
            return this.isPointerDown = !1,
            void delete this.pointerIdentifier;
        this._dragPointerDown(l, h);
        var d = document.activeElement;
        d && d.blur && d.blur(),
        this._bindPostStartEvents(l),
        this.emitEvent("pointerDown", [l, h])
    }
    ,
    f._dragPointerDown = function(l, h) {
        this.pointerDownPoint = r.getPointerPoint(h);
        var d = this.canPreventDefaultOnPointerDown(l, h);
        d && l.preventDefault()
    }
    ,
    f.canPreventDefaultOnPointerDown = function(l) {
        return l.target.nodeName != "SELECT"
    }
    ,
    f.pointerMove = function(l, h) {
        var d = this._dragPointerMove(l, h);
        this.emitEvent("pointerMove", [l, h, d]),
        this._dragMove(l, h, d)
    }
    ,
    f._dragPointerMove = function(l, h) {
        var d = r.getPointerPoint(h)
          , m = {
            x: d.x - this.pointerDownPoint.x,
            y: d.y - this.pointerDownPoint.y
        };
        return !this.isDragging && this.hasDragStarted(m) && this._dragStart(l, h),
        m
    }
    ,
    f.hasDragStarted = function(l) {
        return Math.abs(l.x) > 3 || Math.abs(l.y) > 3
    }
    ,
    f.pointerUp = function(l, h) {
        this.emitEvent("pointerUp", [l, h]),
        this._dragPointerUp(l, h)
    }
    ,
    f._dragPointerUp = function(l, h) {
        this.isDragging ? this._dragEnd(l, h) : this._staticClick(l, h)
    }
    ,
    f._dragStart = function(l, h) {
        this.isDragging = !0,
        this.dragStartPoint = r.getPointerPoint(h),
        this.isPreventingClicks = !0,
        this.dragStart(l, h)
    }
    ,
    f.dragStart = function(l, h) {
        this.emitEvent("dragStart", [l, h])
    }
    ,
    f._dragMove = function(l, h, d) {
        this.isDragging && this.dragMove(l, h, d)
    }
    ,
    f.dragMove = function(l, h, d) {
        l.preventDefault(),
        this.emitEvent("dragMove", [l, h, d])
    }
    ,
    f._dragEnd = function(l, h) {
        this.isDragging = !1,
        setTimeout(function() {
            delete this.isPreventingClicks
        }
        .bind(this)),
        this.dragEnd(l, h)
    }
    ,
    f.dragEnd = function(l, h) {
        this.emitEvent("dragEnd", [l, h])
    }
    ,
    f.onclick = function(l) {
        this.isPreventingClicks && l.preventDefault()
    }
    ,
    f._staticClick = function(l, h) {
        if (!this.isIgnoringMouseUp || l.type != "mouseup") {
            var d = l.target.nodeName;
            d != "INPUT" && d != "TEXTAREA" || l.target.focus(),
            this.staticClick(l, h),
            l.type != "mouseup" && (this.isIgnoringMouseUp = !0,
            setTimeout(function() {
                delete this.isIgnoringMouseUp
            }
            .bind(this), 400))
        }
    }
    ,
    f.staticClick = function(l, h) {
        this.emitEvent("staticClick", [l, h])
    }
    ,
    s.getPointerPoint = r.getPointerPoint,
    s
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function(s, f, l) {
        return r(n, s, f, l)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : n.Flickity = r(n, n.Flickity, n.Unidragger, n.fizzyUIUtils)
}(window, function(n, r, s, f) {
    function l(x) {
        var E = x.type == "touchstart"
          , j = x.pointerType == "touch"
          , L = A[x.target.nodeName];
        return E || j || L
    }
    function h() {
        return {
            x: n.pageXOffset,
            y: n.pageYOffset
        }
    }
    f.extend(r.defaults, {
        draggable: !0,
        dragThreshold: 3
    }),
    r.createMethods.push("_createDrag");
    var d = r.prototype;
    f.extend(d, s.prototype),
    d._touchActionValue = "pan-y";
    var m = "createTouch"in document
      , w = !1;
    d._createDrag = function() {
        this.on("activate", this.bindDrag),
        this.on("uiChange", this._uiChangeDrag),
        this.on("childUIPointerDown", this._childUIPointerDownDrag),
        this.on("deactivate", this.unbindDrag),
        m && !w && (n.addEventListener("touchmove", function() {}),
        w = !0)
    }
    ,
    d.bindDrag = function() {
        this.options.draggable && !this.isDragBound && (this.element.classList.add("is-draggable"),
        this.handles = [this.viewport],
        this.bindHandles(),
        this.isDragBound = !0)
    }
    ,
    d.unbindDrag = function() {
        this.isDragBound && (this.element.classList.remove("is-draggable"),
        this.unbindHandles(),
        delete this.isDragBound)
    }
    ,
    d._uiChangeDrag = function() {
        delete this.isFreeScrolling
    }
    ,
    d._childUIPointerDownDrag = function(x) {
        x.preventDefault(),
        this.pointerDownFocus(x)
    }
    ;
    var _ = {
        TEXTAREA: !0,
        INPUT: !0,
        OPTION: !0
    }
      , k = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0
    };
    d.pointerDown = function(x, E) {
        var j = _[x.target.nodeName] && !k[x.target.type];
        if (j)
            return this.isPointerDown = !1,
            void delete this.pointerIdentifier;
        this._dragPointerDown(x, E);
        var L = document.activeElement;
        L && L.blur && L != this.element && L != document.body && L.blur(),
        this.pointerDownFocus(x),
        this.dragX = this.x,
        this.viewport.classList.add("is-pointer-down"),
        this._bindPostStartEvents(x),
        this.pointerDownScroll = h(),
        n.addEventListener("scroll", this),
        this.dispatchEvent("pointerDown", x, [E])
    }
    ,
    d.pointerDownFocus = function(x) {
        var E = l(x);
        if (this.options.accessibility && !E) {
            var j = n.pageYOffset;
            this.element.focus(),
            n.pageYOffset != j && n.scrollTo(n.pageXOffset, j)
        }
    }
    ;
    var A = {
        INPUT: !0,
        SELECT: !0
    };
    return d.canPreventDefaultOnPointerDown = function(x) {
        var E = l(x);
        return !E
    }
    ,
    d.hasDragStarted = function(x) {
        return Math.abs(x.x) > this.options.dragThreshold
    }
    ,
    d.pointerUp = function(x, E) {
        delete this.isTouchScrolling,
        this.viewport.classList.remove("is-pointer-down"),
        this.dispatchEvent("pointerUp", x, [E]),
        this._dragPointerUp(x, E)
    }
    ,
    d.pointerDone = function() {
        n.removeEventListener("scroll", this),
        delete this.pointerDownScroll
    }
    ,
    d.dragStart = function(x, E) {
        this.dragStartPosition = this.x,
        this.startAnimation(),
        n.removeEventListener("scroll", this),
        this.dispatchEvent("dragStart", x, [E])
    }
    ,
    d.pointerMove = function(x, E) {
        var j = this._dragPointerMove(x, E);
        this.dispatchEvent("pointerMove", x, [E, j]),
        this._dragMove(x, E, j)
    }
    ,
    d.dragMove = function(x, E, j) {
        x.preventDefault(),
        this.previousDragX = this.dragX;
        var L = this.options.rightToLeft ? -1 : 1
          , C = this.dragStartPosition + j.x * L;
        if (!this.options.wrapAround && this.slides.length) {
            var O = Math.max(-this.slides[0].target, this.dragStartPosition);
            C = C > O ? .5 * (C + O) : C;
            var M = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            C = C < M ? .5 * (C + M) : C
        }
        this.dragX = C,
        this.dragMoveTime = new Date,
        this.dispatchEvent("dragMove", x, [E, j])
    }
    ,
    d.dragEnd = function(x, E) {
        this.options.freeScroll && (this.isFreeScrolling = !0);
        var j = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
            var L = this.getRestingPosition();
            this.isFreeScrolling = -L > this.slides[0].target && -L < this.getLastSlide().target
        } else
            this.options.freeScroll || j != this.selectedIndex || (j += this.dragEndBoostSelect());
        delete this.previousDragX,
        this.isDragSelect = this.options.wrapAround,
        this.select(j),
        delete this.isDragSelect,
        this.dispatchEvent("dragEnd", x, [E])
    }
    ,
    d.dragEndRestingSelect = function() {
        var x = this.getRestingPosition()
          , E = Math.abs(this.getSlideDistance(-x, this.selectedIndex))
          , j = this._getClosestResting(x, E, 1)
          , L = this._getClosestResting(x, E, -1)
          , C = j.distance < L.distance ? j.index : L.index;
        return C
    }
    ,
    d._getClosestResting = function(x, E, j) {
        for (var L = this.selectedIndex, C = 1 / 0, O = this.options.contain && !this.options.wrapAround ? function(M, U) {
            return M <= U
        }
        : function(M, U) {
            return M < U
        }
        ; O(E, C) && (L += j,
        C = E,
        E = this.getSlideDistance(-x, L),
        E !== null); )
            E = Math.abs(E);
        return {
            distance: C,
            index: L - j
        }
    }
    ,
    d.getSlideDistance = function(x, E) {
        var j = this.slides.length
          , L = this.options.wrapAround && j > 1
          , C = L ? f.modulo(E, j) : E
          , O = this.slides[C];
        if (!O)
            return null;
        var M = L ? this.slideableWidth * Math.floor(E / j) : 0;
        return x - (O.target + M)
    }
    ,
    d.dragEndBoostSelect = function() {
        if (this.previousDragX === void 0 || !this.dragMoveTime || new Date - this.dragMoveTime > 100)
            return 0;
        var x = this.getSlideDistance(-this.dragX, this.selectedIndex)
          , E = this.previousDragX - this.dragX;
        return x > 0 && E > 0 ? 1 : x < 0 && E < 0 ? -1 : 0
    }
    ,
    d.staticClick = function(x, E) {
        var j = this.getParentCell(x.target)
          , L = j && j.element
          , C = j && this.cells.indexOf(j);
        this.dispatchEvent("staticClick", x, [E, L, C])
    }
    ,
    d.onscroll = function() {
        var x = h()
          , E = this.pointerDownScroll.x - x.x
          , j = this.pointerDownScroll.y - x.y;
        (Math.abs(E) > 3 || Math.abs(j) > 3) && this._pointerDone()
    }
    ,
    r
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("tap-listener/tap-listener", ["unipointer/unipointer"], function(s) {
        return r(n, s)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("unipointer")) : n.TapListener = r(n, n.Unipointer)
}(window, function(n, r) {
    function s(l) {
        this.bindTap(l)
    }
    var f = s.prototype = Object.create(r.prototype);
    return f.bindTap = function(l) {
        l && (this.unbindTap(),
        this.tapElement = l,
        this._bindStartEvent(l, !0))
    }
    ,
    f.unbindTap = function() {
        this.tapElement && (this._bindStartEvent(this.tapElement, !0),
        delete this.tapElement)
    }
    ,
    f.pointerUp = function(l, h) {
        if (!this.isIgnoringMouseUp || l.type != "mouseup") {
            var d = r.getPointerPoint(h)
              , m = this.tapElement.getBoundingClientRect()
              , w = n.pageXOffset
              , _ = n.pageYOffset
              , k = d.x >= m.left + w && d.x <= m.right + w && d.y >= m.top + _ && d.y <= m.bottom + _;
            if (k && this.emitEvent("tap", [l, h]),
            l.type != "mouseup") {
                this.isIgnoringMouseUp = !0;
                var A = this;
                setTimeout(function() {
                    delete A.isIgnoringMouseUp
                }, 400)
            }
        }
    }
    ,
    f.destroy = function() {
        this.pointerDone(),
        this.unbindTap()
    }
    ,
    s
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function(s, f, l) {
        return r(n, s, f, l)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : r(n, n.Flickity, n.TapListener, n.fizzyUIUtils)
}(window, function(n, r, s, f) {
    "use strict";
    function l(w, _) {
        this.direction = w,
        this.parent = _,
        this._create()
    }
    function h(w) {
        return typeof w == "string" ? w : "M " + w.x0 + ",50 L " + w.x1 + "," + (w.y1 + 50) + " L " + w.x2 + "," + (w.y2 + 50) + " L " + w.x3 + ",50  L " + w.x2 + "," + (50 - w.y2) + " L " + w.x1 + "," + (50 - w.y1) + " Z"
    }
    var d = "http://www.w3.org/2000/svg";
    l.prototype = new s,
    l.prototype._create = function() {
        this.isEnabled = !0,
        this.isPrevious = this.direction == -1;
        var w = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == w;
        var _ = this.element = document.createElement("button");
        _.className = "flickity-prev-next-button",
        _.className += this.isPrevious ? " previous" : " next",
        _.setAttribute("type", "button"),
        this.disable(),
        _.setAttribute("aria-label", this.isPrevious ? "previous" : "next");
        var k = this.createSVG();
        _.appendChild(k),
        this.on("tap", this.onTap),
        this.parent.on("select", this.update.bind(this)),
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }
    ,
    l.prototype.activate = function() {
        this.bindTap(this.element),
        this.element.addEventListener("click", this),
        this.parent.element.appendChild(this.element)
    }
    ,
    l.prototype.deactivate = function() {
        this.parent.element.removeChild(this.element),
        s.prototype.destroy.call(this),
        this.element.removeEventListener("click", this)
    }
    ,
    l.prototype.createSVG = function() {
        var w = document.createElementNS(d, "svg");
        w.setAttribute("viewBox", "0 0 100 100");
        var _ = document.createElementNS(d, "path")
          , k = h(this.parent.options.arrowShape);
        return _.setAttribute("d", k),
        _.setAttribute("class", "arrow"),
        this.isLeft || _.setAttribute("transform", "translate(100, 100) rotate(180) "),
        w.appendChild(_),
        w
    }
    ,
    l.prototype.onTap = function() {
        if (this.isEnabled) {
            this.parent.uiChange();
            var w = this.isPrevious ? "previous" : "next";
            this.parent[w]()
        }
    }
    ,
    l.prototype.handleEvent = f.handleEvent,
    l.prototype.onclick = function() {
        var w = document.activeElement;
        w && w == this.element && this.onTap()
    }
    ,
    l.prototype.enable = function() {
        this.isEnabled || (this.element.disabled = !1,
        this.isEnabled = !0)
    }
    ,
    l.prototype.disable = function() {
        this.isEnabled && (this.element.disabled = !0,
        this.isEnabled = !1)
    }
    ,
    l.prototype.update = function() {
        var w = this.parent.slides;
        if (this.parent.options.wrapAround && w.length > 1)
            return void this.enable();
        var _ = w.length ? w.length - 1 : 0
          , k = this.isPrevious ? 0 : _
          , A = this.parent.selectedIndex == k ? "disable" : "enable";
        this[A]()
    }
    ,
    l.prototype.destroy = function() {
        this.deactivate()
    }
    ,
    f.extend(r.defaults, {
        prevNextButtons: !0,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    }),
    r.createMethods.push("_createPrevNextButtons");
    var m = r.prototype;
    return m._createPrevNextButtons = function() {
        this.options.prevNextButtons && (this.prevButton = new l(-1,this),
        this.nextButton = new l(1,this),
        this.on("activate", this.activatePrevNextButtons))
    }
    ,
    m.activatePrevNextButtons = function() {
        this.prevButton.activate(),
        this.nextButton.activate(),
        this.on("deactivate", this.deactivatePrevNextButtons)
    }
    ,
    m.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate(),
        this.nextButton.deactivate(),
        this.off("deactivate", this.deactivatePrevNextButtons)
    }
    ,
    r.PrevNextButton = l,
    r
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/page-dots", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function(s, f, l) {
        return r(n, s, f, l)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : r(n, n.Flickity, n.TapListener, n.fizzyUIUtils)
}(window, function(n, r, s, f) {
    function l(d) {
        this.parent = d,
        this._create()
    }
    l.prototype = new s,
    l.prototype._create = function() {
        this.holder = document.createElement("ol"),
        this.holder.className = "flickity-page-dots",
        this.dots = [],
        this.on("tap", this.onTap),
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }
    ,
    l.prototype.activate = function() {
        this.setDots(),
        this.bindTap(this.holder),
        this.parent.element.appendChild(this.holder)
    }
    ,
    l.prototype.deactivate = function() {
        this.parent.element.removeChild(this.holder),
        s.prototype.destroy.call(this)
    }
    ,
    l.prototype.setDots = function() {
        var d = this.parent.slides.length - this.dots.length;
        d > 0 ? this.addDots(d) : d < 0 && this.removeDots(-d)
    }
    ,
    l.prototype.addDots = function(d) {
        for (var m = document.createDocumentFragment(), w = []; d; ) {
            var _ = document.createElement("li");
            _.className = "dot",
            m.appendChild(_),
            w.push(_),
            d--
        }
        this.holder.appendChild(m),
        this.dots = this.dots.concat(w)
    }
    ,
    l.prototype.removeDots = function(d) {
        var m = this.dots.splice(this.dots.length - d, d);
        m.forEach(function(w) {
            this.holder.removeChild(w)
        }, this)
    }
    ,
    l.prototype.updateSelected = function() {
        this.selectedDot && (this.selectedDot.className = "dot"),
        this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex],
        this.selectedDot.className = "dot is-selected")
    }
    ,
    l.prototype.onTap = function(d) {
        var m = d.target;
        if (m.nodeName == "LI") {
            this.parent.uiChange();
            var w = this.dots.indexOf(m);
            this.parent.select(w)
        }
    }
    ,
    l.prototype.destroy = function() {
        this.deactivate()
    }
    ,
    r.PageDots = l,
    f.extend(r.defaults, {
        pageDots: !0
    }),
    r.createMethods.push("_createPageDots");
    var h = r.prototype;
    return h._createPageDots = function() {
        this.options.pageDots && (this.pageDots = new l(this),
        this.on("activate", this.activatePageDots),
        this.on("select", this.updateSelectedPageDots),
        this.on("cellChange", this.updatePageDots),
        this.on("resize", this.updatePageDots),
        this.on("deactivate", this.deactivatePageDots))
    }
    ,
    h.activatePageDots = function() {
        this.pageDots.activate()
    }
    ,
    h.updateSelectedPageDots = function() {
        this.pageDots.updateSelected()
    }
    ,
    h.updatePageDots = function() {
        this.pageDots.setDots()
    }
    ,
    h.deactivatePageDots = function() {
        this.pageDots.deactivate()
    }
    ,
    r.PageDots = l,
    r
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function(s, f, l) {
        return r(s, f, l)
    }) : typeof module == "object" && module.exports ? module.exports = r(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : r(n.EvEmitter, n.fizzyUIUtils, n.Flickity)
}(window, function(n, r, s) {
    function f(m) {
        this.parent = m,
        this.state = "stopped",
        h && (this.onVisibilityChange = function() {
            this.visibilityChange()
        }
        .bind(this),
        this.onVisibilityPlay = function() {
            this.visibilityPlay()
        }
        .bind(this))
    }
    var l, h;
    "hidden"in document ? (l = "hidden",
    h = "visibilitychange") : "webkitHidden"in document && (l = "webkitHidden",
    h = "webkitvisibilitychange"),
    f.prototype = Object.create(n.prototype),
    f.prototype.play = function() {
        if (this.state != "playing") {
            var m = document[l];
            if (h && m)
                return void document.addEventListener(h, this.onVisibilityPlay);
            this.state = "playing",
            h && document.addEventListener(h, this.onVisibilityChange),
            this.tick()
        }
    }
    ,
    f.prototype.tick = function() {
        if (this.state == "playing") {
            var m = this.parent.options.autoPlay;
            m = typeof m == "number" ? m : 3e3;
            var w = this;
            this.clear(),
            this.timeout = setTimeout(function() {
                w.parent.next(!0),
                w.tick()
            }, m)
        }
    }
    ,
    f.prototype.stop = function() {
        this.state = "stopped",
        this.clear(),
        h && document.removeEventListener(h, this.onVisibilityChange)
    }
    ,
    f.prototype.clear = function() {
        clearTimeout(this.timeout)
    }
    ,
    f.prototype.pause = function() {
        this.state == "playing" && (this.state = "paused",
        this.clear())
    }
    ,
    f.prototype.unpause = function() {
        this.state == "paused" && this.play()
    }
    ,
    f.prototype.visibilityChange = function() {
        var m = document[l];
        this[m ? "pause" : "unpause"]()
    }
    ,
    f.prototype.visibilityPlay = function() {
        this.play(),
        document.removeEventListener(h, this.onVisibilityPlay)
    }
    ,
    r.extend(s.defaults, {
        pauseAutoPlayOnHover: !0
    }),
    s.createMethods.push("_createPlayer");
    var d = s.prototype;
    return d._createPlayer = function() {
        this.player = new f(this),
        this.on("activate", this.activatePlayer),
        this.on("uiChange", this.stopPlayer),
        this.on("pointerDown", this.stopPlayer),
        this.on("deactivate", this.deactivatePlayer)
    }
    ,
    d.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(),
        this.element.addEventListener("mouseenter", this))
    }
    ,
    d.playPlayer = function() {
        this.player.play()
    }
    ,
    d.stopPlayer = function() {
        this.player.stop()
    }
    ,
    d.pausePlayer = function() {
        this.player.pause()
    }
    ,
    d.unpausePlayer = function() {
        this.player.unpause()
    }
    ,
    d.deactivatePlayer = function() {
        this.player.stop(),
        this.element.removeEventListener("mouseenter", this)
    }
    ,
    d.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(),
        this.element.addEventListener("mouseleave", this))
    }
    ,
    d.onmouseleave = function() {
        this.player.unpause(),
        this.element.removeEventListener("mouseleave", this)
    }
    ,
    s.Player = f,
    s
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function(s, f) {
        return r(n, s, f)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("./flickity"), require("fizzy-ui-utils")) : r(n, n.Flickity, n.fizzyUIUtils)
}(window, function(n, r, s) {
    function f(h) {
        var d = document.createDocumentFragment();
        return h.forEach(function(m) {
            d.appendChild(m.element)
        }),
        d
    }
    var l = r.prototype;
    return l.insert = function(h, d) {
        var m = this._makeCells(h);
        if (m && m.length) {
            var w = this.cells.length;
            d = d === void 0 ? w : d;
            var _ = f(m)
              , k = d == w;
            if (k)
                this.slider.appendChild(_);
            else {
                var A = this.cells[d].element;
                this.slider.insertBefore(_, A)
            }
            if (d === 0)
                this.cells = m.concat(this.cells);
            else if (k)
                this.cells = this.cells.concat(m);
            else {
                var x = this.cells.splice(d, w - d);
                this.cells = this.cells.concat(m).concat(x)
            }
            this._sizeCells(m);
            var E = d > this.selectedIndex ? 0 : m.length;
            this._cellAddedRemoved(d, E)
        }
    }
    ,
    l.append = function(h) {
        this.insert(h, this.cells.length)
    }
    ,
    l.prepend = function(h) {
        this.insert(h, 0)
    }
    ,
    l.remove = function(h) {
        var d, m, w = this.getCells(h), _ = 0, k = w.length;
        for (d = 0; d < k; d++) {
            m = w[d];
            var A = this.cells.indexOf(m) < this.selectedIndex;
            _ -= A ? 1 : 0
        }
        for (d = 0; d < k; d++)
            m = w[d],
            m.remove(),
            s.removeFrom(this.cells, m);
        w.length && this._cellAddedRemoved(0, _)
    }
    ,
    l._cellAddedRemoved = function(h, d) {
        d = d || 0,
        this.selectedIndex += d,
        this.selectedIndex = Math.max(0, Math.min(this.slides.length - 1, this.selectedIndex)),
        this.cellChange(h, !0),
        this.emitEvent("cellAddedRemoved", [h, d])
    }
    ,
    l.cellSizeChange = function(h) {
        var d = this.getCell(h);
        if (d) {
            d.getSize();
            var m = this.cells.indexOf(d);
            this.cellChange(m)
        }
    }
    ,
    l.cellChange = function(h, d) {
        var m = this.slideableWidth;
        if (this._positionCells(h),
        this._getWrapShiftCells(),
        this.setGallerySize(),
        this.emitEvent("cellChange", [h]),
        this.options.freeScroll) {
            var w = m - this.slideableWidth;
            this.x += w * this.cellAlign,
            this.positionSlider()
        } else
            d && this.positionSliderAtSelected(),
            this.select(this.selectedIndex)
    }
    ,
    r
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function(s, f) {
        return r(n, s, f)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("./flickity"), require("fizzy-ui-utils")) : r(n, n.Flickity, n.fizzyUIUtils)
}(window, function(n, r, s) {
    "use strict";
    function f(d) {
        if (d.nodeName == "IMG" && d.getAttribute("data-flickity-lazyload"))
            return [d];
        var m = d.querySelectorAll("img[data-flickity-lazyload]");
        return s.makeArray(m)
    }
    function l(d, m) {
        this.img = d,
        this.flickity = m,
        this.load()
    }
    r.createMethods.push("_createLazyload");
    var h = r.prototype;
    return h._createLazyload = function() {
        this.on("select", this.lazyLoad)
    }
    ,
    h.lazyLoad = function() {
        var d = this.options.lazyLoad;
        if (d) {
            var m = typeof d == "number" ? d : 0
              , w = this.getAdjacentCellElements(m)
              , _ = [];
            w.forEach(function(k) {
                var A = f(k);
                _ = _.concat(A)
            }),
            _.forEach(function(k) {
                new l(k,this)
            }, this)
        }
    }
    ,
    l.prototype.handleEvent = s.handleEvent,
    l.prototype.load = function() {
        this.img.addEventListener("load", this),
        this.img.addEventListener("error", this),
        this.img.src = this.img.getAttribute("data-flickity-lazyload"),
        this.img.removeAttribute("data-flickity-lazyload")
    }
    ,
    l.prototype.onload = function(d) {
        this.complete(d, "flickity-lazyloaded")
    }
    ,
    l.prototype.onerror = function(d) {
        this.complete(d, "flickity-lazyerror")
    }
    ,
    l.prototype.complete = function(d, m) {
        this.img.removeEventListener("load", this),
        this.img.removeEventListener("error", this);
        var w = this.flickity.getParentCell(this.img)
          , _ = w && w.element;
        this.flickity.cellSizeChange(_),
        this.img.classList.add(m),
        this.flickity.dispatchEvent("lazyLoad", d, _)
    }
    ,
    r.LazyLoader = l,
    r
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], r) : typeof module == "object" && module.exports && (module.exports = r(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
}(window, function(n) {
    return n
}),
function(n, r) {
    typeof define == "function" && define.amd ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], r) : typeof module == "object" && module.exports ? module.exports = r(require("flickity"), require("fizzy-ui-utils")) : n.Flickity = r(n.Flickity, n.fizzyUIUtils)
}(window, function(n, r) {
    function s(l, h, d) {
        return (h - l) * d + l
    }
    n.createMethods.push("_createAsNavFor");
    var f = n.prototype;
    return f._createAsNavFor = function() {
        this.on("activate", this.activateAsNavFor),
        this.on("deactivate", this.deactivateAsNavFor),
        this.on("destroy", this.destroyAsNavFor);
        var l = this.options.asNavFor;
        if (l) {
            var h = this;
            setTimeout(function() {
                h.setNavCompanion(l)
            })
        }
    }
    ,
    f.setNavCompanion = function(l) {
        l = r.getQueryElement(l);
        var h = n.data(l);
        if (h && h != this) {
            this.navCompanion = h;
            var d = this;
            this.onNavCompanionSelect = function() {
                d.navCompanionSelect()
            }
            ,
            h.on("select", this.onNavCompanionSelect),
            this.on("staticClick", this.onNavStaticClick),
            this.navCompanionSelect(!0)
        }
    }
    ,
    f.navCompanionSelect = function(l) {
        if (this.navCompanion) {
            var h = this.navCompanion.selectedCells[0]
              , d = this.navCompanion.cells.indexOf(h)
              , m = d + this.navCompanion.selectedCells.length - 1
              , w = Math.floor(s(d, m, this.navCompanion.cellAlign));
            if (this.selectCell(w, !1, l),
            this.removeNavSelectedElements(),
            !(w >= this.cells.length)) {
                var _ = this.cells.slice(d, m + 1);
                this.navSelectedElements = _.map(function(k) {
                    return k.element
                }),
                this.changeNavSelectedClass("add")
            }
        }
    }
    ,
    f.changeNavSelectedClass = function(l) {
        this.navSelectedElements.forEach(function(h) {
            h.classList[l]("is-nav-selected")
        })
    }
    ,
    f.activateAsNavFor = function() {
        this.navCompanionSelect(!0)
    }
    ,
    f.removeNavSelectedElements = function() {
        this.navSelectedElements && (this.changeNavSelectedClass("remove"),
        delete this.navSelectedElements)
    }
    ,
    f.onNavStaticClick = function(l, h, d, m) {
        typeof m == "number" && this.navCompanion.selectCell(m)
    }
    ,
    f.deactivateAsNavFor = function() {
        this.removeNavSelectedElements()
    }
    ,
    f.destroyAsNavFor = function() {
        this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect),
        this.off("staticClick", this.onNavStaticClick),
        delete this.navCompanion)
    }
    ,
    n
}),
function(n, r) {
    "use strict";
    typeof define == "function" && define.amd ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function(s) {
        return r(n, s)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("ev-emitter")) : n.imagesLoaded = r(n, n.EvEmitter)
}(typeof window != "undefined" ? window : this, function(n, r) {
    function s(k, A) {
        for (var x in A)
            k[x] = A[x];
        return k
    }
    function f(k) {
        var A = [];
        if (Array.isArray(k))
            A = k;
        else if (typeof k.length == "number")
            for (var x = 0; x < k.length; x++)
                A.push(k[x]);
        else
            A.push(k);
        return A
    }
    function l(k, A, x) {
        return this instanceof l ? (typeof k == "string" && (k = document.querySelectorAll(k)),
        this.elements = f(k),
        this.options = s({}, this.options),
        typeof A == "function" ? x = A : s(this.options, A),
        x && this.on("always", x),
        this.getImages(),
        m && (this.jqDeferred = new m.Deferred),
        void setTimeout(function() {
            this.check()
        }
        .bind(this))) : new l(k,A,x)
    }
    function h(k) {
        this.img = k
    }
    function d(k, A) {
        this.url = k,
        this.element = A,
        this.img = new Image
    }
    var m = n.jQuery
      , w = n.console;
    l.prototype = Object.create(r.prototype),
    l.prototype.options = {},
    l.prototype.getImages = function() {
        this.images = [],
        this.elements.forEach(this.addElementImages, this)
    }
    ,
    l.prototype.addElementImages = function(k) {
        k.nodeName == "IMG" && this.addImage(k),
        this.options.background === !0 && this.addElementBackgroundImages(k);
        var A = k.nodeType;
        if (A && _[A]) {
            for (var x = k.querySelectorAll("img"), E = 0; E < x.length; E++) {
                var j = x[E];
                this.addImage(j)
            }
            if (typeof this.options.background == "string") {
                var L = k.querySelectorAll(this.options.background);
                for (E = 0; E < L.length; E++) {
                    var C = L[E];
                    this.addElementBackgroundImages(C)
                }
            }
        }
    }
    ;
    var _ = {
        1: !0,
        9: !0,
        11: !0
    };
    return l.prototype.addElementBackgroundImages = function(k) {
        var A = getComputedStyle(k);
        if (A)
            for (var x = /url\((['"])?(.*?)\1\)/gi, E = x.exec(A.backgroundImage); E !== null; ) {
                var j = E && E[2];
                j && this.addBackground(j, k),
                E = x.exec(A.backgroundImage)
            }
    }
    ,
    l.prototype.addImage = function(k) {
        var A = new h(k);
        this.images.push(A)
    }
    ,
    l.prototype.addBackground = function(k, A) {
        var x = new d(k,A);
        this.images.push(x)
    }
    ,
    l.prototype.check = function() {
        function k(x, E, j) {
            setTimeout(function() {
                A.progress(x, E, j)
            })
        }
        var A = this;
        return this.progressedCount = 0,
        this.hasAnyBroken = !1,
        this.images.length ? void this.images.forEach(function(x) {
            x.once("progress", k),
            x.check()
        }) : void this.complete()
    }
    ,
    l.prototype.progress = function(k, A, x) {
        this.progressedCount++,
        this.hasAnyBroken = this.hasAnyBroken || !k.isLoaded,
        this.emitEvent("progress", [this, k, A]),
        this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, k),
        this.progressedCount == this.images.length && this.complete(),
        this.options.debug && w && w.log("progress: " + x, k, A)
    }
    ,
    l.prototype.complete = function() {
        var k = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0,
        this.emitEvent(k, [this]),
        this.emitEvent("always", [this]),
        this.jqDeferred) {
            var A = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[A](this)
        }
    }
    ,
    h.prototype = Object.create(r.prototype),
    h.prototype.check = function() {
        var k = this.getIsImageComplete();
        return k ? void this.confirm(this.img.naturalWidth !== 0, "naturalWidth") : (this.proxyImage = new Image,
        this.proxyImage.addEventListener("load", this),
        this.proxyImage.addEventListener("error", this),
        this.img.addEventListener("load", this),
        this.img.addEventListener("error", this),
        void (this.proxyImage.src = this.img.src))
    }
    ,
    h.prototype.getIsImageComplete = function() {
        return this.img.complete && this.img.naturalWidth !== void 0
    }
    ,
    h.prototype.confirm = function(k, A) {
        this.isLoaded = k,
        this.emitEvent("progress", [this, this.img, A])
    }
    ,
    h.prototype.handleEvent = function(k) {
        var A = "on" + k.type;
        this[A] && this[A](k)
    }
    ,
    h.prototype.onload = function() {
        this.confirm(!0, "onload"),
        this.unbindEvents()
    }
    ,
    h.prototype.onerror = function() {
        this.confirm(!1, "onerror"),
        this.unbindEvents()
    }
    ,
    h.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this),
        this.proxyImage.removeEventListener("error", this),
        this.img.removeEventListener("load", this),
        this.img.removeEventListener("error", this)
    }
    ,
    d.prototype = Object.create(h.prototype),
    d.prototype.check = function() {
        this.img.addEventListener("load", this),
        this.img.addEventListener("error", this),
        this.img.src = this.url;
        var k = this.getIsImageComplete();
        k && (this.confirm(this.img.naturalWidth !== 0, "naturalWidth"),
        this.unbindEvents())
    }
    ,
    d.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this),
        this.img.removeEventListener("error", this)
    }
    ,
    d.prototype.confirm = function(k, A) {
        this.isLoaded = k,
        this.emitEvent("progress", [this, this.element, A])
    }
    ,
    l.makeJQueryPlugin = function(k) {
        k = k || n.jQuery,
        k && (m = k,
        m.fn.imagesLoaded = function(A, x) {
            var E = new l(this,A,x);
            return E.jqDeferred.promise(m(this))
        }
        )
    }
    ,
    l.makeJQueryPlugin(),
    l
}),
function(n, r) {
    typeof define == "function" && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function(s, f) {
        return r(n, s, f)
    }) : typeof module == "object" && module.exports ? module.exports = r(n, require("flickity"), require("imagesloaded")) : n.Flickity = r(n, n.Flickity, n.imagesLoaded)
}(window, function(n, r, s) {
    "use strict";
    r.createMethods.push("_createImagesLoaded");
    var f = r.prototype;
    return f._createImagesLoaded = function() {
        this.on("activate", this.imagesLoaded)
    }
    ,
    f.imagesLoaded = function() {
        function l(d, m) {
            var w = h.getParentCell(m.img);
            h.cellSizeChange(w && w.element),
            h.options.freeScroll || h.positionSliderAtSelected()
        }
        if (this.options.imagesLoaded) {
            var h = this;
            s(this.slider).on("progress", l)
        }
    }
    ,
    r
});
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
(function(n, r, s) {
    function f(M, U) {
        return typeof M === U
    }
    function l() {
        var M, U, G, u, ce, ve, H;
        for (var W in k)
            if (k.hasOwnProperty(W)) {
                if (M = [],
                U = k[W],
                U.name && (M.push(U.name.toLowerCase()),
                U.options && U.options.aliases && U.options.aliases.length))
                    for (G = 0; G < U.options.aliases.length; G++)
                        M.push(U.options.aliases[G].toLowerCase());
                for (u = f(U.fn, "function") ? U.fn() : U.fn,
                ce = 0; ce < M.length; ce++)
                    ve = M[ce],
                    H = ve.split("."),
                    H.length === 1 ? x[H[0]] = u : (!x[H[0]] || x[H[0]]instanceof Boolean || (x[H[0]] = new Boolean(x[H[0]])),
                    x[H[0]][H[1]] = u),
                    _.push((u ? "" : "no-") + H.join("-"))
            }
    }
    function h(M) {
        var U = E.className
          , G = x._config.classPrefix || "";
        if (j && (U = U.baseVal),
        x._config.enableJSClass) {
            var u = new RegExp("(^|\\s)" + G + "no-js(\\s|$)");
            U = U.replace(u, "$1" + G + "js$2")
        }
        x._config.enableClasses && (U += " " + G + M.join(" " + G),
        j ? E.className.baseVal = U : E.className = U)
    }
    function d() {
        return typeof r.createElement != "function" ? r.createElement(arguments[0]) : j ? r.createElementNS.call(r, "http://www.w3.org/2000/svg", arguments[0]) : r.createElement.apply(r, arguments)
    }
    function m() {
        var M = r.body;
        return M || (M = d(j ? "svg" : "body"),
        M.fake = !0),
        M
    }
    function w(M, U, G, u) {
        var ce, ve, H, W, Z = "modernizr", Y = d("div"), X = m();
        if (parseInt(G, 10))
            for (; G--; )
                H = d("div"),
                H.id = u ? u[G] : Z + (G + 1),
                Y.appendChild(H);
        return ce = d("style"),
        ce.type = "text/css",
        ce.id = "s" + Z,
        (X.fake ? X : Y).appendChild(ce),
        X.appendChild(Y),
        ce.styleSheet ? ce.styleSheet.cssText = M : ce.appendChild(r.createTextNode(M)),
        Y.id = Z,
        X.fake && (X.style.background = "",
        X.style.overflow = "hidden",
        W = E.style.overflow,
        E.style.overflow = "hidden",
        E.appendChild(X)),
        ve = U(Y, M),
        X.fake ? (X.parentNode.removeChild(X),
        E.style.overflow = W,
        E.offsetHeight) : Y.parentNode.removeChild(Y),
        !!ve
    }
    var _ = []
      , k = []
      , A = {
        _version: "3.3.1",
        _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(M, U) {
            var G = this;
            setTimeout(function() {
                U(G[M])
            }, 0)
        },
        addTest: function(M, U, G) {
            k.push({
                name: M,
                fn: U,
                options: G
            })
        },
        addAsyncTest: function(M) {
            k.push({
                name: null,
                fn: M
            })
        }
    }
      , x = function() {};
    x.prototype = A,
    x = new x;
    var E = r.documentElement
      , j = E.nodeName.toLowerCase() === "svg"
      , L = A._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    A._prefixes = L;
    var C = A.testStyles = w;
    x.addTest("touchevents", function() {
        var M;
        if ("ontouchstart"in n || n.DocumentTouch && r instanceof DocumentTouch)
            M = !0;
        else {
            var U = ["@media (", L.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            C(U, function(G) {
                M = G.offsetTop === 9
            })
        }
        return M
    }),
    l(),
    h(_),
    delete A.addTest,
    delete A.addAsyncTest;
    for (var O = 0; O < x._q.length; O++)
        x._q[O]();
    n.Modernizr = x
}
)(window, document);
/*!
 * Headhesive.js v1.2.3 - An on-demand sticky header
 * Author: Copyright (c) Mark Goodyear <@markgdyr> <http://markgoodyear.com>
 * Url: http://markgoodyear.com/labs/headhesive
 * License: MIT
 */
(function(n, r) {
    typeof define == "function" && define.amd ? define([], function() {
        return r()
    }) : typeof exports == "object" ? module.exports = r() : n.Headhesive = r()
}
)(this, function() {
    "use strict";
    var n = function(h, d) {
        for (var m in d)
            d.hasOwnProperty(m) && (h[m] = typeof d[m] == "object" ? n(h[m], d[m]) : d[m]);
        return h
    }
      , r = function(h, d) {
        var m, w, _, k = Date.now || function() {
            return new Date().getTime()
        }
        , A = null, x = 0, E = function() {
            x = k(),
            A = null,
            _ = h.apply(m, w),
            m = w = null
        };
        return function() {
            var j = k()
              , L = d - (j - x);
            return m = this,
            w = arguments,
            0 >= L ? (clearTimeout(A),
            A = null,
            x = j,
            _ = h.apply(m, w),
            m = w = null) : A || (A = setTimeout(E, L)),
            _
        }
    }
      , s = function() {
        return window.pageYOffset !== void 0 ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
    }
      , f = function(h, d) {
        for (var m = 0, w = h.offsetHeight; h; )
            m += h.offsetTop,
            h = h.offsetParent;
        return d === "bottom" && (m += w),
        m
    }
      , l = function(h, d) {
        "querySelector"in document && "addEventListener"in window && (this.visible = !1,
        this.options = {
            offset: 300,
            offsetSide: "top",
            classes: {
                clone: "headhesive",
                stick: "headhesive--stick",
                unstick: "headhesive--unstick"
            },
            throttle: 250,
            onInit: function() {},
            onStick: function() {},
            onUnstick: function() {},
            onDestroy: function() {}
        },
        this.elem = typeof h == "string" ? document.querySelector(h) : h,
        this.options = n(this.options, d),
        this.init())
    };
    return l.prototype = {
        constructor: l,
        init: function() {
            if (this.clonedElem = this.elem.cloneNode(!0),
            this.clonedElem.className += " " + this.options.classes.clone,
            document.body.insertBefore(this.clonedElem, document.body.firstChild),
            typeof this.options.offset == "number")
                this.scrollOffset = this.options.offset;
            else {
                if (typeof this.options.offset != "string")
                    throw new Error("Invalid offset: " + this.options.offset);
                this._setScrollOffset()
            }
            this._throttleUpdate = r(this.update.bind(this), this.options.throttle),
            this._throttleScrollOffset = r(this._setScrollOffset.bind(this), this.options.throttle),
            window.addEventListener("scroll", this._throttleUpdate, !1),
            window.addEventListener("resize", this._throttleScrollOffset, !1),
            this.options.onInit.call(this)
        },
        _setScrollOffset: function() {
            typeof this.options.offset == "string" && (this.scrollOffset = f(document.querySelector(this.options.offset), this.options.offsetSide))
        },
        destroy: function() {
            document.body.removeChild(this.clonedElem),
            window.removeEventListener("scroll", this._throttleUpdate),
            window.removeEventListener("resize", this._throttleScrollOffset),
            this.options.onDestroy.call(this)
        },
        stick: function() {
            this.visible || (this.clonedElem.className = this.clonedElem.className.replace(new RegExp("(^|\\s)*" + this.options.classes.unstick + "(\\s|$)*","g"), ""),
            this.clonedElem.className += " " + this.options.classes.stick,
            this.visible = !0,
            this.options.onStick.call(this))
        },
        unstick: function() {
            this.visible && (this.clonedElem.className = this.clonedElem.className.replace(new RegExp("(^|\\s)*" + this.options.classes.stick + "(\\s|$)*","g"), ""),
            this.clonedElem.className += " " + this.options.classes.unstick,
            this.visible = !1,
            this.options.onUnstick.call(this))
        },
        update: function() {
            s() > this.scrollOffset ? this.stick() : this.unstick()
        }
    },
    l
});
/*! js-url - v2.5.0 - 2017-04-22 */
(function() {
    var n = function() {
        function r() {}
        function s(h) {
            return decodeURIComponent(h.replace(/\+/g, " "))
        }
        function f(h, d) {
            var m = h.charAt(0)
              , w = d.split(m);
            return m === h ? w : (h = parseInt(h.substring(1), 10),
            w[h < 0 ? w.length + h : h - 1])
        }
        function l(h, d) {
            for (var m = h.charAt(0), w = d.split("&"), _ = [], k = {}, A = [], x = h.substring(1), E = 0, j = w.length; E < j; E++)
                if (_ = w[E].match(/(.*?)=(.*)/),
                _ || (_ = [w[E], w[E], ""]),
                _[1].replace(/\s/g, "") !== "") {
                    if (_[2] = s(_[2] || ""),
                    x === _[1])
                        return _[2];
                    A = _[1].match(/(.*)\[([0-9]+)\]/),
                    A ? (k[A[1]] = k[A[1]] || [],
                    k[A[1]][A[2]] = _[2]) : k[_[1]] = _[2]
                }
            return m === h ? k : k[x]
        }
        return function(h, d) {
            var m, w = {};
            if (h === "tld?")
                return void 0;
            if (d = d || window.location.toString(),
            !h)
                return d;
            if (h = h.toString(),
            m = d.match(/^mailto:([^\/].+)/))
                w.protocol = "mailto",
                w.email = m[1];
            else {
                if ((m = d.match(/(.*?)\/#\!(.*)/)) && (d = m[1] + m[2]),
                (m = d.match(/(.*?)#(.*)/)) && (w.hash = m[2],
                d = m[1]),
                w.hash && h.match(/^#/))
                    return l(h, w.hash);
                if ((m = d.match(/(.*?)\?(.*)/)) && (w.query = m[2],
                d = m[1]),
                w.query && h.match(/^\?/))
                    return l(h, w.query);
                if ((m = d.match(/(.*?)\:?\/\/(.*)/)) && (w.protocol = m[1].toLowerCase(),
                d = m[2]),
                (m = d.match(/(.*?)(\/.*)/)) && (w.path = m[2],
                d = m[1]),
                w.path = (w.path || "").replace(/^([^\/])/, "/$1"),
                h.match(/^[\-0-9]+$/) && (h = h.replace(/^([^\/])/, "/$1")),
                h.match(/^\//))
                    return f(h, w.path.substring(1));
                if (m = f("/-1", w.path.substring(1)),
                m && (m = m.match(/(.*?)\.(.*)/)) && (w.file = m[0],
                w.filename = m[1],
                w.fileext = m[2]),
                (m = d.match(/(.*)\:([0-9]+)$/)) && (w.port = m[2],
                d = m[1]),
                (m = d.match(/(.*?)@(.*)/)) && (w.auth = m[1],
                d = m[2]),
                w.auth && (m = w.auth.match(/(.*)\:(.*)/),
                w.user = m ? m[1] : w.auth,
                w.pass = m ? m[2] : void 0),
                w.hostname = d.toLowerCase(),
                h.charAt(0) === ".")
                    return f(h, w.hostname);
                void 0 && (m = w.hostname.match(void 0),
                m && (w.tld = m[3],
                w.domain = m[2] ? m[2] + "." + m[3] : void 0,
                w.sub = m[1] || void 0)),
                w.port = w.port || (w.protocol === "https" ? "443" : "80"),
                w.protocol = w.protocol || (w.port === "443" ? "https" : "http")
            }
            return h in w ? w[h] : h === "{}" ? w : void 0
        }
    }();
    typeof window.define == "function" && window.define.amd ? window.define("js-url", [], function() {
        return n
    }) : (typeof window.jQuery != "undefined" && window.jQuery.extend({
        url: function(r, s) {
            return window.url(r, s)
        }
    }),
    window.url = n)
}
)();
var social = {
    twitter: function() {
        window.twttr || (window.twttr = function(n, r, s) {
            var f, l, h = n.getElementsByTagName(r)[0];
            if (!n.getElementById(s))
                return l = n.createElement(r),
                l.id = s,
                l.src = "https://platform.twitter.com/widgets.js",
                h.parentNode.insertBefore(l, h),
                window.twttr || (f = {
                    _e: [],
                    ready: function(d) {
                        f._e.push(d)
                    }
                })
        }(document, "script", "twitter-wjs")),
        window.twttr && window.twttr.ready(function(n) {
            n.widgets.load(document.getElementById("twitter-timeline"))
        })
    },
    unload: function() {}
}
  , instagram = {
    loadContent: function(n) {
        if (n.clientID) {
            var r = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + n.clientID;
            $.ajax({
                type: "GET",
                url: r,
                dataType: "jsonp",
                success: function(s) {
                    if (s.meta.code === 200 && s.data.length) {
                        var s = s.data
                          , f = 0;
                        n.el.empty();
                        for (var l = 0; l < s.length; l++) {
                            var h = s[l], d, m = h.images.low_resolution.url;
                            if (!h.images.low_resolution.url.indexOf("null") > -1 && (d = '<div class="il-photo__img instagram__bg" style="background-image:url(' + m + ')" data-filter="' + h.filter + '" /></div>',
                            d = '<a href="' + h.link + '" target="_blank" class="instagram__link">' + d + "</a>"),
                            h.videos && (d = '<div class="instagram__video instagram__bg" style="background-image:url(' + m + ')" data-filter="' + h.filter + '" /></div>',
                            d = '<a href="' + h.link + '" target="_blank" class="instagram__link instagram__video-link">' + d + "</a>"),
                            d && (d = '<div class="four columns instagram__item">' + d + "</div>"),
                            d !== "" && (n.el.append(d),
                            f++),
                            f == n.limit)
                                break
                        }
                    }
                },
                error: function() {}
            })
        }
    }
};
$(".social-feeds-wrap").each(function(n, r) {
    social.twitter();
    var s = $(this).find(".js-instafeed");
    instagram.loadContent({
        el: s,
        clientID: s.data("client-id"),
        limit: s.data("count")
    })
}),
$(document).on("shopify:block:select", function(n) {
    var r = n.detail.blockId
      , s = $("#shopify-section-" + n.detail.sectionId);
    (s.hasClass("slideshow-section") || s.hasClass("testimonial-section")) && sliderBlock.select(r, s),
    s.hasClass("page-details-section") && $(".map-section").length && mapFunction.init(),
    s.hasClass("product-template"),
    utils.resizeActionButtons()
}),
$(document).on("shopify:block:deselect", function(n) {
    var r = $("#shopify-section-" + n.detail.sectionId);
    (r.hasClass("slideshow-section") || r.hasClass("testimonial-section")) && sliderBlock.deselect(r)
}),
$(document).on("shopify:section:reorder", function(n) {
    utils.pageBannerCheck()
}),
$(document).on("shopify:section:load", function(n) {
    var r = $("#shopify-section-" + n.detail.sectionId);
    utils.pageBannerCheck(),
    r.hasClass("social-feeds-section") && $(".social-feeds-wrap").each(function(s, f) {
        social.twitter();
        var l = $(this).find(".js-instafeed");
        instagram.loadContent({
            el: l,
            clientID: l.data("client-id"),
            limit: l.data("count")
        })
    }),
    r.hasClass("faq-section") && faqAccordion.init(),
    r.hasClass("cart-section") && cart.init(),
    r.hasClass("featured-promotions-section") && featuredPromotions.init(),
    r.hasClass("slideshow-section") && slideshow.init(),
    r.hasClass("search-section") && searchAutocomplete.init(),
    r.hasClass("testimonial-section") && testimonial.init(),
    r.hasClass("image-gallery-section") && gallery.init(),
    r.hasClass("featured-products-section") && (productPage.initializeQuantityBox(),
    productPage.productSwatches(),
    productPage.init()),
    r.hasClass("map-section") && mapFunction.init(),
    r.hasClass("featured-collection-section") && featuredCollectionSection.init(),
    r.hasClass("video-section") && videoSection.init(),
    r.hasClass("recently-viewed") && recentlyViewed.init(".js-recently-viewed"),
    r.hasClass("product-template") && (productPage.init(),
    productPage.productSwatches(),
    productPage.relatedProducts(),
    recentlyViewed.init()),
    r.hasClass("article-template-section") && window.location.pathname.indexOf("/comments") != -1 && $("html,body").animate({
        scrollTop: $("#new-comment").offset().top - 140
    }, "slow"),
    r.hasClass("collection-template-section") && collectionSidebarFilter.init(),
    r.hasClass("contact-section") && mapFunction.init(),
    r.hasClass("search-template-section") && (collection.init(),
    searchAutocomplete.init(),
    collectionSidebarFilter.init()),
    r.hasClass("header-section") && (header.init(),
    header.loadMegaMenu()),
    r.hasClass("mega-menu-section") && header.loadMegaMenu(),
    r.hasClass("page-details-section") && (featuredCollectionSection.init(),
    videoSection.init()),
    r.hasClass("product-details-section") && (featuredCollectionSection.init(),
    videoSection.init(),
    mapFunction.init())
}),
$(document).on("shopify:section:unload", function(n) {
    var r = $(n.target)
      , s = $("#shopify-section-" + n.detail.sectionId);
    s.hasClass("header-section") && (header.unload(r),
    header.unloadMegaMenu()),
    s.hasClass("slideshow-section") && slideshow.unload(r),
    s.hasClass("testimonial-section") && testimonial.unload(r),
    s.hasClass("video-section") && videoSection.unload(r),
    s.hasClass("search-section") && searchAutocomplete.unload(r),
    s.hasClass("product-template") && productPage.unload(r),
    s.hasClass("mega-menu-section") && header.unloadMegaMenu(),
    s.hasClass("page-details-section") && videoSection.unload(r),
    s.hasClass("product-details-section") && videoSection.unload(r)
}),
$(document).on("shopify:section:select", function(n) {
    var r = $("#shopify-section-" + n.detail.sectionId);
    if (r.hasClass("social-feeds-section") && $(".social-feeds-wrap").each(function(l, h) {
        social.twitter()
    }),
    r.hasClass("mega-menu-section")) {
        var s = $(".header ." + n.detail.sectionId).data("dropdown");
        setTimeout(function() {
            $('a.mega-menu-parent[data-dropdown-rel="' + s + '"]').trigger("mouseenter"),
            $('a.mega-menu-parent[data-dropdown-rel="' + s + '"]').parents("header").addClass("editor-hover--true"),
            header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column")
        }, 10)
    }
    r.hasClass("featured-collection-section") && (featuredCollectionSection.unload(r),
    featuredCollectionSection.init()),
    utils.pageBannerCheck();
    var f = document.createEvent("UIEvents");
    f.initUIEvent("resize", !0, !1, window, 0),
    window.dispatchEvent(f)
}),
$(document).on("shopify:section:deselect", function(n) {
    var r = $("#shopify-section-" + n.detail.sectionId);
    if (r.hasClass("mega-menu-section")) {
        var s = $(".header ." + n.detail.sectionId).data("dropdown");
        $('a.mega-menu-parent[data-dropdown-rel="' + s + '"]').trigger("mouseout"),
        $('a.mega-menu-parent[data-dropdown-rel="' + s + '"]').parents("header").removeClass("editor-hover--true")
    }
});
function getOs()   
 {   
     var OsObject = "";   
     if(navigator.userAgent.indexOf("MSIE")>0) {   
          return "MSIE";   
     }   

     if(isFirefox=navigator.userAgent.indexOf("Firefox")>0){   
          return "Firefox";   
     }   

     if(isSafari=navigator.userAgent.indexOf("Safari")>0) {   
          return "Safari";   
     }    


     if(isCamino=navigator.userAgent.indexOf("Camino")>0){   
          return "Camino";   
     }   


     if(isMozilla=navigator.userAgent.indexOf("Gecko/")>0){   
        return "Gecko";   
     }   
  } 

//# sourceMappingURL=/s/files/1/0445/3587/3698/t/27/assets/app.js.map?v=93327708885451774131656657720
